/*
 * @Author: 赵泽文
 * @Date: 2023-01-22 16:10:40
 * @LastEditors: 王仁涛 wangrt@cnlemon.net
 * @LastEditTime: 2026-04-16 20:53:09
 * @Description: 中文语言包
 */

const transform = {
  收入科目: '收入科目',
  保存查询条件: '保存查询条件',
  裱花间: '裱花间',
  裱花间设备: '裱花间设备',
};

export const zh = {
  ...transform,
  development_env: '开发环境',
  production_env: '正式环境',
  commodity: '菜品',
  product_limit: '菜品限制',
  product_tag: '菜品标签',
  product_tag_placeholder: '请输入菜品标签，用于小程序活动分类展示',
  product: '物品',
  filter_invalid_product: '已过滤无效物品',
  add_product: '请添加物品',
  operate_will_clean_product: '变更该信息将清空已选择的物品数据，确认变更吗？',
  import_product_will_clean_current_product: '当前单据已有物品明细，导入会清空已有物品，确认导入？',

  money_symbol: '¥',
  year: '年',
  month: '月',
  day: '日',
  days: '天',
  hour: '时',
  minute: '分',
  second: '秒',

  business_day: '营业日',
  placed_order: '已下单',
  not_place_order: '未下单',
  save_success: '保存成功',
  audit_success: '审核成功',
  edit_success: '更新成功',
  confirm_audit_is: '确认通过审核？',
  del_success: '删除成功',
  pass_success: '通过成功',
  refuse_success: '拒绝成功',
  setting_success: '设置成功',
  please_check_data: '请先查询数据',
  please_select_delete_order: '请勾选要删除的单据',
  please_select_print_order: '请勾选要打印的单据',
  please_select_re_audit_order: '请勾选要反审核的单据',
  create_transfer_in_out_order: '生成调出单',
  transerOutOrder_audit_success: '批量审核提交成功，请前往任务中心查看结果',
  save_and_audit: '保存并审核',
  save_success_and_audit_is: '单据保存成功，是否立即进行审核？',
  order_del_confirm_is: '确认删除选中的单据?',
  invalid_confirm_is_with_order_no: '作废后不可恢复，确认作废单据[{{orderNo}}]？',
  whether_to_return_the_document: '是否退回单据[{{orderNo}}]？',
  cancel_relate_product_will_clean: '取消关联订单后已选择物品将会被清空，确认取消关联吗？',
  request_order_not_in_list: '该要货单不存在单据列表，请重新选择',
  audit_auto_create_transfer_in_order_confirm_is: '确认通过审核？', // 审核通过后自动生成门店调入单。
  relate_request_order_will_clean_product_confirm_is:
    '{{alertTxt}}关联订单后已选择物品将会被清空，确认{{alertTxt}}关联吗？',
  please_choose_apply_location_first: '请先选择申请门店',
  cancel_relate_transfer_in_order_product_will_clean:
    '取消关联调入单后已选择物品将会被清空，确认取消关联吗？',
  transfer_in_order_not_in_list: '该调入单不存在单据列表，请重新选择',
  relate_transfer_in_order_will_clean_product_confirm_is:
    '{{alertTxt}}关联调入单后已选择物品将会被清空，确认{{alertTxt}}关联吗？',
  inner_order_pass_confirm_is: '确认通过内部申请单？',
  inner_order_agree_confirm_is: '确认同意内部申请单？',
  inner_order_agree_confirm_is_order_no: '确认同意内部申请单[{{orderNo}}]？',
  audit_auto_create_transfer_in_out_order: '批复通过将自动生成调出单和调入单，库存发生变动。',
  agree_auto_create_transfer_in_out_order: '同意后将自动生成调出单和调入单，库存发生变动。',
  inner_order_refuse_confirm_is: '确认拒绝申请？',
  inner_order_refuse_confirm_is_order_no: '确认拒绝内部申请单[{{orderNo}}]？',
  suggest_link_apply_location: '建议跟申请门店沟通后再决定。',
  filter_product_batch_setting_confirm_is: '确认将筛选物品的属性进行批量设置?',
  batch_setting_product_not_fund: '没有找到批量设置的物品',
  cancel_relate_purchase_order_product_will_clean:
    '取消关联采购订单后已选择物品将会被清空，确认取消关联吗？',
  purchase_order_not_in_list: '该采购订单不存在单据列表，请重新选择',
  relate_purchase_order_will_clean_product_confirm_is:
    '{{alertTxt}}关联采购订单后已选择物品将会被清空，确认{{alertTxt}}关联吗？',
  cancel_relate_purchase_receive_order_product_will_clean:
    '取消关联采购收货单后已选择物品将会被清空，确认取消关联吗？',
  purchase_receive_order_not_in_list: '该采购收货单不存在单据列表，请重新选择',
  relate_purchase_receive_order_will_clean_product_confirm_is:
    '{{alertTxt}}关联采购收货单后已选择物品将会被清空，确认{{alertTxt}}关联吗？',
  del_choose_supplier_confirm_is: '供应商删除后不可恢复，是否确认删除？',
  del_reason_confirm_is: '确认删除该原因？',
  change_query_will_clean_product: '修改过滤条件将清空物品明细，确认修改?',
  check_order_snapshot_confirm_is:
    '使用库存快照，系统将记录当前库存量，盘点后的数据会和库存快照比较。快照后无法继续添加物品，确定使用库存快照？',
  current_page_un_save_leave_confirm_is: '当前页面尚未保存内容将会丢失，确认离开吗？',
  update_location_success: '切换门店成功',
  have_common_product_can_not_change_gift: '已存在相同物品，禁止再次更改赠送标记',
  store_account_balance_insufficient:
    '门店记账户余额不足，无法审核成功。门店可前往APP进行记账户充值。',

  cancel: '取消',
  confirm: '确定',
  save: '保存',
  audit: '审核',
  re_audit: '反审核',
  re_audit_success: '反审核成功',
  modify: '修改',
  edit: '编辑',
  copy: '复制',
  print: '打印',
  batch_print: '批量打印',
  partake: '分享',
  create: '创建',
  create_success: '创建成功',
  read: '查看',
  del: '删除',
  delete_fail: '删除失败',
  pass: '通过',
  refuse: '拒绝',
  refuse_person: '拒绝人',
  refuse_time: '拒绝时间',
  agree: '同意',
  agree_time: '同意时间',
  agree_person: '同意人',
  export_excel: '导出',
  invalid: '作废',
  return: '退回',
  return_success: '退回成功',
  add_product_btn: '添加物品',
  batch_setting: '批量设置',
  import_file: '导入',
  setting: '设置',
  close: '关闭',
  audit_pass: '审核通过',
  upload: '上传',
  new_add: '新增',
  query: '查询',
  return_btn: '返回',
  business_date: '业务日期',
  variance_rate: '差异率',

  stock_item_search: '物品库存查询',
  export_stock_item_search: '导出物品库存查询',
  inventory_list: '物品库存表',
  inventory_dimension: '（到{{dimension}}维度）',
  greater_than: '大于',
  less_than: '小于',
  equal_than: '等于',
  not_equal_than: '不等于',
  please_select_comparison: '请选择对比方式',
  detail: '明细',
  single: '单品',
  cross_product: '跨菜品',
  cross_product_tip:
    '若选择单品，则只有购买M件单个规格的菜品时，才享受折扣，点击跨菜品，购买所有参与活动菜品总数达到M件时，就享受折扣',
  collect: '汇总',
  select: '选择',
  filter: '过滤',
  display: '显示',
  please_select: '请选择',
  negative_stock: '负库存',
  zero_stock: '零库存',
  negative_amount: '负金额',
  early_warning_state: '预警状态',
  above_maximum_inventory: '高于最高库存',
  below_minimum_inventory: '低于最低库存',
  latest_delivery_date: '最近收货日期',
  time_frame: '时段',
  next_step: '下一步',
  previous_step: '上一步',
  payment_status: '付款状态',
  unpaid: '未付款',
  paid: '已付款',
  warehouse_allocation: '分仓',

  exp_collect: '效期汇总',
  exp_board: '效期看板',
  storage_condition: '储存条件',
  exp_product: '效期菜品',
  create_exp_product: '创建效期菜品',
  edit_exp_product: '编辑效期菜品',
  exp_product_import: '效期菜品导入',
  exp_product_import_template: '效期菜品导入模版',
  condition: '条件',

  distribution_settlement: '配送结算',
  create_distribution_settlement: '创建配送结算',
  edit_distribution_settlement: '编辑配送结算',
  read_distribution_settlement: '查看配送结算',
  settlement_date: '结算日期',
  settlement_money: '结算金额',
  settlemented_money: '已结算金额',
  unsettled_money: '未结算金额',
  discount_amount: '折扣金额',
  discounted_amount: '已折扣金额',
  receivables_amount: '应收金额',
  collected_amount: '已收金额',
  outstanding_amount: '未收金额',
  payable_amount: '应付金额',
  paid_amount: '已付金额',
  unpaid_amount: '未付金额',
  settlement_amount_for_this_instance: '本次结算金额',
  payment_date: '付款日期',
  payment_type: '付款方式',
  agreed_payment_date: '约定付款日期',
  re_audit_confirm_is: '是否反审核选中的单据',
  delete_distribution_settlement_document: '删除配送结算单[{{orderNo}}]',
  create_distribution_settlement_document: '创建配送结算单[{{orderNo}}]',
  re_audit_distribution_settlement_document: '反审核配送结算单[{{orderNo}}]',
  location_dealings: '门店往来账款',
  supplier_dealings: '供应商往来账款',
  prepayment_amount: '预付金额',
  cost_project: '费用项目',
  save_cost_project: '新增费用项目',
  edit_cost_project: '编辑费用项目',
  receivable: '应收',
  meet: '应付',
  income_and_expenditure_direction: '收支方向',
  cost_project_code: '费用项目代码',
  cost_project_name: '费用项目名称',
  application_scope: '应用范围',
  location_prepayment: '门店预收',
  store_expense_sheet: '门店费用单',
  supplier_expense_sheet: '供应商费用单',
  add_location_prepayment: '新增门店预收',
  edit_location_prepayment: '编辑门店预收',
  read_location_prepayment: '查看门店预收',
  supplier_prepayment: '供应商预付',
  add_supplier_prepayment: '新增供应商预付',
  edit_supplier_prepayment: '编辑供应商预付',
  read_supplier_prepayment: '查看供应商预付',
  supplier_settlement: '供应商结算',
  create_supplier_settlement: '创建供应商结算',
  edit_supplier_settlement: '编辑供应商结算',
  read_supplier_settlement: '查看供应商结算',

  request_order: '要货单',
  request_order_same_tip: '要货门店不允许跟发货门店相同',
  replenishment_guide: '补货向导',
  export_replenishment_guide: '导出补货向导',
  generate_requisitions_by_store: '按门店生成要货单',
  generate_requisitions_by_class: '按物品顶级分类生成要货单',
  order_the_items: '订购物品',
  choose_to_order_the_items: '选择订购物品',
  order_all_items_in_stock: '订购当前门店库存中所有物品',
  order_items_when_inventory_levels: '订购库存量达到补货订购点的物品',
  order_items_from_a_specified_category: '订购指定物品分类',
  replenish_items_based_on_the_request_order_template: '按要货模板补货',
  order_items_based_on_the_item_query_template: '按物品查询模板补货',
  order_items_based_day_1: '订购',
  order_items_based_day_2: '天未补货，且库存为0的物品',
  out_of_stock_item: '缺货物品',
  actively_selling_items: '动销物品',
  actively_selling_items_tip: '动销物品：指要货门店在时间范围内存在进出库明细的物品',
  order_items_that_have_stock_at_the_distribution_store: '订购发货门店有库存的物品',
  pending_order_qty: '在订量',
  order_quantity: '订购数量',
  select_order_quantity: '选择订购数量',
  order_quantity_is_zero: '订购数量为零',
  based_on_the_stock_upper_limit: '根据库存上限',
  outbound_quantity_within_a_time_range: '时间范围出库量',
  replenishment_guide_success_tip: '共生成 {{order_qty}} 张要货单，包含 {{item_qty}} 样物品！',
  replenishment_guide_success_check_tip: '可在配送模块-要货单查看订单详情，是否前往查看？',
  replenishment_condition_change_tip: '补货条件发生变更后将清空已选择物品列表，是否继续？',
  transfer_in_order: '调入单',
  transfer_out_order: '调出单',
  export_transfer_out_order_storehouse: '调出汇总（按仓库）',
  confirm_order_audit_is: '确定需要审核所选单据？',
  inner_apply_order: '内部申请单',
  request_order_statistics: '要货统计',
  product_delivery_prop: '物品配送属性',
  product_purchase_prop: '物品采购属性',
  delivery_unit: '配送单位',
  location_delivery_price: '门店配送价',
  distribution_gross_profit: '配送毛利分析表',
  location_gross_profit: '门店毛利分析表',
  product_gross_profit: '菜品毛利分析表',
  location_gross_profit_diff: '门店菜品毛利对比表',
  pre_discount_sales_revenue: '折前销售额',
  discounted_sales_revenue: '折后销售额',
  financial_info: '财务信息',
  financial_entity: '财务主体',
  go_to_add: '去新增',
  purchase_order: '采购订单',
  go_to_purchase_order_page: '前往采购订单页面',
  generate_purchase_order: '生成采购单',
  generate_central_purchase_order: '生成中心采购订单',
  generate_central_purchase_orders_by_out_stock_volume: '按缺货量生成中心采购订单',
  generate_direct_delivery_order: '生成直配单',
  purchase_receive: '采购收货',
  purchase_receive_order: '采购收货单',
  settlement_status: '结算状态',
  unsettled: '未结算',
  partial_settlement: '部分结算',
  already_settled: '已结算',
  return_order: '退货单',
  supplier: '供应商',
  please_supplier_priority: '请选择供应商优先级',
  by_main_supplier: '按主供应商',
  by_nearest_receiving_supplier: '按最近收货供应商',
  do_not_display_items: '不显示物品',
  is_it_the_main_supplier: '是否主供应商',
  by_purchasing_unit: '按采购单位',
  new_supply_relationship_added: '新增供货关系',
  copy_supply_relationship_error: '目标门店与参考门店不能相同',
  recent_procurement_records: '最近采购记录',
  set_as_the_main_upplier: '设为主供应商',
  are_you_sure_set_as_the_main_upplier: '确定变更所选中的数据的主供应商吗？',
  copy_supply_relationship: '供货关系复制',
  batch_modify_suppliers: '批量修改供应商',
  agreed_price: '约定价格',
  please_input_agreed_price: '请输入约定价格',
  priority: '优先级',
  minimum_order_quantity: '起订量',
  please_input_minimum_order_quantity: '请输入起订量',
  highest_price: '最高价',
  lowest_price: '最低价',
  latest_purchase_date: '最近进货日期',
  freight_amount: '运费金额',
  please_input_freight_amount: '请输入运费金额',
  input_tax_rate: '进项税率',
  please_input_input_tax_rate: '请输入进项税率',
  procurement_cycle: '采购周期（天）',
  procurement_conversion_rate: '采购换算率',
  do_not_display_discontinued_items: '不显示停购物品',
  do_not_display_dormant_items: '不显示休眠物品',
  please_select_do_not_display_items: '请选择不显示物品',
  please_select_supplier_or_item_archives: '多店查询请选择供应商或物品档案',
  import_supply_relationship: '导入物品供货关系',
  batch_import_supply_relationship: '批量导入物品供货关系',
  supply_relationship_import_tmpl: '物品供货关系导入模板',
  export_supply_relationship_of_goods: '导出物品供货关系',
  import_supply_relationship_tips:
    '每次导入物品限制数量应小于5000条，文件小于3M仅支持：.XLS，.XLSX格式的文件',
  please_select_supply_relationship: '请选择要操作的供货关系数据',
  supply_relationship_to_be_deleted: '删除物品供货关系[{{id}}]',
  delete_the_supply_relationship: '确定要删除选中物品的供货关系吗？',
  supply_relationship_of_goods: '物品供货关系',
  target_store: '目标门店',
  scope_of_items: '物品范围',
  please_choose_target_store: '请选择目标门店',
  please_select_a_specified_category: '请选择指定分类',
  adjustment_order: '库存调整单',
  adjustment_reason: '调整原因',
  check_order: '库存盘点单',
  finished_produce_rate_report: '出品率报表',
  produce_plan_order: '生产计划单',
  generate_plan_order: '生成计划单',
  generate_produce_plan_order: '生成生产计划单',
  generate_produce_plan_order_by_process: '生产计划单（按加工品汇总）',
  generate_produce_plan_order_by_request: '生产计划单（按要货单分单）',
  produce_material_order: '生产领料单',
  confirm_save_order: '您确定要保存此{{name}}吗？',
  confirm_audit: '您确定要审核通过此{{name}}吗？',
  confirm_audit_order: '您确定要保存并审核通过此{{name}}吗？',
  produce_material_order_audit_success: '领料审核成功，可至【库存管理-库存调整】中查看',
  audit_success_warehousing: '生成{{num}}张生产领料入库单',
  audit_success_outbound: '生成{{num}}张生产领料出库单',
  material_date: '领料日期',
  produce_storage_order: '生产入库单',
  produce_fast_order: '快速生产单',
  ship_net_setting: '配送网络设置',
  chain_stock_setting: '进销存设置',
  number_precision: '数字精度',
  modify_precision_tip: '修改精度小数位数不能少于当前小数位数，考虑清楚后再进行调整',
  product_price_precision: '菜品价格精度',
  two_decimal: '两位小数',
  three_decimal: '三位小数',
  four_decimal: '四位小数',
  order_goods_setting: '订货设置',
  call_single_parameter: '调出调入单参数',
  examine_direct_generation: '中心调出单审核直接生成门店调入单',
  exceed: '超过',
  automatically_call_hours: '小时后自动调入',
  auto_transfer_in_tip: '提示：空表示不会自动调入',
  price_precision_cannot_subtract: '价格精度不允许变小',
  edit_chain_stock_settings: '编辑进销存设置',
  location_request_order_setting: '门店补货参数',
  intelligent_replenishment: '智能补货',
  location_request_no_display_central_inventory: '门店要货不显示配送中心库存',
  location_request_no_exceed_distribution_center_inventory: '门店要货不可以超过配送中心库存量',

  please_select_material: '请选择原料',
  raw_material_consumption_analysis_table_for_processed_products: '加工品原料耗用分析表',
  read_raw_material_consumption_analysis_table_for_processed_products: '查看加工品原料耗用分析表',
  export_raw_material_consumption_analysis_table_for_processed_products: '导出加工品原料耗用分析表',
  expected_yield_report: '应产率报表',
  read_expected_yield_report: '查看应产率报表',
  export_expected_yield_report: '导出应产率报表',
  expected_yield: '应产量',
  actual_yield: '实际产量',

  tag: '标签',
  vendor: '品牌',
  search_vendor: '搜索品牌',
  product_service: '物品系列',
  copy_request_order_with_order_no: '复制要货单[{{orderNo}}]',
  copy_request_order: '复制要货单',
  save_request_order_with_order_no: '创建要货单[{{orderNo}}]',
  del_request_order_with_order_no: '删除要货单[{{orderNo}}]',
  invalid_request_order_with_order_no: '作废要货单[{{orderNo}}]',
  audit_request_order_with_order_no: '审核要货单[{{orderNo}}]',
  save_request_order: '新增要货单',
  edit_request_order: '编辑要货单',
  print_request_order: '打印要货单',
  read_request_order: '查看要货单',
  request_order_import: '要货单导入',
  request_order_import_tmpl: '要货单导入模板',
  order_no: '单据号',
  order_type: '单据类型',
  memo: '备注说明',
  tip: '提示',
  order_detail_export: '明细导出',
  export_order_detail_by_storehouse: '导出明细汇总（按仓库）',
  summary_export: '要货汇总',
  order_summary_export: '导出要货汇总',
  order_summary_export_by_sku: '按 SKU 导出',
  order_summary_export_by_type: '按分类导出',
  by_type: '按分类',
  export_request_order_detail_with_order_no: '导出要货单[{{orderNo}}]明细',
  order_detail_import: '明细导入',
  import_request_order_detail_with_order_no: '导入要货单[{{orderNo}}]明细',
  export_task_create_success: '正在导出，请前往任务中心查看',
  import_task_create_success: '正在导入，请前往任务中心查看',
  uploading_wait: '上传中，请稍等',
  upload_failed: '上传失败，请重新上传',
  upload_success: '上传成功',
  print_task_create_success: '正在打印，请前往任务中心查看',
  print_failed: '打印失败',
  current_location_no_type: '当前门店未设置门店类型',
  head_quarters_have_no_transfer: '暂未设置可配送门店',
  location_have_no_transfer: '暂未设置可配送门店，请联系总部进行配置',
  request_location: '要货门店',
  request_location_num: '要货门店数',
  choose_request_location: '请选择要货门店',
  choose_request_location_first: '请先选择要货门店',
  head_quarters_have_no_distribution_center: '暂未设置配送中心',
  location_have_no_distribution_center: '暂未设置配送中心，请联系总部进行配置',
  delivery_location: '发货门店',
  receive_location: '收货门店',
  please_choose_receive_location: '请选择收货门店',
  please_choose_receive_location_first: '请选择收货门店',
  choose_delivery_location: '请选择发货门店',
  choose_delivery_location_first: '请先选择发货门店',
  delivery_location_can_not_be_null: '发货门店不可为空',
  please_choose_location: '请选择门店',
  choose_location: '选择门店',
  delivery_date: '交货日期',
  receive_date: '收货日期',
  send_date: '发货日期',
  expected_delivery_time: '期望到货时间',
  salesman: '业务员',
  choose_salesman: '选择业务员',
  search_product_tag: '搜索标签',
  input_memo_and_max_length_100: '请输入，不超过100字',
  un_choose_list: '未选中列表项',
  export_request_order: '导出要货单',
  input_order_no: '请输入单据号',
  audit_sate: '审核状态',
  date_type: '日期类型',
  filer_date: '筛选日期',
  all: '全部',
  state_init: '待审核',
  state_audit: '已审核',
  state_cancel: '已作废',
  state_pass: '已通过',
  state_refuse: '已拒绝',
  state_agree: '已同意',
  row_num: '序号',
  order_created_at: '制单时间',
  order_creator: '制单人',
  order_audited_at: '审核时间',
  order_auditor: '审核人',
  order_delivery_at: '交货时间',
  settlement_time: '结算时间',
  payment_method: '收款方式',
  order_money: '单据金额',
  operate: '操作',
  operate_tip: '操作提示',
  invalid_success: '作废成功',
  agree_success: '同意成功',
  read_transfer_in_order: '查看调入单',
  save_transfer_in_order: '新增调入单',
  edit_transfer_in_order: '编辑调入单',
  copy_transfer_in_order: '复制调入单',
  copy_transfer_in_order_with_order_no: '复制调入单[{{orderNo}}]',
  create_transfer_in_order_with_order_no: '创建调入单[{{orderNo}}]',
  del_transfer_in_order_with_order_no: '删除调入单[{{orderNo}}]',
  audit_transfer_in_order: '审核调入单',
  audit_transfer_in_order_with_order_no: '审核调入单[{{orderNo}}]',
  print_transfer_in_order: '打印调入单',
  export_transfer_in_order: '导出调入单',
  export_transfer_in_order_detail_with_order_no: '导出调入单[{{orderNo}}]明细',
  invalid_transfer_in_order_with_order_no: '作废调入单[{{orderNo}}]',
  read_transfer_out_order: '查看调出单',
  save_transfer_out_order: '新增调出单',
  edit_transfer_out_order: '编辑调出单',
  copy_transfer_out_order: '复制调出单',
  audit_transfer_out_order: '审核调出单',
  export_transfer_out_order: '导出调出单',
  print_transfer_out_order: '打印调出单',
  transfer_out_guide: '调出向导',
  read_transfer_out_guide: '查看调出向导',
  save_transfer_out_guide: '保存调出向导',
  transfer_out_guide_by_storehouse_ruler: '调出向导（按仓库物品规则）',
  export_transfer_out_guide: '导出调出向导',
  audit_transfer_out_order_with_order_no: '审核调出单[{{orderNo}}]',
  audit_auto_create_transfer_in_order: '审核通过后自动生成门店调入单。',
  copy_transfer_out_order_with_order_no: '复制调出单[{{orderNo}}]',
  create_transfer_out_order_with_order_no: '创建调出单[{{orderNo}}]',
  export_transfer_out_order_detail_with_order_no: '导出调出单[{{orderNo}}]明细',
  relate_request_order: '关联要货单',
  please_choose_relate_request_order: '选择关联要货单',
  del_transfer_out_order_with_order_no: '删除调出单[{{orderNo}}]',
  invalid_transfer_out_order_with_order_no: '作废调出单[{{orderNo}}]',
  copy_inner_apply_order_with_order_no: '复制内部申请单[{{orderNo}}]',
  create_inner_apply_order_with_order_no: '创建内部申请单[{{orderNo}}]',
  pass_inner_apply_order_with_order_no: '通过内部申请单[{{orderNo}}]',
  refuse_inner_apply_order_with_order_no: '拒绝内部申请单[{{orderNo}}]',
  print_inner_apply_order: '打印内部申请单',
  export_inner_apply_order_detail_with_order_no: '导出内部申请单[{{orderNo}}]明细',
  save_inner_apply_order: '新增内部申请单',
  reply_inner_apply_order: '批复内部申请单',
  edit_inner_apply_order: '编辑内部申请单',
  audit_inner_apply_order: '审核内部申请单',
  copy_inner_apply_order: '复制内部申请单',
  read_inner_apply_order: '查看内部申请单',
  deadline: '截止日期',
  relate_transfer_in_order: '关联调入单',
  choose_relate_transfer_in_order: '选择关联调入单',
  please_choose_apply_location: '请选择申请门店',
  apply_location: '申请门店',
  read_request_order_statistics: '查看要货统计',
  read_request_distribution_center: '查看配送中心',
  print_request_distribution_center: '打印配送中心',
  export_request_order_statistics: '导出要货统计',
  export_request_distribution_center: '导出配送中心',
  product_title: '物品名称',
  variant: '规格',
  product_sku: '物品编码',
  product_type: '物品类别',
  qty: '数量',
  number_of_items: '件数',
  use_unit: '常用单位',
  use_unit_qty: '常用单位数量',
  base_unit: '基本单位',
  base_qty: '基本数量',
  money: '金额',
  current_location_stock: '当前门店库存',
  distribution_center_stock: '配送中心库存',
  validate_request_num_tip: '要货数量不能大于实际中心库存量 {{num}}',
  validate_request_num_tip1: '要货数量不能大于实际中心库存量',
  choose_product_type: '选择物品类别',
  product_info: '物品信息',
  choose_product_info: '选择物品信息',
  choose_product: '选择物品',
  please_choose_product: '请选择物品',
  please_choose_out_order_product: '请选择需要生产调出单的物品',
  keyword: '关键字',
  search_product_title_barcode_sku: '搜索物品名称/条码/编码',
  product_summary: '物品汇总',
  total: '总计',
  order_count: '单据总数',
  goods_count: '货品数',
  location_product_summary: '门店-物品汇总',
  day_max_order_qty: '每日订购上限',
  please_input_day_max_order_qty: '请输入每日订购上限',
  min_order_qty: '订购下限',
  please_input_min_order_qty: '请输入订购下限',
  min_order_qty_must_lt_day_max_order_qty: '订购下限需要小于每日订购上限',
  order_multiple: '订购基数',
  please_input_order_multiple: '请输入订购基数',
  inventory_policy: '缺货后继续要货',
  please_choose_inventory_policy: '请选择缺货后继续要货',
  stock_out_distribution: '缺货分配',
  all_product: '全部物品',
  point_product: '指定物品',
  specify_classification: '指定分类',
  only_search_for_items: '仅查询物品',
  query_scope: '查询范围',
  filter_items_fully_shipped: '过滤已全部配送的物品',
  query_only_items_not_generated_out: '只查询未生成调出单的物品',
  query_only_items_not_generated_out_order: '只查询未生成调出单的单据',
  export_purchase_order_summary: '导出要货汇总',
  export_by_category: '按分类导出',
  export_according_to_warehouse_item_rules: '按仓库物品规则导出',
  by_warehouse_item_rules: '按仓库物品规则',
  query_all_desired_products: '查询全部要货物品',
  please_choose_copy_prop: '请选择复制属性',
  choose_location_can_not_equal_reference_location: '选择门店不可与参考门店相同',
  copy_product_delivery_prop: '复制物品配送属性',
  product_delivery_prop_copy: '物品配送属性复制',
  product_delivery_prop_copy_desc:
    '配送属性复制功能主要用于将参考门店物品的配送属性直接复制到其他门店使用。',
  please_choose_reference_location: '请选择参考门店',
  reference_location: '参考门店',
  read_product_delivery_prop: '查看物品配送属性',
  import_product_delivery_prop: '导入物品配送属性',
  export_product_delivery_prop: '导出物品配送属性',
  setting_product_delivery_prop: '设置物品配送属性',
  batch_delete_product_delivery_prop: '批量删除物品配送属性',
  edit_product_delivery_prop_with_location_name: '编辑物品配送属性{{locationName}}',
  copy_product_purchase_prop: '复制物品采购属性',
  product_purchase_prop_copy: '物品采购属性复制',
  product_purchase_prop_copy_desc:
    '采购属性复制功能主要用于将参考门店物品的采购属性直接复制到其他门店使用。',
  read_product_purchase_prop: '查看物品采购属性',
  import_product_purchase_prop: '导入物品采购属性',
  export_product_purchase_prop: '导出物品采购属性',
  setting_product_purchase_prop: '设置物品采购属性',
  edit_product_purchase_prop_with_location_name: '编辑物品采购属性{{locationName}}',
  location_name: '门店名称',
  location_total: '门店总数',
  day_max_order_qty_must_gt_min_order_qty: '每日订购上限必须大于等于订购下限',
  day_max_order_qty_must_ge_order_multiple: '每日订购上限必须大于等于订购基数，请扩大每日订购上限',
  day_max_order_qty_rule_desc: '每日订购上限：每天订购数量总和的最大值',
  min_order_qty_rule_desc: '订购下限：每次要货的最少数量',
  order_multiple_rule_desc: '订购基数：要货时必须按照订购基数的整数倍要货',
  inventory_policy_rule_desc:
    '缺货后继续要货：勾选该选项，该门店指定的配送中心缺货时，允许继续要货；取消勾选，该门店指定的配送中心缺货时，不允许继续要货',
  choose_type: '选择类别',
  type: '类别',
  search_product_lt_value: '搜索小于等于该值的物品',
  search_product_gt_value: '搜索大于等于该值的物品',
  product_delivery_prop_import: '物品配送属性导入',
  product_purchase_prop_import: '物品采购属性导入',
  product_delivery_prop_import_tmpl: '物品配送属性导入模板',
  product_purchase_prop_import_tmpl: '物品采购属性导入模板',
  if_excel_empty_not_change: '如果导入的Excel表格数据为空，则不会更改原有的数据。',
  please_input_location_delivery_price: '请输入门店配送价',
  please_add_price_rate: '请输入加价的比例',
  please_add_price_value: '请输入加价的金额',
  setting_location_delivery_price: '设置门店配送价',
  max_can_not_gt: '最大不可超过',
  cost_price: '成本价',
  available_inventory: '可售库存',
  inventory_price: '库存单价',
  inventory_average_price: '库存均价',
  inventory_average_price_tip: '库存数量为0时取档案参考价',
  reference_cost_price: '参考成本价',
  setting_delivery_price: '设置配送价',
  rule: '规则',
  adjust: '调整',
  add_price_rate: '加价的比例',
  add_price_value: '加价的金额',
  copy_location_delivery_price: '复制门店配送价',
  delivery_price_copy: '配送价复制',
  delivery_price_copy_desc: '配送价复制功能主要用于将参考门店物品的配送价直接复制到其他门店使用。',
  read_distribution_gross_profit: '查看配送毛利',
  export_distribution_gross_profit: '导出配送毛利',
  transfer_out_money: '调出金额',
  transfer_out_cost: '调出成本',
  transfer_in_money: '调入金额',
  transfer_in_cost: '调入成本',
  distribution_cost: '配送成本',
  gross_profit: '毛利',
  gift_cost: '赠送成本',
  gift_qty: '赠送数量',
  delivery_money: '配送金额',
  delivery_money_total: '配送金额合计',
  delivered_qty: '已配送数量',
  undelivered_order_qty: '要货未配送数量',
  delivery_qty: '配送数量',
  product_barcode: '物品条码',
  transfer_out_qty: '调出数量',
  transfer_in_qty: '调入数量',
  gross_profit_rate: '毛利率',
  gross_profit_quantity: '毛料量',
  location_summary: '门店汇总',
  read_purchase_order: '查看采购订单',
  save_purchase_order: '新增采购订单',
  edit_purchase_order: '编辑采购订单',
  audit_purchase_order: '审核采购订单',
  export_purchase_order: '导出采购订单',
  print_purchase_order: '打印采购订单',
  copy_purchase_order: '复制采购订单',
  invalid_purchase_order_with_order_no: '作废采购订单[{{orderNo}}]',
  del_purchase_order_with_order_no: '删除采购订单[{{orderNo}}]',
  audit_purchase_order_with_order_no: '审核采购订单[{{orderNo}}]',
  copy_purchase_order_with_order_no: '复制采购订单[{{orderNo}}]',
  create_purchase_order_with_order_no: '创建采购订单[{{orderNo}}]',
  abandon_purchase_order_with_order_no: '中止采购订单[{{orderNo}}]',
  read_purchase_receive_order: '查看采购收货单',
  save_purchase_receive_order: '新增采购收货单',
  edit_purchase_receive_order: '编辑采购收货单',
  audit_purchase_receive_order: '审核采购收货单',
  print_purchase_receive_order: '打印采购收货单',
  export_purchase_receive_order: '导出采购收货单',
  copy_purchase_receive_order: '复制采购收货单',
  copy_purchase_receive_order_with_order_no: '复制采购收货单[{{orderNo}}]',
  create_purchase_receive_order_with_order_no: '创建采购收货单[{{orderNo}}]',
  del_purchase_receive_order_with_order_no: '删除采购收货单[{{orderNo}}]',
  invalid_purchase_receive_order_with_order_no: '作废采购收货单[{{orderNo}}]',
  audit_purchase_receive_order_with_order_no: '审核采购收货单[{{orderNo}}]',
  export_purchase_receive_order_detail_with_order_no: '导出采购收货单[{{orderNo}}]明细',
  read_return_order: '查看退货单',
  save_return_order: '新增退货单',
  edit_return_order: '编辑退货单',
  audit_return_order: '审核退货单',
  export_return_order: '导出退货单',
  copy_return_order: '复制退货单',
  print_return_order: '打印退货单',
  copy_return_order_with_order_no: '复制退货单[{{orderNo}}]',
  create_return_order_with_order_no: '创建退货单[{{orderNo}}]',
  del_return_order_with_order_no: '删除退货单[{{orderNo}}]',
  invalid_return_order_with_order_no: '作废退货单[{{orderNo}}]',
  audit_return_order_with_order_no: '审核退货单[{{orderNo}}]',
  export_return_order_detail_with_order_no: '导出退货单[{{orderNo}}]明细',
  audit_confirm_is: '审核确认',
  purchase_location: '采购门店',
  save_supplier: '新增供应商',
  edit_supplier: '编辑供应商',
  edit_supplier_with_name: '编辑供应商[{{supplierName}}]',
  create_supplier_with_name: '创建供应商[{{supplierName}}]',
  edit_supplier_with_role_name: '编辑供应商用户角色[{{supplierRoleName}}]',
  create_supplier_with_role_name: '创建供应商用户角色[{{supplierRoleName}}]',
  purchase_date: '采购日期',
  please_choose_purchase_location: '请选择采购门店',
  export_purchase_order_detail_with_order_no: '导出采购订单[{{orderNo}}]明细',
  please_choose_supplier: '请选择供应商',
  choose_supplier: '选择供应商',
  have_no_supplier: '暂未设置供应商',
  bulk_set_suppliers: '批量设置供应商',
  relate_purchase_order: '关联采购订单',
  choose_relate_purchase_order: '选择关联采购订单',
  return_location: '退货门店',
  return_date: '退货日期',
  please_choose_return_location: '请选择退货门店',
  relate_receive_order: '关联收货单',
  choose_relate_receive_order: '选择关联收货单',
  relate_purchase_receive_order: '关联采购收货单',
  base_info: '基础信息',
  wechat_order_accept: '微信接单',
  supplier_code: '供应商代码',
  please_input_supplier_code: '请输入供应商代码',
  input_char_length_must_le_20: '不超过20个字符',
  please_input_number_or_str: '请输入数字或者字母',
  input_number_or_str_length_must_le_20: '不超过20个字母或数字',
  supplier_name: '供应商名称',
  please_input_supplier_name: '请输入供应商名称',
  input_length_must_le_20: '不超过20个字',
  contact: '联系人',
  contact_phone: '联系号码',
  please_input_contact_name: '请输入联系人名称',
  contact_address: '联系地址',
  please_input_contact_address: '请输入联系地址',
  please_input_right_phone: '请输入正确的联系号码',
  please_input_right_contact_phone: '请输入联系号码',
  email: '电子邮箱',
  please_input_email: '请输入电子邮箱',
  email_format_error: '邮箱格式不正确',
  finance_info: '财务信息',
  open_account_name: '开户名称',
  please_input_open_account_name: '请输入开户名称',
  open_account_bank: '开户银行',
  please_input_open_account_bank: '请输入开户银行',
  bank_card_no: '银行卡号',
  please_input_bank_card_no: '请输入银行卡号',
  please_input_right_bank_card_no: '请输入正确的银行卡号',
  invoice_title: '发票抬头',
  please_input_invoice_title: '请输入发票抬头',
  enclosure_info: '附件信息',
  upload_certificates: '上传证件',
  upload_enclosure: '上传附件',
  upload_maximum: '最多允许上传{{max}}张图片',
  upload_image_maximum_size: '图片不可大于10MB',
  business_license_image_upload_rule:
    '请上传营业执照等资质文件，支持 png、jpg、jpeg 文件，单个文件不可大于 2MB',
  read_supplier: '查看供应商',
  del_supplier_with_name: '删除供应商[{{supplierName}}]',
  del_supplier_with_user_name: '删除供应商用户[{{supplierUserName}}]',
  del_supplier_with_user_role_name: '删除供应商用户角色[{{supplierUserRoleName}}]',
  search_supplier_name_contact_phone: '搜索供应商/联系人/联系号码',
  read_adjustment_order: '查看库存调整单',
  save_adjustment_order: '新增库存调整单',
  edit_adjustment_order: '编辑库存调整单',
  audit_adjustment_order: '审核库存调整单',
  export_adjustment_order: '导出库存调整单',
  print_adjustment_order: '打印库存调整单',
  copy_adjustment_order: '复制库存调整单',
  invalid_adjustment_order_with_order_no: '作废库存调整单[{{orderNo}}]',
  del_adjustment_order_with_order_no: '删除库存调整单[{{orderNo}}]',
  audit_adjustment_order_with_order_no: '审核库存调整单[{{orderNo}}]',
  copy_adjustment_order_with_order_no: '复制库存调整单[{{orderNo}}]',
  create_adjustment_order_with_order_no: '创建库存调整单[{{orderNo}}]',
  import_adjustment_order_with_order_no: '导入库存调整单[{{orderNo}}]',
  export_adjustment_order_detail_with_order_no: '导出库存调整单[{{orderNo}}]明细',
  adjustment_location: '调整门店',
  please_choose_adjustment_location: '请选择调整门店',
  adjustment_type: '调整方式',
  please_choose_adjustment_type: '请选择调整方式',
  choose_adjustment_type: '选择调整方式',
  inventory_in: '入库',
  inventory_in_money: '入库金额',
  inventory_out: '出库',
  inventory: '库存',
  inventory_change: '库存变动',
  virtual_inventory_change: '虚拟库存变动',
  export_inventory_change: '导出库存变动',
  inventory_log_list: '库存日志列表',
  virtual_inventory_log_list: '虚拟库存日志列表',
  stock_transfer: '库存转仓',
  stock_transfer_details: '转仓单详情',
  read_stock_transfer: '查看库存转仓',
  save_stock_transfer: '新增库存转仓',
  copy_stock_transfer: '复制库存转仓',
  edit_stock_transfer: '编辑库存转仓',
  save_stock_transfer_with_order_no: '创建库存转仓[{{orderNo}}]',
  del_stock_transfer_with_order_no: '删除库存转仓[{{orderNo}}]',
  edit_stock_transfer_with_order_no: '编辑库存转仓[{{orderNo}}]',
  audit_stock_transfer_with_order_no: '审核库存转仓[{{orderNo}}]',
  copy_stock_transfer_with_order_no: '复制库存转仓[{{orderNo}}]',
  export_stock_transfer: '导出库存转仓',
  export_stock_transfer_detail_with_order_no: '导出库存转仓单[{{orderNo}}]明细',
  blush_copy_stock_transfer_with_order_no: '冲红复制库存转仓[{{orderNo}}]',
  confirm_blush_copy_stock_transfer: '确定要冲红复制“[{{orderNo}}]"吗？',
  blush_duplicate: '冲红复制',
  stock_transfer_date: '转仓日期',
  available_stock: '可用库存',
  occupy_stock: '占用库存',
  occupy_qty: '占用数量',
  occupy_stock_details: '占用库存明细',
  inventory_situation: '库存情况',
  please_select_inventory_situation: '请选择库存情况',
  in_stock: '有库存',
  out_stock: '无库存',
  adjustment_date: '调整日期',
  choose_reason: '选择原因',
  please_choose_adjustment_reason: '请选择调整原因',
  please_input_reason_keyword: '请输入原因关键字',
  adjustment_order_import: '调整单导入',
  adjustment_order_import_tmpl: '调整单导入模板',
  read_adjustment_reason: '查看调整原因',
  save_adjustment_reason: '新增调整原因',
  edit_adjustment_reason: '编辑调整原因',
  create_adjustment_reason_with_order_no: '创建调整原因[{{reasonName}}]',
  edit_adjustment_reason_with_order_no: '编辑调整原因[{{reasonName}}]',
  del_adjustment_reason_with_order_no: '删除调整原因[{{reasonName}}]',
  name: '名称',
  please_input_name: '请输入名称',
  name_can_not_be_null: '名称不可为空',
  please_input_adjustment_reason_name: '输入调整原因名称',
  read_check_order: '查看库存盘点单',
  save_check_order: '新增库存盘点单',
  edit_check_order: '编辑库存盘点单',
  audit_check_order: '审核库存盘点单',
  export_check_order: '导出库存盘点单',
  print_check_order: '打印库存盘点单',
  copy_check_order: '复制库存盘点单',
  invalid_check_order_with_order_no: '作废库存盘点单[{{orderNo}}]',
  del_check_order_with_order_no: '删除库存盘点单[{{orderNo}}]',
  audit_check_order_with_order_no: '审核库存盘点单[{{orderNo}}]',
  copy_check_order_with_order_no: '复制库存盘点单[{{orderNo}}]',
  create_check_order_with_order_no: '创建库存盘点单[{{orderNo}}]',
  import_check_order_with_order_no: '导入库存盘点单[{{orderNo}}]',
  export_check_order_detail_with_order_no: '导出库存盘点单[{{orderNo}}]明细',
  check_order_import: '盘点单导入',
  check_order_import_tmpl: '盘点单导入模板',
  check_location: '盘点门店',
  please_choose_check_location: '请选择盘点门店',
  all_product_check: '全场盘点',
  point_product_check: '单品盘点',
  point_type_check: '类别盘点',
  check_type: '盘点类型',
  inventory_check_scope: '盘点物品范围',
  please_choose_inventory_check_scope: '请选择盘点物品范围',
  check_date: '盘点日期',
  no_unit: '没有单位',
  product_have_no_unit: '物品没有单位',
  check_qty_base_unit_qty_gt_zero_in_same_time: '盘点数量和基本数量必须同时不为0',
  check_order_detail: '盘点单明细',
  check_order_snapshot_desc:
    '例如：系统实际库存100，盘点时填写库存数量为101，此时设置库存快照后采购入库数量40，然后再进行库存盘点审核，审核后盘点库存为101+40=141',
  product_dormancy_desc: '【休眠】：不允许要货，要货流程不显示该物品',
  product_stop_purchase_desc: '【停购】：不允许采购，采购流程中不显示该物品',
  product_draft_desc: '【淘汰】：系统单据中不显示该物品',
  after_audit_inventory_will_change: '审核通过后库存将按照盘点数量调整。',
  please_choose_check_type: '请选择盘点类型',
  please_choose_type: '请选择类别',
  check_method: '盘点方法',
  filter_product: '过滤物品',
  read_finished_produce_rate_report: '查看出品率报表',
  export_finished_produce_rate_report: '导出出品率报表',
  plan_produce_qty: '计划生产量',
  finished_in_inventory_qty: '成品入库量',
  plan_finish_rate: '计划完成率',
  finished_produce_rate: '成品出品率',
  total_material: '原料合计',
  storage_time: '入库时间',
  storage_date: '入库日期',
  plan_order_no: '计划单号',
  add_by_request_order: '通过要货单新增',
  request_number: '需求数量',
  request_number_tip: '门店向配送中心要货，某个物品的总和',
  in_production: '生产中',
  in_production_tip: '未审核的生产入库单，某个物品的总和',
  formula_available: '是否有配方',
  quantity_required: '需生产量',
  at_most: '最多{{num}}个字',
  please_select_produced_product: '请选择要生产的物品',
  produce_plan_order_tip: '根据门店要货需求⽣成需求单，以加工品维度展示',
  choose_plan_order_no: '选择计划单号',
  produce_production_order_no: '生产领料单号',
  produce_plan_order_no: '生产计划单号',
  from_to_process_order_no: '来源加工单号',
  from_to_process_order_no_tip:
    '若加工品A配方嵌套半成品B，则A生产计划单审核后系统会生成被嵌套半成品B的生产计划单，B生产计划单的来源生产计划单号为加工品A的生产计划单',
  process_no_type: '加工单类型',
  added_by_hands: '手动新增',
  request_order_added: '要货单新增',
  ship_center_generated: '配送中心生成',
  from_board_created: '生产看板创建',
  production_order_created: '生产任务创建',
  from_order: '订单生成',
  document_date: '单据日期',
  current_inventory: '当前库存',
  produce_room_inventory: '加工间库存',
  outbound_price: '出库均价',
  outbound_price_tip: '出库仓库消耗单位出库均价，如果没有则取档案成本价',
  base_outbound_price: '出库基本均价',
  base_outbound_price_tip: '出库仓库基本单位出库均价，如果没有则取档案成本价',
  outbound_money: '出库金额',
  outbound_money_tip: '领用数量*出库均价',
  current_inventory_tip: '当前加工间库存余量',
  storehouse_num_cannot_be_the_same: '加工间仓库与出库仓库不能是同一个,请重新选择',
  product_date: '生产日期',
  batch_add: '批量添加',
  receive_quantity: '领用数量',
  read_produce_plan_order: '查看生产计划单',
  save_produce_plan_order: '新增生产计划单',
  edit_produce_plan_order: '编辑生产计划单',
  audit_produce_plan_order: '审核生产计划单',
  export_produce_plan_order: '导出生产计划单',
  print_produce_plan_order: '打印生产计划单',
  copy_produce_plan_order: '复制生产计划单',
  invalid_produce_plan_order_with_order_no: '作废生产计划单[{{orderNo}}]',
  del_produce_plan_order_with_order_no: '删除生产计划单[{{orderNo}}]',
  audit_produce_plan_order_with_order_no: '审核生产计划单[{{orderNo}}]',
  copy_produce_plan_order_with_order_no: '复制生产计划单[{{orderNo}}]',
  create_produce_plan_order_with_order_no: '创建生产计划单[{{orderNo}}]',
  import_produce_plan_order_with_order_no: '导入生产计划单[{{orderNo}}]',
  export_produce_plan_order_detail_with_order_no: '导出生产计划单[{{orderNo}}]明细',
  produce_qty_can_not_be_zero: '加工量不可以为0',
  read_produce_material_order: '查看生产领料单',
  save_produce_material_order: '新增生产领料单',
  edit_produce_material_order: '编辑生产领料单',
  audit_produce_material_order: '审核生产领料单',
  export_produce_material_order: '导出生产领料单',
  print_produce_material_order: '打印生产领料单',
  copy_produce_material_order: '复制生产领料单',
  invalid_produce_material_order_with_order_no: '作废生产领料单[{{orderNo}}]',
  del_produce_material_order_with_order_no: '删除生产领料单[{{orderNo}}]',
  audit_produce_material_order_with_order_no: '审核生产领料单[{{orderNo}}]',
  copy_produce_material_order_with_order_no: '复制生产领料单[{{orderNo}}]',
  create_produce_material_order_with_order_no: '创建生产领料单[{{orderNo}}]',
  import_produce_material_order_with_order_no: '导入生产领料单[{{orderNo}}]',
  export_produce_material_order_detail_with_order_no: '导出生产领料单[{{orderNo}}]明细',
  finished_have_no_material: '该成品配方暂无原料',
  produce_date: '加工日期',
  relate_produce_plan_order: '关联生产计划单',
  please_choose_relate_produce_plan_order: '请选择关联生产计划单',
  choose_relate_produce_plan_order: '选择关联生产计划单',
  produce_product: '加工物品',
  please_choose_produce_product: '请选择加工物品',
  choose_produce_product: '选择加工物品',
  produce_qty: '加工量',
  please_input_produce_qty: '请输入加工量',
  please_input_product_title_barcode_sku_variant: '请输入物品名称/条码/编码/规格',
  produce_storage_order_no: '生产入库单号',
  warehousing_success_tip: '生产入库成功，可至【库存进出明细】中查看',
  outbound_record: '生成生产入库记录{{num}}条',
  warehousing_record: '生成生产出库记录{{num}}条',
  process_product_warehousing: '加工品入库',
  raw_material_warehousing: '原材料出库',
  confirm_price: '价格确认',
  deducting_warehouse: '扣除仓库',
  deducting_warehouse_tip: '扣除仓库取自加工品管理中，加工品所在加工间仓库',
  inventory_status: '库存状态',
  theoretical_dosage: '理论用量',
  theoretical_dosage_tip: '加工品生产入库数量结合生产配方计算出的原料理论耗用数量',
  actual_usage: '实际用量',
  actual_usage_tip: '用户手动输入的用量，默认取理论用量的值',
  differential_dosage: '差异用量',
  differential_dosage_tip: '差异用量=理论用量-实际用量',
  quantity_on_hand: '现存量',
  quantity_to_be_supplemented: '待补充数量',
  quantity_to_be_supplemented_tip:
    '实际用量-现存量，如为正，红字提示标记短缺，如为负，展示为零标记充足',
  detail_money_tip: '金额在已完工入库前不进行计算',
  detail_price_tip: '成本单价在已完工入库前不进行计算',
  detail_in_storehouse_tip: '默认取加工品设置的默认归属仓库',
  batch_setting_in_warehouse: '批量设置入库仓库',
  raw_material_name: '原材料名称',
  total_theoretical_dosage: '总理论用量',
  total_actual_usage: '总实际用量',
  total_base_unit_qty: '基本单位总用量',
  base_unit_qty: '基本单位用量',
  total_assist_unit_qty: '辅助单位总用量',
  total_differential_dosage: '总差异用量',
  actual_usage_detail_tip:
    '（可直接输入总实际用量，系统会按默认规则自动分摊，也可以按明细自定义实际用量）',
  default_allocation_rules: '默认分摊规则',
  automatic_allocation_rules: '自动分摊规则',
  automatic_allocation_rules_tip_one: '按加工品的理论用量占比进行分摊。',
  automatic_allocation_rules_tip_two:
    '例：加工品A理论用量M，加工品B理论用量N，总实际用量X，则，加工品A的实际用量=X * M/（M+N）；加工品B的实际用量=X * N/（M+N）;',
  automatic_allocation_rules_tip_three: '若：原材料理论用量为0时，该原材料不自动分摊',
  completion_date: '完工日期',
  unfinished: '未完工',
  completed: '已完工',
  cancel_operation: '是否取消当前操作？',
  in_storehouse_cannot_be_empty: '入库仓库不能为空',
  warehouseing_success: '入库成功',
  confirm_produce_tip: '确认生产后，加工品入库对应仓库，原材料从对应仓库出库',
  confirm_produce: '确认生产',
  read_produce_storage_order: '查看生产入库单',
  save_produce_storage_order: '新增生产入库单',
  edit_produce_storage_order: '编辑生产入库单',
  audit_produce_storage_order: '审核生产入库单',
  export_produce_storage_order: '导出生产入库单',
  print_produce_storage_order: '打印生产入库单',
  copy_produce_storage_order: '复制生产入库单',
  invalid_produce_storage_order_with_order_no: '作废生产入库单[{{orderNo}}]',
  del_produce_storage_order_with_order_no: '删除生产入库单[{{orderNo}}]',
  audit_produce_storage_order_with_order_no: '审核生产入库单[{{orderNo}}]',
  copy_produce_storage_order_with_order_no: '复制生产入库单[{{orderNo}}]',
  create_produce_storage_order_with_order_no: '创建生产入库单[{{orderNo}}]',
  import_produce_storage_order_with_order_no: '导入生产入库单[{{orderNo}}]',
  export_produce_storage_order_detail_with_order_no: '导出生产入库单[{{orderNo}}]明细',
  location_can_not_be_null: '门店不可为空',
  relate_produce_material_order: '关联领料单',
  please_choose_relate_produce_material_order: '请选择关联领料单',
  choose_relate_produce_material_order: '选择关联领料单',
  read_produce_fast_order: '查看快速生产单',
  save_produce_fast_order: '新增快速生产单',
  edit_produce_fast_order: '编辑快速生产单',
  audit_produce_fast_order: '审核快速生产单',
  export_produce_fast_order: '导出快速生产单',
  print_produce_fast_order: '打印快速生产单',
  copy_produce_fast_order: '复制快速生产单',
  invalid_produce_fast_order_with_order_no: '作废快速生产单[{{orderNo}}]',
  del_produce_fast_order_with_order_no: '删除快速生产单[{{orderNo}}]',
  audit_produce_fast_order_with_order_no: '审核快速生产单[{{orderNo}}]',
  copy_produce_fast_order_with_order_no: '复制快速生产单[{{orderNo}}]',
  create_produce_fast_order_with_order_no: '创建快速生产单[{{orderNo}}]',
  import_produce_fast_order_with_order_no: '导入快速生产单[{{orderNo}}]',
  export_produce_fast_order_detail_with_order_no: '导出快速生产单[{{orderNo}}]明细',
  of_material: '的原料',
  finished_product_title: '成品名称',
  material_product_title: '原料名称',
  un_get_location_permission: '未获取到门店信息、权限',
  update_chain_stock_failed: '更换进销存token失败',
  lack_important_data: '缺少关键数据，跳转失败',
  load_finished: '加载完毕',
  ship_net: '配送网络',
  read_ship_net: '查看配送网络',
  setting_ship_location: '设置配送门店',
  read_ship_location: '查看配送门店',
  ship_location_setting: '配送门店设置',
  choose_location_setting: '选择配送门店',
  no_location: '暂无门店',
  ship_center_name: '配送中心名称',
  ship_center: '配送中心',
  return_ship_center: '返回配送中心',
  please_select_ship_center: '请选择配送中心',
  location_code: '门店代码',
  location_sys_num: '门店编码',
  search_location_name_code: '搜索门店名称/代码',
  read_chain_stock_setting: '查看进销存设置',
  purchase_setting: '采购设置',
  receive_auto_update_cost: '采购收货自动维护成本价',
  goods_name: '物品名称',
  please_input_goods_name: '请输入物品名称',
  goods_inventory: '物品库存',
  read_goods_inventory: '查看物品库存',
  product_detail: '物品明细',
  un_know: '未知',
  sync: '同步',
  success_import_count: '成功导入{{dataCount}}条',
  failed_reason: '失败原因',
  task_type: '任务类型',
  apply_time: '申请时间',
  finished_time: '完成时间',
  task_process: '任务进度',
  task_state: '任务状态',
  my_account: '我的账号',
  user_center: '个人中心',
  user_setting: '个人设置',
  switch_merchant: '切换店铺',
  headquarters: '【总部】',
  ship: '【配送】',
  location: '【门店】',
  location_renewals: '门店',
  logout: '退出登录',
  task_center: '任务中心',
  task_center_only_show_15_day_data: '任务中心只展示近15天的数据，请及时处理',
  qty_must_ge_min_order_qty: '数量不能小于订购下限',
  qty_must_double_order_base: '数量必须为订购基数: {{useUnitMul}}的倍数',
  please_input_keyword_to_add: '请输入关键词添加',
  price: '单价',
  base_price: '基本单价',
  base_price_average: '基本均价',
  base_unit_inventory: '基本单位库存',
  in_out_qty: '盈亏数量',
  tag_gift: '标记赠送',
  yes: '是',
  no: '否',
  all_product_type: '全部物品类别',
  un_choose_location: '未选门店',
  choose_location_count: '已选门店({{locationCount}})',
  please_choose_product_variant: '请选择物品规格',
  search_product: '搜索物品',
  search_product_series: '搜索物品系列',
  search_product_title_variant_barcode: '搜索物品名称/规格/条码/编码',
  choose_product_count: '已选物品({{productCount}})',
  all_orders_selected: '已勾选要货门店为 {{locationName}} 的所有要货单',
  choose_date: '选择日期',
  clean_choose: '清空已选项',
  filter_produced_produce_plan_order: '过滤已加工的生产计划单',
  have_repeat_product_please_choose_again: '已存在重复物品，请重新选择！',
  no_data: '暂无数据',
  no_data_please_check: '暂无数据，请检查您的查询条件或数据源！',
  request_date: '要货日期',
  import_tmpl: '导入模版',
  please_upload_excel: '请上传excel',
  only_upload_xls_and_xlsx: '只能上传xlsx或xls文件格式',
  only_upload_image: '只能上传png、jpg、gif和bmp文件格式',
  change_file: '替换文件',
  add_file: '上传文件',
  or_drag_change: '将文件拖到此处，或点击上传',
  upload_file_change: '将文件拖到此处，或',
  download_import_tmpl: '下载模版',
  download_import_tmpl_tip: '请用系统提供的模版编辑数据',
  reason: '原因',
  ship_center_inventory: '配送中心库存',
  today_order_qty: '今日已订数量',
  undelivered_qty: '未配送数量',
  order_qty: '要货数量',
  product_can_not_ship_please_adjust: '以下物品不满足物品配送属性，需要按要求进行调整',
  product_order_audit_error_tip_one: '当前时段不可订货，请在规定时间内订货',
  product_order_audit_error_tip_two: '下列物品必选，是否自动添加到单据中？',
  product_order_audit_error_tip_three: '下列菜品必选，是否自动调整最小要货数量？',
  product_order_audit_error_tip_content: '【{{name}}】的要货数量不能小于最小要货值【{{number}}】',
  current_order_amount_tip: '当前单据金额{{money}}元',
  min_order_amount_tip: '最小起订金额为{{money}}元',
  please_input_keyword: '请输入关键字',
  choose_all: '全选',
  cancel_all: '全部取消',
  location_without_symbol: '门店',
  location_num: '门店编号',
  keyword_query: '关键字查询',
  role: '角色',
  please_choose_role: '请选择角色',
  super_admin: '超级管理员',
  all_role: '全部角色',
  move_right_complete_verification: '向右滑动完成验证',
  verification_success: '验证成功',
  verification_failed: '验证失败',
  safe_storage: '安全留存',
  please_complete_safe_verification: '请完成安全验证',
  only_upload_jpg_and_png: '只能上传JPG或PNG文件格式',
  image_size_lt_2m: '图片必须小于 2MB',
  custom_tag: '自定义标签',
  save_filtter: '保存筛选器',
  saved: '已保存',
  filter_saved_tips: '筛选器将保存为此列表顶部的新标签。',
  filter_name_labels: '请输入标签名称!',
  edit_name: '编辑名称',
  choose_proudct: '已选物品',
  label_name_repeated: '标签名称已重复',
  diff_money: '差异金额',
  shipping_attribute_copy: '配送属性复制',
  purchase_attribute_copy: '采购属性复制',
  today: '今天',
  yesterday: '昨天',
  week: '本周',
  last_week: '上周',
  current_month: '本月',
  last_month: '上月',
  current_quarter: '本季度',
  current_year: '本年度',
  sure_to_delete: '确定删除{{name}}吗？',
  price_openly_agreed_upon: '明盘',
  blind_disc: '盲盘',
  hibernate: '休眠',
  eliminate: '淘汰',
  stop_purchasing: '停购',
  archive_draft: '归档/草稿',
  inventory_snapshot: '库存快照',
  purchase_order_import: '采购订单导入',
  purchase_order_import_tmpl: '采购订单导入模板',
  import_purchase_order_with_order_no: '导入采购订单[{{orderNo}}]',
  receive_order_import: '采购收货订单导入',
  receive_order_import_tmpl: '采购收货订单导入模板',
  import_receive_order_with_order_no: '导入采购收货订单[{{orderNo}}]',
  return_order_import: '退货单导入',
  return_order_import_tmpl: '退货单导入模板',
  import_return_order_with_order_no: '导入退货订单[{{orderNo}}]',
  article_0_of_0: '第 0 条/总共 0 条',
  default_pangination: '第{{first}}-{{second}}条/总共 {{third}} 条',
  store_delivery_price_import_template: '门店配送价导入模版',
  store_delivery_price_import: '门店配送价导入',
  transfer_in_order_import: '调入订单导入',
  transfer_in_order_import_tmpl: '调入订单导入模板',
  import_transfer_in_order_with_order_no: '导入调入单订单[{{orderNo}}]',

  transfer_out_order_import: '调出单导入',
  transfer_out_order_import_tmpl: '调出单导入模板',
  import_transfer_out_order_with_order_no: '导入调出单订单[{{orderNo}}]',
  inner_apply_order_import: '内部申请单导入',
  inner_apply_order_import_tmpl: '内部申请单导入模板',
  import_inner_apply_order_with_order_no: '导入内部申请单订单[{{orderNo}}]',
  produce_plan_order_import: '生产计划单导入',
  produce_plan_order_import_tmpl: '生产计划单导入模板',
  fast_plan_order_import: '快速生产单导入',
  fast_plan_order_import_tmpl: '快速生产单导入模板',
  import_fast_order_with_order_no: '导入快速生产单订单[{{orderNo}}]',
  add_finished_product: '添加成品',
  archive_delivery_price: '档案配送价',
  archive_reference_cost_price: '档案参考成本',
  tag_enable: '标记启用',
  approval: '批复',
  approved: '已批复',
  approval_success: '批复成功',
  whether_to_approval_the_document: '是否批复单据[{{orderNo}}]？',
  quantity_must_be_greater_than_0: '数量必须大于0',
  product_quantity_cannot_be_0: '物品数量不能全为0',
  the_maximum_quantity_cannot_exceed: '数量最大不可超过',
  the_basic_maximum_quantity_cannot_exceed: '基本数量最大不可超过',
  the_quantity_of_raw_materials_cannot_all_be_0: '原料数量不可全部为0',
  duplicate_product_already_exists: '已存在重复物品',
  max_price_cannot_exeed: '单价最大不可超过',
  max_amounnt_cannot_exeed: '金额最大不可超过',
  amount_calculation_error: '金额计算错误',
  read_material: '读取原料',
  loading_products: '物品数据加载中...',
  continue_to_sale: '继续销售',
  stop_to_sale: '停止销售',
  obsolescence_time: '作废时间',
  last_modification_time: '最后修改时间',
  p_delivery_date: '配送日期',
  approval_time: '批复时间',
  processing_time: '处理时间',
  prepare_document: '制单',
  handle: '处理',
  document_status: '单据状态',
  status: '状态',
  applied_store: '被申请门店',
  application_type: '申请类型',
  modifier: '修改人',
  modifier_time: '修改时间',
  operate_type: '操作方式',
  approver: '批复人',
  approver_time: '批复时间',
  processor: '处理人',
  processor_time: '处理时间',
  print_times: '打印次数',
  three_times_more: '三次以上',
  num_times: '{{num}} 次',
  application_remarks: '申请备注',
  reply_note: '批复备注',
  attachments: '附件',
  number_of_attachments: '附件数量',
  return_reason: '退货原因',
  business_store: '业务门店',
  reply_money: '批复金额',
  unit: '单位',
  storehouse_num: '调出单号',
  please_enter_storehouse_num: '请选择调入仓库',
  please_select_storehouse: '请选择仓库',
  no_storehouse_available: '暂无可用仓库',
  location_replenishment: '要货单',
  store_not_bound: '门店未绑定',
  shipping_warehouse: '出货仓库',
  transfer_out_of_warehouse: '转出仓库',
  please_select_transfer_out_of_warehouse: '请选择转出仓库',
  roll_out_memo: '转出备注',
  transfer_to_memo: '转入备注',
  transfer_in_of_warehouse: '转入仓库',
  please_select_transfer_in_of_warehouse: '请选择转入仓库',
  call_in_store: '调入门店',
  call_out_store: '调出门店',
  summary_by_product: '按物品汇总',
  summary_by_store: '按门店汇总',
  summary_by_store_product: '按门店物品汇总',
  summarize_by_order_number: '按单据号汇总',
  summarize_by_order_product_detail: '按单据物品明细',
  summarize_by_business_day: '按门店-物品-营业日汇总',
  commodity_code: '物品代码',
  transit_quantity: '在途数量',
  generate_transfer_store_out_order: '生成调出门店调入单',
  generate_transfer_store_in_form: '生成调入门店调入单',
  relate_transfer_out_order: '关联调出单',
  outbound_tracking_number: '请选择调出单号',
  goods_in_transit: '物品在途',
  batch_review: '批量审核',
  operation_successful: '操作成功',
  check_that_out_unapproved_in_order:
    '请检查相同调出单生成的未审核的调入单，一共成功生成 {{num}} 张单据',
  read_goods_in_transit: '查看物品在途',
  operation_after_sold_out: '售罄后的操作',
  code_input: '代码、名称',
  please_input_code_or_name: '请输入代码或名称',
  store_code: '仓库代码',
  please_enter_store_code: '请输入仓库代码',
  please_enter_contact: '请输入联系人',
  please_enter_store_name: '请输入仓库名称',
  please_enter_contract_phone: '请输入联系人电话',
  please_enter_address: '请输入地址',
  please_enter_remark: '请输入备注',
  please_input_english_name: '请输入英文名称',
  please_input_item_barcode: '请输入物品条码',
  please_input_abbreviation_code: '请输入速记码',
  please_input_variant: '请输入规格',
  please_select_brand_name: '请选择物品品牌名称',
  please_input_place_of_origin: '请输入产地',
  please_select_cost_accounting_method: '请选择成本核算方式',
  please_select_use_unit: '请选择默认单位',
  please_input_purchase_price: '请输入采购价',
  only_number_letter_and_chinese_character: '只能输入中英文/数字/字母组合',
  only_query_not_generated_transfer_out: '只查询未生成调出单的物品',
  store_name: '仓库名称',
  enable: '是否启用',
  default_store: '默认仓库',
  distribution_store: '配送仓库',
  produce_room: '加工间',
  default_belonging_store: '默认归属仓库',
  distribution_processing_room: '分加工间',
  by_request_order: '（按要货单分单）',
  contract_phone: '联系人电话',
  address: '地址',
  last_modified_by: '最后修改人',
  remark: '备注',
  store_info: '仓库信息',
  contact_info: '联系信息',
  save_request_store: '新增仓库信息',
  belonging_store: '所属门店',
  store_attributes: '组织属性',
  belonging_store_not_empty: '所属门店不能为空！',
  edit_request_store: '编辑仓库信息',
  code_input_brand: '代码、名称、速记码',
  barnd_code: '品牌代码',
  brand_name: '物品品牌',
  brand_abbreviation_code: '品牌速记码',
  edit_request_brand: '编辑品牌信息',
  save_request_brand: '新增品牌信息',
  brand_name_title: '品牌名称',
  category_management: '分类名称',
  product_category: '物品分类',
  all_product_category: '全部分类',
  barnd_manage: '品牌管理',
  parent_class: '父类',
  category_code: '分类代码',
  please_input_category_code: '请输入类别代码',
  category_name: '分类名称',
  please_input_category_name: '请输入分类名称',
  please_input_brand_code: '请输入品牌代码',
  please_input_brand_name: '请输入品牌名称',
  document_setting: '档案设置',
  product_document: '物品档案',
  supplier_document: '供应商档案',
  supplier_code_customized: '自定义供应商代码',
  supplier_code_customized_tip: '不勾选应用系统默认规则：前缀KS，加3位自增整数，如KS001，KS002',
  store_document: '仓库档案',
  stock_code_customized: '自定义仓库代码',
  stock_code_customized_tip: '不勾选应用系统默认规则：前缀CK，加3位自增整数，如CK001，CK002',
  store: '仓库',
  no_warehouse_available: '暂无可用仓库',
  delivery_warehouse: '发货仓库',
  please_delivery_warehouse: '请选择发货仓库',
  batch_selection_of_delivery_warehouse: '批量选择发货仓库',
  receive_warehouse: '收货仓库',
  please_receive_warehouse: '请选择收货仓库',
  return_warehouse: '退货仓库',
  please_return_warehouse: '请选择退货仓库',
  inventory_warehouse: '盘点仓库',
  please_inventory_warehouse: '请选择盘点仓库',
  transfer_out_warehouse: '调出仓库',
  please_transfer_out_warehouse: '请选择调出仓库',
  adjust_warehouse: '调整仓库',
  please_adjust_warehouse: '请选择调整仓库',
  inventory_quantity: '库存数量',
  current_inventory_quantity: '当前库存数量',
  remove_current_inventory_quantity_zero: '移除当前账面数为0的物品',
  set_current_inventory_quantity: '实盘数设置为当前库存数',
  not_zero_current_inventory: '无当前库存数为 0 的物品！',
  zero_inventory_remove_tip: '当前库存数为 0 的物品共 {{number}} 项，确认是否从当前盘点单中移除',
  check_product_set_current_inventory_quantity: '盘点物品实盘数设置为账面数',
  set_current_inventory_quantity_tip:
    '盘点物品共 {{number}} 项，确认是否将盘点单未盘点的物品实盘数设置为当前库存数量吗？',
  origin_cost_price: '原成本价',
  current_cost_price: '现成本价',
  origin_base_price: '原基本单价',
  current_base_price: '现基本单价',
  stock_cost_diff_money: '金额差',
  please_enter_inventory_quantity: '请输入库存数量',
  inventory_amount: '库存金额',
  auto_generate_item_code: '自动生成物品条码',
  barcode_digits: '条码位数',
  prefix_usage: '前缀使用',
  auto_generate_sku: '自动生成SKU',
  sku_digits: 'SKU位数',
  fixed_prefix: '固定开头',
  current_category_code: '当前类别编码',
  top_level_category_code: '顶级大类编码',
  none: '无',
  front: '前',
  back: '后',
  position: '位',
  position2: '定位',
  auto_generate_warehouse_code: '自动生成仓库代码',
  current_store_inventory: '当前门店库存',
  fixed_prefix_usage: '前缀使用固定开头',
  code_length: '代码位数',
  product_category_import: '物品分类导入',
  brand_import: '品牌导入',
  dimension: '维度',
  inventory_product_input: '名称、sku、速记码、物品编码',
  product_input: '物品编码、sku、条码、速记码、名称、ID',
  sales_management: '销售管理',
  normal: '正常',
  item_name: '物品名称',
  item_variant_name: '物品规格名称',
  item_category: '物品分类',
  top_item_category: '顶级分类',
  select_item: '选择物品',
  please_item_category: '请选择物品分类',
  item_sku: '物品条码',
  abbreviation_code: '速记码',
  bar_code: '条码',
  please_input_bar_code: '请输入条码',
  sku: 'SKU',
  purchase_price: '采购价',
  delivery_price: '配送价',
  validity_Period: '有效天数',
  primary_Supplier: '主供应商',
  date_item: '建档日期',
  item_id: '物品id',
  item_export: '物品导入',
  english_name: '英文名称',
  sku_code: 'SKU(货号)',
  place_of_origin: '产地',
  cost_accounting_method: '成本核算方式',
  quality_guarantee_period_tip: '用于加工品标签打印，保质期按整一天24小时进行计算到期时间',
  weighted_average: '移动加权平均',
  unit_of_Measurement: '单位设置',
  price_attribute: '价格属性',
  reference_cost: '参考成本',
  other_attributes: '其他属性',
  multiple_codes: '一品多码',
  press_enter_key: '输入多个条码时，逗号隔开',
  item_image: '物品图片',
  please_select_item_category: '请选择物品分类',
  upload_item_image: '上传物品图片',
  business_item_image_upload_rule:
    '仅支持 gif、jpeg、png、bmp 4种格式，推荐像素 800 * 800, 大小不超过10MB, 物品仅需上传单张图片',
  call_in_status: '调入状态',
  not_transferred_in: '未调入',
  partial_transfer_in: '部分调入',
  all_transfer_in: '全部调入',
  warehouse: '仓库',
  item_classification: '物品分类',
  purchase_receipt_details: '采购收货明细',
  purchase_return_details: '采购退货明细',
  summary_purchasing_stores: '采购门店汇总',
  return_store_name: '退货门店名称',
  return_unit_price: '退货单价',
  return_gift_number: '退货赠品数量',
  return_gift_amount: '退货赠品金额',
  cost_unit_price: '成本单价',
  goods: '物品',
  goods_barcode: '物品条码',
  goods_title: '物品名称',
  top_tier_categories: '顶级大类',
  received_quantity: '收货数量',
  receipt_unit_price: '收货单价',
  receipt_amount: '收货金额',
  gift_unit: '赠品单位',
  gift_quantity: '赠品数量',
  gift_amount: '赠品金额',
  conversio_rate: '换算率',
  return_quantity: '退货数量',
  return_amount: '退货金额',
  goods_input_placeholder: '物品名称、助记码、物品条码、sku',
  base_unit_num: '基本单位数量',
  sub_total_num: '数量小计',
  sub_total_amount: '金额小计',
  del_request_store_with_store_no: '删除要货单[{{storehouse_num}}]',
  read_store: '查看仓库信息',
  store_del_confirm_is: '确认删除选中的仓库?',
  create_brand_reason_with_no: '创建品牌[{{name}}]',
  edit_brand_reason_with_no: '编辑品牌[{{name}}]',
  read_request_brand: '查看品牌',
  read_request_category: '查看分类',
  create_category_with_no: '创建分类[{{name}}]',
  edit_category_with_order_no: '编辑分类[{{name}}]',
  category_del_confirm_is: '您确定要删除选中的分类吗?',
  brand_del_confirm_is: '确认删除选中的品牌?',
  del_request_brand_with_id: '删除品牌[{{id}}]',
  psi_unit: '要货单位',
  transfer_unit: '配送单位',
  assist_unit: '辅助单位',
  assist_unit_qty: '辅助单位数量',
  please_select_assist_unit: '请选择辅助单位',
  rate: '换算比例',
  chain_unit: '可要货单位',
  set_multiple_unit: '设置多单位',
  set_assist_unit: '设置辅助单位',
  assist_unit_scene:
    '辅助单位使用场景:常见于生鲜行业，按数量单位要货，按称重单位结算。例如：鱼，10元/斤，下单按条，结算价 = 称重数 x 单价',
  please_select_sub_unit_1: '请选择副单位1',
  please_input_sub_unit_1_rate: '请输入副单位1换算率',
  sub_unit_1_more_than_zero: '副单位1换算率应大于0',
  please_select_sub_unit_2: '请选择副单位2',
  please_input_sub_unit_2_rate: '请输入副单位2换算率',
  sub_unit_2_more_than_zero: '副单位2换算率应大于0',
  sub_unit_2_rate_more_than_zero_sub_unit_1: '副单位2换算比例需要大于副单位1换算比例',
  please_select_base_unit: '请选择基本单位',
  please_input_assist_unit_rate: '请输入辅助单位换算率',
  assist_unit_rate_more_than_zero: '辅助单位换算率应大于0',
  rate_over_zero: '换算比例大于0',
  share: '份',
  add_unit: '新增单位',
  unit_can_not_be_null: '单位必填',
  please_select_unit: '请选择单位',
  sub_unit_1: '副单位1',
  please_select_sub_unit: '请选择副单位',
  please_add_unit_first: '请先添加该单位',
  the_unit_is_already_selected_by_others: '该单位已被其他选中，请重新选择！',
  sub_unit_2: '副单位2',
  settings_desc: '常规物品条码为69开头的13位数字，条码位数推荐使用13位',
  add_category: '新增一级分类',
  add_Subcategory: '添加子分类',
  edit_request_category: '编辑分类',
  save_request_category: '新增分类',
  del_request_product_with_no: '删除物品档案[{{id}}]',
  product_confirm_is: '物品删除后不可恢复，是否确认删除？',
  product_delete_confirm_tip: '是否删除该物品？',
  whether_to_delete_the_selected_item: '是否删除所选物品',
  code_store: '代码',
  save_store: '保存仓库[{{name}}]',
  export_transfer_out_store: '导出仓库单',
  auto_generate_category_code: '自动生成类别代码',
  not_allowed_purchase: '不允许采购，采购流程中不显示该物品',
  not_allowed_requisition: '不允许要货，要货流程中不显示该物品',
  not_allowed_create_business_documents: '不允许做业务单据，供应链单据无法添加该物品',
  involved_sales: '勾选时，物品也是销售菜品，可以直接参与零售环节的销售',
  to_add: '新增',
  unit_settings: '单位设置',
  create_product_with_name: '创建物品档案[{{name}}]',
  copy_create_product_with_name: '复制创建物品档案[{{name}}]',
  edit_product_with_name: '编辑物品档案[{{name}}]',
  please_input_purse: '请输入配送价',
  please_input_reference_cost: '请输入参考成本',
  save_settings: '保存设置',
  please_item_cost: '请选择成本核算方式',
  please_item_rate: '请输入换算比例',
  sub_unit2_greater_than_sub_unit1: '副单位2换算比例需要大于副单位1换算比例',
  sub_unit2_not_equals_sub_unit1: '副单位不能与基本单位重复',
  summaries: '摘要',
  please_select_summaries: '请选择摘要',
  entry_exit_details: '库存进出明细',
  in_out_type: '出入库类型',
  in_stock_type: '入库类型',
  out_stock_type: '出库类型',
  read_entry_exit_details: '查看库存进出明细',
  operate_time: '操作时间',
  quantity_before_adjustments: '调整前数量',
  quantity_adjustments: '调整数量',
  quantity_after_adjustments: '调整后数量',
  operator: '操作人',
  price_after_adjustments: '调整后金额',
  summaries_details: '摘要明细',
  inventory_in_storehouse: '入库仓库',
  inventory_out_storehouse: '出库仓库',
  please_choose_inventory_in_warehouse: '请选择入库仓库',
  please_choose_inventory_out_warehouse: '请选择出库仓库',
  please_input_multiple_codes: '请输入一品多码',
  edit_store: '编辑仓库[{{name}}]',
  please_input_unit: '请输入单位',
  summary_details: '采购汇总明细',
  item_can_not_be_empty: '物品名称不能为空',
  summary_detail_goods_input_placeholder: '物品名称、物品编码、物品条码、sku',
  product_export: '批量导入物品',
  batch_edit: '批量修改',
  please_select_one_row: '请选择要修改的物品',
  product_import_tmpl: '物品档案导入模板',
  please_select_item_brand: '请选择物品品牌',
  import_product_document_prop: '导入物品档案属性',
  batch_edit_document: '批量编辑物品',
  export_transfer_out_document: '导出物品单',
  export_transfer_out_suppiler: '导出供应商档案',
  please_input_barcode_length: '请输入条码位数',
  please_input_sku_length: '请输入sku位数',
  production_department: '出品部门',
  search_production_department: '搜索出品部门',
  allow_selection_of_unit: '手工创建单据时允许选择非默认单位',
  as_the_unit_displayed: '作为用户手工创建业务单据时页面默认展示的单位，可在业务中选择其他单位。',
  simple_category: '菜品类别',
  sale_tracked_inventory: '销售扣减库存',
  headquarters_price: '总部统一价',
  estimated_cost: '预估成本',
  query_by_finished_product_title_shorthand_character: '请输入配方名称、编号',
  search_finished_product: '搜索成品名称',
  sort: '排序',
  create_at_desc: '创建时间（新-旧）',
  create_at_asc: '创建时间（旧-新）',
  trade_name_asc: '菜品名称（A-Z）',
  trade_name_desc: '菜品名称（Z-A）',
  please_select_product_category: '请选择菜品分类',
  read_formula_manage: '查看配方管理',
  not_query_formula_manage: '未查询到配方管理',
  formula_manage_export: '配方管理导出',
  formula_manage: '配方管理',
  operate_tips_del_finished_product: '确认要删除配方{{title}}吗？',
  delete_finished_product: '删除成品{{title}}',
  formula_import: '配方导入',
  formula_import_template: '配方导入模板',
  document_length: '物品数',
  add_first_level_classification: '新增一级分类',
  category_del_confirm_move: '发现该分类下面有物品在使用,删除分类后,这些物品将被移动到?',
  choose_category: '选择分类',
  category_del_confirm_input: '确认删除该分类，请输入分类名称"{{title}}"',
  confirm_delete: '确认删除',
  category_parent: '上级分类',
  please_select_category_parent: '请选择上级分类',
  collapse_all_categories: '折叠全部分类',
  expand_all_categories: '展开全部分类',
  please_input_item_category_name: '输入的名称与选择删除的分类名称不一致，请重新输入',
  sort_category: '排序类别[{{title}}]',
  del_request_category_with_name: '删除分类[{{title}}]',
  move_success: '移动成功',
  create_new_recipe: '新建配方',
  edit_new_recipe: '编辑配方',
  recipe_title: '配方名称',
  please_enter_recipe_name: '请输入配方名称',
  reference_cost_tooltip: '即物品每基准单位的理论预估单价，可用于物品的理论成本核算',
  other_cost: '其他成本',
  total_cost: '总成本',
  total_cost_tip: '总成本 = 参考成本 + 其他成本',
  input_memo_and_max_length_50: '请输入备注说明，不超过50个字',
  price_tip: '取值规则：库存均价>档案成本价',
  money_tip: '原料实际用量出库成本金额',
  location_process_order: '门店加工单',
  process_order_no: '加工单号',
  processing_location: '加工门店',
  processing_storehouse: '加工仓库',
  processing_date: '加工日期',
  invalid_location_process_order_with_order_no: '作废门店加工单[{{orderNo}}]',
  read_location_process_order: '查看加工单',
  save_location_process_order: '新增加工单',
  copy_location_process_order: '复制加工单',
  delete_location_process_order: '删除加工单',
  edit_location_process_order: '编辑加工单',
  audit_location_process_order: '审核加工单',
  processing_room_task_dashboard: '加工间任务看板',
  full_screen: '全屏显示',
  exit_full_screen: '退出全屏',
  processing_room_task_dashboard_data: '加工间每日任务统计看板',
  production_board: '生产看板',
  production_board_tip:
    '生产看板是针对于生产计划单进行集中处理，处理的内容包含：原料领料、加工品生产',
  stop_production: '中止生产',
  stop_production_tip: '不可中止已中止的加工品，请重新选择',
  cancel_termination: '取消中止',
  cancel_termination_tip: '只能取消中止已中止的加工品，请重新选择',
  terminated: '已中止',
  generate_material_order: '生成领料单',
  single_generate: '单品领料',
  summary_generate: '汇总领料',
  process_status: '加工状态',
  generate_status: '领料状态',
  generated_inventory: '已生成入库',
  ungenerated_inventory: '未生成入库',
  generate_picking: '已生成领料',
  ungenerate_picking: '未生成领料',
  generate_processing_order: '生成生产入库单',
  inventory_quantity_already_received: '已入库量',
  actual_production_volume: '实际生产量',
  processed_products_management: '加工品管理',
  storage_conditions: '存储条件',
  product_description: '产品描述',
  usage: '使用方法',
  precautions: '注意事项',
  contact_information: '联系方式',
  product_standard_code: '产品标准代号',
  production_license_code: '生产许可编号',
  select_processed_products: '选择加工品',
  belong_formula: '所属配方',
  add_processed_product: '新增加工品',
  add_processed_product_confirm: '有{{num}}条加工品已属于当前加工间，不可用。是否移除?',
  edit_processed_product: '编辑加工品',
  export_processed_product: '导出加工品',
  please_choose_produce_room: '请选择加工间',
  no_produce_room_to_use: '暂无可用加工间',
  set_process_product: '未设置配方加工品：{{num}}个',
  set_formula: '配方未启用：{{num}}个',
  set_a_recipe: '是否设置配方',
  processed_products: '加工品',
  please_choose_processed_product_greater_than_zero: '仅选择需生产量大于0的加工品',
  please_choose_processed_products: '请选择要删除的加工品',
  delete_processed_product_tip: '以下加工品不可删除！',
  occupied_by_formula: '加工品被配方【{{name}}】占用',
  delete_processed_product: '删除加工品[{{id}}]',
  delete_processed_product_confirm: '删除后，已经使用该物品的加工单将无法审核，确定删除？',
  raw_materials: '原材料',
  processed_product_barcode: '加工品编码',
  processed_product_title: '加工品名称',
  planned_processing_volume: '计划加工量',
  actual_processing_volume: '实际加工量',
  ratio: '比率',
  production_quantity: '生产数量',
  net_material_quantity: '净料量',
  net_material_rate: '净料率',
  reference_unit_price: '参考单价',
  recipe_code: '配方编码',
  creator: '创建人',
  creator_time: '创建时间',
  last_edited_time: '最后编辑时间',
  recipe_information: '配方信息',
  enable_confirm: '启用',
  disable: '禁用',
  cost_unit_tip: '参考成本=参考单价×毛料量',
  net_material_quantity_tip: '指原材料初加工后可用部分的数量',
  net_material_rate_tip: '是指原材料在初步加工后的可用部分重量占加工前总重量的比率',
  gross_profit_tip: '指未加工原材料的毛重，毛料量=净料量÷净料率',
  reference_unit_price_tip: '原材料单价为加工品所属仓库的库存均价，会动态变化',
  consumption_unit_tip: '制作菜品时消耗原材料的单位',
  consumption_unit_price_tip:
    '指物品每消耗单位的价格，消耗单价=物品档案中此物品的消耗单价，此处为理论成本，实际扣减规则：取库存均价>档案成本价',
  category_move_confirm_is: '确认是否移动分类?',
  category_move_confirm_levle: '只能在同一级别的节点之间移动！',
  create_time: '创建时间',
  business_default_unit: '业务默认单位',
  allow_non_fefault_unit:
    '手工创建单据时允许选择非默认单位（如果启用辅助单位代替常用单位，业务默认单位统一为辅助单位，此处设置无效）',
  purchasing_unit: '采购单位',
  distribution_unit: '配送单位',
  stock_keeping_unit: '库存单位',
  business_default_unit_tip:
    '作为用户手工创建业务单据时页面默认展示的单位，可在业务中选择其他单位。',
  unit_conversion_rate: '单位换算率',
  coust_unit: '消耗单价（元）',
  coust_unit_tip: '即物品每消耗单位的价格，消耗单价=参考成本/消耗单位换算值',
  unit_tip: '基本单位无需换算',
  automatically_calculated: '自动计算得出',
  can_setting_cost_card: '门店可以设置物品成本卡',
  can_setting_cost_card_tip:
    '当不启用时，门店视角只能看到总部设置并下发的成本卡，不可编辑；当启用时，门店视角不仅能够看到总部设置并下发的成本卡，还可以在总部成本卡的基础上进行编辑，若总部未设置成本卡，则门店可以直接设置。此外门店还可以进行导入成本卡；',
  standard_cost_card: '菜品成本卡',
  mall_cost_card: '商城菜品成本卡',
  cost_card_manage: '成本卡管理',
  import_cost_card: '导入成本卡',
  export_cost_card: '导出成本卡',
  cost_card: '成本卡',
  cost_card_info: '成本卡信息',
  commodity_info: '菜品信息',
  configuration_cost_card: '配置成本卡',
  commodity_info_placeholder: 'ID/速记码/名称',
  product_info_placeholder: '物品名称/编码/速记码',
  product_id: '菜品ID',
  reset: '重置',
  cost_card_issuance: '成本卡下发',
  issuance_location_manage: '管理下发门店',
  issuance_location_tip: '您确定要撤回勾选的门店吗？',
  withdraw: '撤回',
  withdraw_success: '撤回成功',
  replace_cost_card_search_tip: '请先在上方输入物品进行成本卡查询',
  choose_cost_card: '选择成本卡',
  cost_card_issuance_tips:
    '下发只影响总部下发给门店的数据，门店自建的不影响。成本卡出品仓库为默认仓库',
  batch_replacement_of_items: '批量替换物品',
  batch_import: '批量导入',
  batch_export: '批量导出',
  batch_deletion: '批量删除',
  distribution_management: '下发管理',
  cost_card_import_tips_first:
    '每次导入物品限制数量应小于5000条，菜品限制数量应小于1000条，文件小于3M只能上传.xlsx格式的文件',
  cost_card_import_tips_second: '请按错误提示修改，直至导入成功',
  batch_import_of_cost_cards: '批量导入成本卡',
  cost_card_import_tmpl: '成本卡导入模板',
  product_code: '货号',
  product_name: '菜品名称',
  product_variant_name: '规格名称',
  product_classify: '菜品分类',
  sales_unit: '销售单位',
  sales_price: '销售价（元）',
  s_price: '售价',
  membership_price: '会员价（元）',
  cost_price_yuan: '成本价（元）',
  add_cost_card: '添加成本卡',
  cost_card_confirm: '您确定要删除成本卡吗？删除后不可恢复，请谨慎操作！',
  cost_price_yuan_tip: '成本价 = 物品成本 + 其他成本',
  classify_all: '全部分类',
  view_cost_card: '查看成本卡',
  confirm_issuance: '确认下发',
  cost_card_id: '成本卡编号',
  cost_card_name: '成本卡名称',
  number_of_associated_dishes: '关联菜品数',
  associated_dishes: '关联菜品',
  abnormal_association: '异常关联',
  items_before_replacement: '替换前物品',
  batch_replacement_of_items_tips:
    '此功能可用于将成本卡中某物品批量替换成新物品，请先选择要被替换的的物品',
  consumption_unit: '消耗单位',
  consumption: '消耗量',
  consumption_unit_price: '消耗单价（元）',
  consumption_amount: '消耗金额（元）',
  consumption_amount_tip: '消耗金额=消耗单价×毛料量',
  basic_unit_gross_profit_quantity: '基本单位毛料量',
  find_cost_card: '查找对应成本卡',
  items_after_replacement: '替换后物品',
  choose_items_after_replacement: '选择替换后物品',
  affects_the_number_of_dishes: '影响菜品数',
  individual: '个',
  selected_cost_card: '已选成本卡',
  replacing_institutions: '替换机构',
  return_to_modification: '返回修改',
  location_count: '下发门店数',
  issuing_operation_time: '下发操作时间',
  effective_date_of_issuance: '下发生效时间',
  please_enter_operator: '请输入操作人',
  all_successful: '全部成功',
  all_failed: '全部失败',
  partial_failure: '部分失败',
  in_progress: '执行中',
  select_institution: '选择机构',
  additional_cost_card: '新增成本卡',
  edit_cost_card: '编辑成本卡',
  copy_cost_card: '复制成本卡',
  cost_card_code: '成本卡编码',
  yuan: '（元）',
  product_cost: '物品成本',
  cost_card_type: '成本卡类型',
  the_first_associated_product_by_default: '默认填充首次关联菜品的名称',
  add_product_tootip: '物品成本 = 所有物品消耗金额之和',
  total_cost_tootip: '指单品的合计成本，值=物品成本合计 + 其他成本',
  add_associated_products: '添加关联菜品',
  associated_products: '关联菜品',
  product_codes: '菜品编码',
  selected: '已选择',
  gross_profit_rate_tootip: '毛利率=（销售价-成本价）/销售价',
  associated_with_a_cost_card: '是否关联成本卡',
  standard_products: '标准菜品',
  mall_products: '商城菜品',
  all_associated_products: '已关联的菜品',
  distribution_status: '下发状态',
  distribution_location: '下发门店',
  distribution_location2: '分配门店',
  replace_result: '替换结果',
  got_it: '知道了',
  please_select_cost_card: '请选择要操作的成本卡',
  del_cost_card_with_no: '删除成本卡[{{id}}]',
  gross_profit_error: '售价不能小于成本价',
  commodity_type: '菜品类型',
  choose_commodity_count: '已选菜品({{productCount}})',
  please_input_product_code: '请输入物品编码',
  management_type: '统计科目',
  please_select_management_type: '请选择管理类型',
  finished_product: '库存菜品（成本类）',
  semi_finished_product: '半成品（成本类）',
  raw_material: ' 原材料（成本类）',
  Consumables: '低值易耗品（费用类）',
  yield: '产率',
  theoretical_consumption: '理论耗用量',
  theoretical_consumption_amount: '理论耗用金额',
  actual_consumption: '实际耗用量',
  actual_amount_consumed: '实际耗用金额',
  number_of_differences: '差异数量',
  fixed_assets: '固定资产（费用类）',
  please_input_number: '请输入数量',
  custom_item_code: '自定义物品编码',
  code_number: '编码位数',
  custom_item_code_tip: '不勾选应用系统默认规则：前缀WP，加4位自增整数，如WP0001，WP0002',
  please_input_code_length: '请输入编码位数',
  Purchase_prices: '采购单价（元）',
  Purchase_barcode: '采购条形码',
  Purchase_barcode_tip:
    '采购单价：新增采购订单和收货单时的默认价格.<br/>取值顺序：对应供应商供货关系的约定价格>该供应商的最近一次进货价>物品档案采购单价>档案成本价',
  please_input_purchase_prices: '请输入采购单价（元）',
  please_input_purchase_code: '请输入采购条形码',
  cost_card_name_empty: '成本卡名称不能为空',
  please_add_associated_products: '请添加关联菜品',
  successfully_issued: '下发成功',
  cannot_become_the_child_of_the_party: '不能成为对方的子节点',
  current_institution: '当前机构',
  replace_successfully: '有{{num}}个成本卡全部替换物品成功',
  replace_failure: '有{{successNum}}个菜品成本卡替换物品成功，{{failNum}}个失败，失败明细如下：',
  please_select_the_item_after_replacement: '请选择替换后物品',
  please_select_the_consumption_unit: '请选择消耗单位',
  please_use_template: '请使用系统提供的模板编辑数据',
  click_upload: '点击上传',
  please_use_template_tip: '每次导入物品限制数量应小于5000条，文件小于3M',
  please_use_template_desc: '仅支持：.XLS，.XLSX格式的文件',
  drag_file: '将文件拖到此处，或',
  start_importing: '开始导入',
  template_content_verification: '模板内容校验：',
  repeat_comparison: '重复对比：',
  override_import: '覆盖导入',
  enable_data_import: '开启后将覆盖已有数据，以本次导入内容为准',
  base_unit_update: '基准单位、默认业务单位及换算率不支持修改，无法覆盖',
  confirm_import: '确认导入',
  re_upload: '重新上传',
  download_verification_results: '下载校验结果',
  you_can_click: '您可以点击',
  view_data: '查看并修改有问题的数据',
  skip_data: '或跳过问题直接导入',
  please_input_item_code: '请输入物品编码',
  add_up_to_10_units: '最多添加10个单位',
  only_number_greater_than_0: '只支持大于0的数字',
  sales_manage_confirm_is: '是否开启销售管理、开启后，菜品可进行销售',
  sales_item_move: '第三方菜品不能移动',
  sales_item_export: '第三方菜品不能导入',
  source: '来源',
  third_classification: '三方菜品',
  material_classification: '自建物品',
  packageackage_products: '套餐菜品',
  add_raw_materials: '添加原材料',
  add_processed_products: '添加加工品',
  add_processed_products_tip: '（仅显示当前加工间还没有创建配方的加工品）',
  summary_of_items_procured: '采购物品汇总',
  enquiry_unit: '查询单位',
  recent_purchase_price: '最近进价',
  please_input_net_material_quantity: '请输入净料量',
  please_input_net_material_rate: '请输入净料率',
  please_input_consumption_unit: '请输入生产数量',
  choose_raw_materials: '选择原材料，需先选择加工品',
  duplicate_with_processed_product_data: '与加工品数据：{{id}}重复,已过滤',
  production_quantity_cannot_be_0: '生产数量不能为0',
  save_recipe_management: '创建配方',
  edit_recipe_management: '编辑配方',
  create_recipe_management_with_recipe_no: '创建配方编号{{id}}',
  add_recipe_management: '请先添加一个加工品和一个原材料',
  operate_tips_del_goods_formula: '修改加工品会清空填入的信息，是否确认操作？',
  edit_recipe_management_with_code: '编辑配方,原因:{{code}}',
  net_material_quantity_cannot_be_0: '净料量不能为0',
  net_material_rate_cannot_be_0: '净料率不能为0',
  number_of_gifts_received: '收货赠品数量',
  price_of_gifts_received: '收货赠品金额',
  classification_not_allowed_created: '系统内置分类名称，不允许重复创建',
  read_stock_change_statistics: '查看进销存变动统计',
  stock_change_statistics: '进销存变动统计',
  category_summary: '分类汇总',
  purchase_unit: '采购单位',
  inventory_unit: '库存单位',
  none_inventory: '无出入库',
  have_inventory_transfer_record: '有出入库记录',
  deleted: '已删除',
  base_info2: '基本信息',
  other_info: '其他信息',
  top_level_category: '顶级分类',
  last_time_inventory: '上期库存',
  purchase_return: '采购退货',
  reception_sales: '前台销售',
  inventory_cost_adjustment: '库存成本调整',
  inventory_in_adjustment_reason: '入库库存调整原因',
  inventory_out_adjustment_reason: '出库库存调整原因',
  inventory_report_overflow: '盘点报溢',
  inventory_loss_reporting: '盘点报损',
  transfer_warehouse_entry: '转仓入库',
  transfer_warehouse_out: '转仓出库',
  transfer_warehouse_date: '转仓日期',
  material_requisition_out: '领料出库',
  finished_product_warehousing: '成品入库',
  current_time_inventory_in: '本期入库',
  current_time_inventory_out: '本期出库',
  current_time_inventory_balance: '本期库存',
  export_stock_change_statistics: '导出配送毛利',
  create_unit: '新增单位',
  unit_name: '单位名称',
  please_input_unit_name: '请输入单位名称',
  last_seven_days: '近7天',
  last_thirty_days: '近30天',
  cost_money: '成本金额',
  unit_settings_tooltip:
    '1.物品被业务应用后无法更改基准单位。（业务单据有：采购订单、采购收货单、采购退货单、要货单、调入单、调出单、内部申请单、盘点单）2.关联过菜品成本卡或生产配方时无法修改单位及换算率',
  pagnition_total: '共 {{t}} 条',
  loading: '加载中',
  not_found_data: '未查询到数据',
  delivery_price_tooltip: '配送价取值顺序：物品配送属性里的配送价>档案配送价',
  store_statistics: '储存统计',
  inventory_minimum: '库存下限',
  inventory_limit: '库存上限',
  inventory_upper_and_lower: '库存上下限的单位类型是基本单位',
  please_input: '请输入',
  please_input_over_0_integer_1: '请输入大于等于1的整数',
  item_volume: '物品体积',
  item_weight: '物品重量',
  inventory_minimum_tooltip:
    '可通过物品库存查询表-门店维度查看库存的上下限和库存预警，库存上下限的单位类型是基本单位',
  inventory_limit_tooltip:
    '可通过物品库存查询表-门店维度查看库存的上下限和库存预警，库存上下限的单位类型是基本单位',
  item_volume_tooltip:
    '物品属性用于记录物品的体积信息，表示为基准单位对应物品的体积数据。暂无业务使用，待后续更新',
  item_weight_tooltip:
    '物品属性用于记录物品的重量信息，表示为基准单位对应物品的重量数据。暂无业务使用，待后续更新',
  read_request_order_template: '查看要货模板',
  request_order_template: '要货模板',
  template_name: '模板名称',
  template_id: '模板编号',
  used_location: '应用门店',
  used_location_count: '{{locationCount}}家门店',
  requst_product_num: '可要货物品数',
  create_request_order_template: '新增要货模板',
  template_del_confirm_is: '确定要删除模板【{{name}}】吗?',
  distributed_location_del_confirm_is: '确定要删除已下发门店【{{name}}】吗?',
  template_del_tip2: '注：总部模板删除后，门店下的该模板也随之删除',
  template_batch_delete_confirm_is: '确定要批量删除{{count}}个模板吗?',
  distributed_location_batch_delete_confirm_is: '确定要批量删除{{count}}个已下发的门店吗?',
  please_input_template_name: '请输入要货模板名称',
  add_location: '添加门店',
  suit_product_detail: '适用物品明细',
  suit_product_import_tmpl: '物品导入模板',
  please_select_delete_template: '请选择要删除的模板',
  please_select_delete_location: '请选择要删除的门店',
  require_goods_template: '要货模板',
  please_select_require_goods_template: '请选择要货模板',
  remove: '移除',
  batch_remove: '批量移除',
  please_select_delete_product: '请选择要移除的物品',
  past_quarter: '近90天',
  past_year: '近一年',
  del_request_template_with_no: '删除要货模板[{{id}}]',
  export_request_template_detail: '导出要货模板菜品',
  import_request_template_detail: '导入要货模板菜品',
  total_count: '共 {{totalCount}} 条',
  progressing: '进行中',
  not_started_yet: '未开始',
  ended: '已结束',
  remark_msg: '备注信息',
  date: '日期',
  time: '时间',
  ordering_control_tip: '针对相同活动时间，相同门店，同一时刻仅生效最新更新的方案',
  ordering_control_detail_tip:
    '注：如果应用门店存在要货模板，则必订物品需同时添加在对应要货模板内且必须是总部已下发给门店的物品，否则无效',
  new_plan_added: '新增方案',
  plan_name: '方案名称',
  activity_time: '活动时间',
  activity_cycle: '活动周期',
  repeat_every_day: '每天重复',
  repeat_every_week: '每周重复',
  repeat_every_month: '每月重复',
  activity_time_period: '活动时间段',
  orderable_date: '可订货日期',
  orderable_time: '可订货时间',
  min_order_amount: '最小起订金额',
  number_of_mandatory_items: '必订物品数',
  last_editor: '最后编辑人',
  certain_items: '必订物品',
  confirm_delete_order_control: '确定要删除必订货方案{{name}}吗？',
  order_control: '门店订货控制',
  order_control_import_template: '门店订货控制导入模板',
  export_order_control_detail: '导出门店订货控制明细',
  import_order_control_detail: '导入门店订货控制明细',
  designated_time_period: '指定时间段',
  please_select_activity_time: '请选择活动时间',
  unrestricted: '不限制',
  fixed_date: '固定日期',
  fixed_week: '固定星期',
  edit_order_control: '编辑门店订货控制',
  additional_order_control: '新增门店订货控制',
  copy_order_control: '复制门店订货控制',
  please_enter_order_control_name: '请输入门店订货控制方案名称',
  permanent_validity: '永久有效',
  fixed_time: '固定时间',
  participation_rules: '参与规则',
  please_select_used_location: '请选择应用门店',
  specific_time_period: '特定时间段',
  after_folding: '折后',
  before_folding: '折前',
  ordering_unit: '订购单位',
  click_date: '点击选择日期，再次点击取消',
  click_week: '点击选择星期，再次点击取消',
  start_time: '开始时间',
  end_time: '结束时间',
  default_delivery_date: '默认期望送达日期',
  default_delivery_date_tip:
    'N天后，表示订货日期+n为期望送达日期。例：若为0，则表示当日；为1则表示次日',
  order_control_save_tip: '以下菜品同活动时间内，已存在门店订货控制方案',
  order_control_plan: '门店订货控制方案',
  add_up_to_six_rows: '最多添加六行',
  please_select_fixed_date: '请选择固定日期',
  please_select_fixed_week: '请选择固定星期',
  please_select_specific_time_period: '请选择特定时间段',
  start_time_cannot_be_empty: '可订货时间的开始时间不能为空',
  end_time_cannot_be_empty: '可订货时间的结束时间不能为空',
  start_time_must_be_less_than_end_time: '可订货时间的结束时间必须大于开始时间',
  specific_time_periods_cannot_overlap: '特定时间段不能重叠',
  kilogram: '公斤',
  reimport: '重新上传',
  request_order_product_detail_template: '要货模板导入明细',
  new_query_template: '新增查询模板',
  query_template_range: '查询模板范围',
  please_select_tmplate: '请选择要操作的模板',
  template_batch_del_tip: '确定要批量删除{{id}}个模板吗？',
  template_del_tip: '确定要删除模板【{{name}}】吗？',
  edit_query_template: '编辑查询模板',
  item_delivery: '物品下发',
  send_to_stores: '下发门店',
  distributed_by_head_office: '总部下发',
  self_built_store: '门店自建',
  product_confirm_associates_is: '此物品已被业务关联使用，不可删除！',
  view_xiafa_stores: '查看下发门店',
  the_stores_that_have_been_distributed: '已下发的门店如下',
  store_type: '门店类型',
  query_template: '查询模板',
  choose_template: '选择模板',
  batch_item_distribution: '批量物品下发',
  business_information: '业务信息',
  daily_inventory: '日盘点',
  weekly_inventory: '周盘点',
  monthly_inventory: '月盘点',
  other_inventory: '其他盘点',
  please_select_items_to_distributed: '请选择要下发的物品',
  item_enquiry_template: '物品查询模板',
  item_enquiry_template_detail: '物品查询模板导入明细',
  check_type_tooltip: '盘点时可以通过此处的盘点类型，快速过滤物品带入盘点单',
  clear_selected_items: '将已选的物品清空',
  inventory_cost_in_money: '调整入库金额',
  inventory_cost_out_money: '调整出库金额',
  basic_parameter: '基本参数',
  procurement_management: '采购管理',
  delivery_management: '配送管理',
  basic_file: '基础档案',
  return_order_parameters: '收退货单参数',
  history_record: '历史记录',
  modify_records: '修改记录',
  basic_file_setting: '基础档案设置',
  procurement_management_setting: '采购管理设置',
  delivery_management_setting: '配送管理设置',
  only_keep_records_for_the_last_6_months: '仅保留最近6个月的记录',
  inventory_management: '库存管理',
  inventory_parameters: '库存参数',
  how_to_convert_virtual_items: '门店入库时，虚拟物品转换方式',
  transfer_actual_items: '转实际物品',
  not_transferring_actual_items: '不转实际物品',
  actual_items_spec1:
    '应用场景一：门店只需订货鸡翅，不问品牌，但配送中心有多个品牌，一段时间会更换。',
  actual_items_desc1:
    '订货转实际品项，订虚拟品项、提交为实际品项、发实际品项、入库实际品项、扣减实际品项、盘点实际品项。',
  actual_items_spec2:
    '应用场景二：门店订货某个品牌的鸡翅，到货后拆包后与其它品牌的混在一些，无法分辨。',
  actual_items_desc2:
    '不转实际品项，订实际品项、提交为实际品项、发实际品项、入库虚拟品项、扣减虚拟品项、盘点虚拟品项。',
  inventory_management_setting: '库存管理设置',
  search_virtualItem_title: '物品编码、sku、条码、速记码、名称',
  virtual_item_list: '虚拟物品列表',
  associated_with_actual_item_list: '关联实际物品列表',
  virtual_item_desc: '虚拟物品只能关联基本单位一致的实际物品',
  virtual_item: '虚拟物品',
  actual_item: '实际物品',
  related_to_actual_items: '关联实际物品',
  conversio_rate_base: '换算率(基本)',
  please_select_virtual_item_first: '请先选择一个虚拟物品',
  cost_card_can_be_set_up: '可设立成本卡',
  cost_card_can_be_set_up_tip: '可设立成本卡，在配置成本卡可选择虚拟物品',
  hibernate_tip: '休眠：不允许要货，要货流程中不显示该虚拟物品',
  historical_receipt_price: '历史收货价',
  receipt_number: '收货单据号',
  audit_date: '审核日期',
  headquarters_products_distributed_to_the_store: '总部创建物品后，自动下发到门店',
  managing_products_distributed_to_the_store: '销售端菜品库存管理后，自动下发到门店',
  third_party_products_distributed_to_the_store: '三方菜品同步到总部后，自动下发到门店',
  automatically_distributed_to_the_store:
    '在用零售进销存的几个客户，开启下‘’三方菜品同步到总部后，自动下发到门店',
  priority_order: '优先级顺序',
  product_move_confirm_is: '确认是否移动物品?',
  add_virtual_management: '请先添加一个虚拟物品和一个实际物品',
  actual_item_base_unit_rate_cannot_be_0: '换算率不能为0',
  delivery_price__desc_tooltip: '配送价: 物品每基本单位的单价',
  create_virtual_with_name: '创建虚拟物品档案{{name}}',
  edit_virtual_with_name: '编辑虚拟物品档案{{name}}',
  edit_kit_with_name: '编辑成套件物品{{name}}',
  virtual_confirm_is:
    '删除后不可恢复，确认要删除此虚拟物品吗？注：物品删除后，门店下的该物品也随之删除。',
  del_request_virtual_with_no: '删除虚拟物品档案[{{id}}]',
  del_request_kit_items_with_no: '删除成套件档案[{{id}}]',
  virtual_item_delivery: '虚拟物品下发',
  categories_without_items: '管家APP补货，不显示没有物品的物品分类',
  no_category_item_move: '无类别分类不能移动',
  no_category_item: '无类别',
  change: '更换',
  change_replace_product: '更换替代物品',
  please_input_product: '名称、编码、助记码搜索物品',
  please_select_an_actual_item_first: '请先选择一个实际物品',
  edit_request_document: '编辑物品档案信息',
  save_request_document: '新增物品档案信息',
  product_location_confirm_is: '注：物品删除后，门店下的该物品也随之删除。',
  users_not_allowed_modify: '用户不允许修改，如需修改，请联系乐檬客服人员',
  upload_image: '上传图片',
  add: '添加',
  only_keep_records_for_the_last_12_months: '仅保留最近12个月的记录',
  transfer_out_price: '调出单价',
  transfer_in_price: '调入单价',
  in_transit_money: '在途金额',
  in_transit_base_qty: '在途基本数量',
  product_memo: '物品备注',
  suppiler_email: '电子邮件',
  product_related_request_order_desc: '该物品关联要货单，更换后将同步跟换要货单内物品',
  please_input_processed_product_title: '请输入加工品名称',
  please_input_raw_materials: '请输入原材料名称',
  recipe_level: '配方层级',
  legend: '图例',
  new_recipe: '新增配方',
  positive_relationship_diagram: '正向关系图',
  export_Picture: '导出',
  virtual_confirm_location_is: '物品删除后不可恢复，是否确认删除？',
  formula_layers: '配方层数',
  other_parameters: '其他参数',
  purchase_approve: '采购单据第一次保存时，提示是否审核',
  transfer_approve: '连锁单据第一次保存时，提示是否审核',
  inventory_approve: '库存单据第一次保存时，提示是否审核',
  please_select_store_name: '请选择一个加工间',
  review_immediately: '单据保存成功，是否立即进行审核?',
  select_processed_item: '选择加工品',
  audit_failed: '审核失败',
  check_order_qty: '实盘数',
  check_order_stock_qty: '账面数',
  local_actual_money: '账面金额',
  check_order_money: '实盘金额',
  check_order_base_qty: '基本单位实盘数',
  check_order_base_stock_qty: '基本单位账面数',
  win_loss_money: '盈亏金额',
  check_diff: '盘点差异',
  total_summary: '总合计',
  check_win_count: '盘盈数量',
  check_win_unit_price: '盘盈入库单价',
  check_win_money: '盘盈金额',
  check_loss_count: '盘亏数量',
  check_loss_unit_price: '盘亏出库单价',
  check_loss_money: '盘亏金额',
  summary_of_procurement_classifications: '采购分类汇总',
  summary_of_supplier_classifications: '采购供应商汇总',
  summary_of_supplier_location: '供应商-门店汇总',
  summary_of_supplier_product: '供应商-物品汇总',
  summary_of_supplier_product_type: '供应商-物品分类汇总',
  multi_unit_check: '多单位盘点',
  default_store_spec: '设为加工间时，可同时做为加工品的管理仓库使用',
  negative_inventory_deductions: '负库存扣减',
  not_allowed_except_pos_sales: '不允许（POS销售除外）',
  allow_negative_inventory: '允许所有业务负库存扣减',
  all_businesses_include:
    '所有业务包括，调出单、入库单作废、采购收货单作废、退货发货、库存调整出库、库存盘亏出库、转仓出库、生产领料出库、生产出库',
  awaiting_receipt: '待收货',
  partial_receipt: '部分收货',
  receipt_completed: '收货完成',
  receipt_close: '收货关闭',
  receipt_status: '收货状态',
  downstream_order_number: '下游单号',
  expected_date_delivery: '期望送达日期',
  classification_type: '分类类型',
  system_created: '系统创建',
  manually_created: '手动创建',
  allow: '允许',
  not_allowed: '不允许',
  change_tips_del_goods_formula: '切换加工间会清空加工品原料填入的信息，是否确认操作？',
  file_name: '文件名',
  size: '大小',
  upload_time: '上传时间',
  uploader: '上传人',
  download: '下载',
  please_select_file: '请选择文件',
  choose_file: '添加文件',
  batch_download: '批量下载',
  upload_tips: '支持上传图片、文档等格式，最大不超过10MB，最多上传15个',
  upload_max_tip: '最多上传15个文件',
  upload_exceeded_tip: '{{names}}大小超过10M，请重新上传',
  batch_distribution: '批量下发',
  distributed_locations: '已下发门店',
  latest_distributed_date: '最近下发时间',
  terminate: '中止',
  related_purchase_receipt: '关联采购收货单',
  setting_location: '设置门店',
  request_order_use_template_config: '门店要货必须通过门店要货模板',
  kit_item_request_check_rate: '成套件物品要货时校验配件比例',
  template_used_location_config: '已应用{{count}}家门店',
  use_template_add: '通过要货模板新增',
  discontinued: '已中止',
  pending_partial_receipt: '待收货、部分收货',
  receive_order_no: '采购收货单号',
  purchase_order_no: '采购订单号',
  save_and_distribute: '保存并下发',
  read_purchase_return_order: '查看采购退货单',
  processed_product_production: '加工品生产',
  processed_product_production_desc:
    '生产计划单在生产看板中发生过原料领料或加工品生产，无法反审核。不可跨门店原料领料、加工品生产，请重新筛选后再操作',
  processed_product_desc: '加工品生产成功，可至生产入库单中继续操作。生成{{num}}张生产入库单',
  processed_product_production_success: '加工品生产成功',
  the_following_processed_products_cannot_generate: '以下加工品不可生成领料单',
  reason_cannot_be_generated: '不可生成领料单原因',
  input_code_sku: '物品编码、名称',
  overview_of_processed_products: '加工品总览',
  picking_date: '领料日期',
  processing_quantity: '加工数量',
  machining_room_allowance: '加工间余量',
  theoretical_picking_quantity: '理论领料数量',
  theoretical_consumption_of_work_in_progress: '在制品理论耗用量',
  estimated_picking_quantity: '预估领料数量',
  actual_picking_quantity: '实际领料数量',
  quantity_received_by_basic_unit: '基本单位领料数量',
  basic_unit_inventory_balance: '基本单位库存余量',
  picking_warehouse: '领料仓库',
  picking_warehouse_desc: '领料仓库，按仓库物品规则',
  theoretical_consumption_of_work_in_progress_desc:
    '在制品理论耗用量：未审核的生产入库单对应原料占用的数量',
  estimated_picking_quantity_desc:
    '预估领料数量=本加工品理论领料数量-（原料加工间库存余量-在制品理论原料耗用量）',
  edit_the_actual_quantity_received_with_one_click: '一键编辑实际领用数量',
  one_click_picking_quantity: '一键编辑 实际领料数量 = 理论领料数量',
  one_click_estimated_picking_quantity: '一键编辑 实际领料数量 = 预估领料数量',
  one_click_theoretical_piking_quantity: '一键编辑 实际领料数量 =理论领料数量 - 加工间余量',
  picking_order_number: '领料单号',
  the_picking_is_successful: '领料成功，可以去生产领料单中查看，单据如下',
  current_inventory_of_the_processing: '加工品所在加工间仓库的当前库存',
  expected_date_of_arrival: '期望到货日期',
  purchase_order_details: '采购订单明细',
  purchase_order_summary: '采购订单汇总',
  order_items_summary: '订单物品汇总',
  order_suppliers_summary: '订单供应商汇总',
  purchase_order_number: '采购单号',
  purchase_aprice: '采购单价',
  purchase_num: '采购数量',
  purchase_num_base_unit: '采购数量(基本单位)',
  gift_quantity_base_unit: '赠品数量(基本单位)',
  purchase_money: '采购金额',
  already_received_quantity: '已收货数量',
  already_received_quantity_base_unit: '已收货数量(基本单位)',
  number_of_returned_goods: '已退货数量',
  number_of_returned_goods_base_unit: '已退货数量(基本单位)',
  tip_processed_products: '提示：以下加工品不可生成领料单',
  modify_request_template_tip:
    '1、同一个配送中心和同一个要货门店，可以存在多个要货模板；2、物品在此处配置后，仍然需要下发给对应门店，在门店要货中才可以选择到；',
  purchase_barcode_desc: '暂无业务使用，待后期更新',
  base_unit_qty_and_use_unit_qty_are_required: '领料数量不能为0',
  the_following_processed_order_cannot_generate: '以下加工品不可生成生产任务',
  receive_auto_update_price: '采购收货自动维护档案对应单位的采购单价',
  import_product_formula_prop: '导入配方属性',
  export_transfer_out_formula: '导出配方单',
  select_accroding_to_machining: '按加工间余量不足选中',
  select_semifinished_product: '选中半成品',
  is_semifinished_product: '是否半成品',
  uncheck_semi_finished_product: '取消选中半成品',
  please_choose_expected_date_delivery: '请选择期望送达日期',
  summary_by_location_items: '按门店-物品汇总',
  operation_date: '操作日期',
  summary_by_location_itemtype: '按门店-分类汇总',
  production_receiving_material_inventory: '生产领料入库',
  production_material_out_stock: '生产领料出库',
  production_in_storage: '生产入库',
  production_out_storage: '生产出库',
  bring_to_account: '盘盈入库',
  out_to_account: '盘亏出库',
  retail_other_entries: '(零售)其他入库',
  retail_other_outgoings: '(零售)其他出库',
  retail_reutrn_storage: '(零售)退货入库',
  retail_sell_out: '(零售)销售出库/退货',
  Delivery_price_tip:
    '配送价：加盟店新增要货单，或配送中心给加盟店做调出单时的默认价格<br/>配送价取值顺序：物品配送属性里的门店配送价>档案配送价',
  please_input_delivery_prices: '请输入配送价（元）',
  reocrd: '日志',
  operate_date: '操作日期',
  production_management: '生产管理',
  production_approve: '生产单据第一次保存时，提示是否审核',
  reason_for_modification: '修改原因',
  puchase_upload: '采购单[{{orderNo}}]上传附件',
  receive_upload: '采购收货单[{{orderNo}}]上传附件',
  return_upload: '退货单[{{orderNo}}]上传附件',
  default_purchasing_unit: '默认采购单位',
  default_purchase_unit_price: '默认采购单价',
  default_shipping_unit: '默认配送单位',
  default_shipping_price: '默认配送价',
  headquarters_file_data: '总部修改物品档案，覆盖已下发总部档案数据',
  warehouse_item_rules: '仓库物品规则',
  print_template_settings: '打印模板设置',
  del_request_warehouse_with_no: '删除仓库物品规则[{{id}}]',
  edit_warehouse_item: '编辑仓库物品规则[{{id}}]',
  del_request_store_with_no: '删除仓库[{{name}}]',
  item_query_template: '物品查询模版',
  accounting_period: '会计期',
  del_item_query_template: '删除物品查询模版[{{name}}]',
  edit_item_query_template: '编辑物品查询模版[{{name}}]',
  create_item_query_template: '创建物品查询模版[{{name}}]',
  del_print_template_settings: '删除打印模板设置[{{name}}]',
  edit_print_template_settings: '编辑打印模板设置[{{name}}]',
  create_print_template_settings: '创建打印模板设置[{{name}}]',
  history_receive_price_tip_1:
    '物品明细-最近进价：取供货关系的最近进价，若是供货关系删除，那么历史最近进价会被一并删除。',
  history_receive_price_tip_2: '历史收货价：查询进出库明细，与供货关系无关。',
  puchase_setting: '采购订单参数',
  auto_generate_receive_order: '采购订单审核后，自动生成待审核状态的采购收货单',
  supplier_delivery: '供应商下发',
  required_for_purchasing: '采购单据业务员必选',
  required_for_production: '生产单据业务员必选',
  required_for_productStorage: '生产入库单允许添加配方以外的原材料',
  trace_material_of_semi_finished: '加工配方嵌套半成品领料时，追溯半成品配方原料（仅本加工间）',
  auto_generate_plan_across_produce_house:
    '配方中用到其他加工间的加工品时，自动生成跨加工间生产计划单',
  auto_generate_plan_across_produce_house_tip1:
    '当启用时，生产计划单审核时，如果有需要其他加工间加工的半成品，则自动生成其他加工间的生产计划单;',
  auto_generate_plan_across_produce_house_tip2:
    '当不启用时，下达生产计划单只会生成本加工品的生产计划单，不会生成嵌套品项的生产计划单;',
  required_for_delivery: '配送单据业务员必选',
  required_for_inventory: '库存单据业务员必选',
  supplier_data_instructions: '说明：总部下发会覆盖门店的供应商数据',
  product_data_instructions:
    '说明：下发至影响总部下发给门店的数据，门店自建的不影响。如果门店是加盟店，首次下发，门店成本价会应用档案配送价。',
  financial_management: '财务管理',
  financial_management_desc: '财务单据第一次保存时，提示是否审核',
  financial_document_clerks: '财务单据业务员必选',
  please_select_salesperson: '请选择业务员',
  operate_tips: '操作提示',
  whether_funds_are_settled: '是否资金结算',
  extra_points_for_delivery: '配送加点',
  lock_delivery_price: '按照参考成本进行锁定配送价固定加点',
  lock_delivery_points: '锁定配送加点',
  proportionately: '按比例',
  by_amount: '按金额',

  order_date: '订单日期',
  voucher_type: '单据类型',
  order: '订单',
  coupon_order: '卡券订单',
  order_refund: '订单退款',
  deposit_customer_refund: '客户储值退款',
  deposit_customer: '客户储值',
  card_order_refund: '卡券订单退款',
  deposit_refund_order: '订金退款单',
  business_receipts_audit: '营业收款稽核',
  reconciliation_status: '对账状态',
  reconciliation_finished: '对账完成',
  have_difference: '有差异',
  collection_type: '收款类型',
  business_receipts_description:
    '营业收款稽查主要用于乐檬餐饮业务系统数据与财务中心的支付/退款数据进行对比。如果数据一致，则对账正常，如果数据不一致，则显示有差异。',
  amount_of_receive_refund_money: '收款/退款金额',
  number_of_receive_refund: '收款/退款笔数',
  amount_of_lemon_pay: '乐檬支付金额',
  number_of_lemon_pay: '乐檬支付笔数',
  amount_of_difference: '差异金额',
  number_of_difference: '差异笔数',
  difference_data: '差异数据',
  difference_info: '差异信息',
  lemon_pay_no_data: '乐檬支付无数据',
  system_no_data: '业务系统无数据',
  lemon_store_pay_data: '乐檬餐饮商户中心与支付数据不一致',
  pay_flow_document_no: '交易流水号',
  document_sale_no: '业务单据号',
  lemon_pay_data: '乐檬支付数据',
  document_time: '单据时间',
  difference_error_info: '差错信息',
  pay_start_time: '支付开始时间',
  pay_end_time: '支付结束时间',
  amount_of_receive_money: '收款金额',
  amount_of_refund_money: '退款金额',
  card_order: '卡券订单',
  shiftNumber: '班次号',
  handover_person: '交班人',
  opening_time2: '开班时间',
  shift_handover_time: '交班时间',
  collection_for_this_shift: '本班次收款',
  shift_handover_statistics: '交班统计',
  receipt_statistics_description1:
    '1.本班次收款：统计本班次记入实收的支付方式的总金额，需要统计签单还款的部分，且不包括签单、企业支付、余额支付、礼品卡支付、积分抵扣。',
  receipt_statistics_description2: '2.点击查看可查看详情。',
  cash_pay: '现金支付',
  origin_petty_cash: '领用备用金',
  amount_put_in: '放入金额',
  amount_put_out: '取出金额',
  expected_cash: '预期现金',
  cash_received: '实收现金',
  diff_money_short: '差额',
  composition_of_business_incentives: '营业优惠构成',
  business_composition: '营业构成',
  member_consumption_statistics: '会员消费统计',
  shift_handover_details: '交班详情',
  discount_type_01: '优惠类型',
  collection_statistics: '挂账统计',
  deposit_statistics: '订金统计',
  sale_shift_order: '交班单',
  number_of_receive: '收款笔数',
  subtotal_of_receipts: '收款小计',

  statistics_dimension: '统计维度',
  order_source: '订单来源',
  wechat_miniprogram: '微信小程序',
  web_admin: '网页后台',
  oms_mt: '美团外卖',
  oms_elm: '淘宝闪购·餐饮',
  oms_elm: '淘宝闪购·餐饮',
  miniprogram: '平台小程序',
  oms_eb: '淘宝闪购·零售',
  oms_eb_tb: '淘宝闪购·零售',
  douyin_takeout: '抖音外卖',
  alipay_mini_program: '支付宝小程序',
  tiktok_self_verification: '抖音自助核销',
  date_range: '日期范围',
  all_range: '所有',
  search_order_source: '搜索订单来源',
  adjustment_enterprise_credit_limit_log:
    '{{changeType}}挂账企业[{{enterpriseName}}]授信额度{{creditLimitValue}}',
  enter_adjust_reason: '请输入调整原因',
  adjustment_credit_limit: '授信额度调整',
  please_enter_credit_limit: '请输入授信额度',
  adjustment_method: '调整方式',
  increase_limit: '增加额度',
  reduce_limit: '减少额度',
  adjustment_limit: '调整额度',
  adjustment_credit_limit_success: '授信额度调整成功',
  confirm_delete_enterprise: '确定删除企业，删除后无法恢复',
  debtor_enterprise: '挂账企业',
  group_meal_status: '团餐状态',
  head_enterprise_ledger_management: '总部企业挂账管理',
  store_enterprise_ledger_management: '门店企业挂账管理',
  head_people_ledger_management: '总部个人挂账管理',
  store_people_ledger_management: '门店个人挂账管理',
  peeson_ledger_management: '个人挂账管理',
  enterprise_ledger_management: '企业挂账管理',
  nature_of_enterprise: '企业性质',
  credit_line: '挂账额度',
  amount_charged: '已挂账金额',
  remain_pending_account_money: '剩余挂账金额',
  create_payee: '创建挂账人',
  edit_payee: '编辑挂账人',
  read_payee: '查看挂账人',
  name_debtor: '挂账人名称',
  repayment_history: '还款记录',
  quota_change: '额度变动',
  charge_record: '挂账记录',
  nationalized: '国有企业',
  private: '私营企业',
  foreing_invested: '外商投资企业',
  collectively_owned: '集体所有制企业',
  joint_stock: '股份制企业',
  limited_partnership: '有限合伙企业',
  affiliates: '联营企业',
  sole_proprietoreship: '个人独资企业',
  unknown_enterprise: '未知性质企业',
  edit_enterprise_staffs: '编辑企业',
  read_enterprise_staffs: '查看企业',
  create_enterprise_staffs: '创建企业',
  enterprise_name: '企业名称',
  enter_enterprise_name: '请输入企业名称',
  enterprise_staff: '企业客户',
  enterprise_LOGO: '企业LOGO',
  enterprise_profile: '企业简介',
  please_enter_enterprise_profile: '请输入企业简介',
  please_enter_the_debit_amount: '请输入挂账额度',
  group_meal_rule: '团餐规则',
  enable_group_meals: '启用团餐',
  credit_discount: '挂账优惠',
  no_discount: '无优惠',
  discount_ratio: '优惠比例',
  maximum_99: '最大值99',
  credit_discount_tips: '如20%，则挂帐时优惠20%',
  delete_address: '删除地址',
  update_address: '修改地址',
  add_group_meal_address: '添加地址',
  address_max: '支持最多添加10个地址',
  local_deliver_address: '配送地址',
  enterprise_employee: '企业员工',
  on_job: '在职',
  leave_job: '离职',
  entry_job: '入职',
  does_support_account_suspension: '是否支持挂账',
  supports: '支持',
  not_supports: '不支持',
  staff_status: '员工状态',
  confirm_staff: '确认员工',
  entry_job_tips: '确认入职后，该员工将重新成为企业员工。',
  leave_job_tips: '确认离职后，员工将会从企业中移除，不再享受企业权益，成为普通会员身份!',
  not_query_more_staff_info: '未查询到更多员工信息',
  create_enterprise_employee: '创建企业员工',
  search_staff_phone: '搜索员工手机号',
  affiliated_enterprise: '所属企业',
  please_enter_staff_name: '请输入员工姓名',
  password_check_one: '请输入6位纯数字密码',
  password_check_two: '请输入正确的数字密码',
  staff_full_name: '员工姓名',
  support_account_suspension: '支持挂账',
  payment_password: '支付密码',
  read_enterprise_ledger_staff_list: '查看企业挂账员工列表',
  read_enterprise_staff_list: '查看企业员工列表',
  read_enterprise_staff_info: '查看企业员工[{{staffName}}]的信息',
  edit_enterprise_staff_info: '编辑企业员工[{{staffName}}]的信息',
  create_enterprise_staff: '创建企业员工[{{staffName}}]',
  confirm_staff_entry_job: '确认员工入职',
  confirm_staff_leave_job: '确认员工离职',
  create_enterprise_ledger_staff_info: '创建企业挂账员工[{{staffName}}]的信息',
  edit_enterprise_ledger_staff_info: '编辑企业挂账员工[{{staffName}}]的信息',
  debtor: '挂账人',
  canteen_food: '堂食',
  takeaway: '外卖',
  self_pick: '自提',
  business_scenario: '业务场景',
  search_business_scenario: '搜索业务场景',
  description_statements: '功能说明',

  report_description: '报表说明',
  business_discounts_tips:
    '系统菜品订单营业优惠，包括：储值卡赠送金额支付、积分抵扣支付、营销活动折扣、券优惠等',
  business_discounts_report: '营业优惠报表',
  business_flow: '营业流水',
  business_income: '营业收入',
  business_discounts: '营业优惠',
  business_discounts_analysis: '营业优惠分析',
  order_no_normal: '订单号',
  search_for_order_number: '搜索订单号',
  cashier: '收银员',
  business_refund_statistic: '营业退款统计',
  sign_payment_detail: '挂账明细',
  composition_payment_method: '支付方式构成',
  business_discounts_composition: '营销优惠构成',
  busincess_income_composition: '营业收入构成',
  sales_item_composition: '销售品项构成',
  composition_of_marketing_discounts: '营业优惠构成',
  original_order_no: '原订单号',
  return_time: '退单时间',
  performance_mode: '业务类型',
  customer_name: '客户姓名',
  customer_name2: '客户名称',
  contact_number: '联系电话',
  shipping_address: '收货地址',
  refund_or_return_reason: '退款/退货原因',
  order_created_at2: '下单时间',
  statistical_indicators: '统计指标',
  single_average_after_discount: '折后单均',
  number_of_valid_orders: '有效订单数',
  average_before_discount: '折前单均',
  statistical_cycle: '统计周期',
  month_range: '月份范围',
  date_on: '按日期',
  by_month: '按月份',
  channel_business_statistic_tip_1:
    '营业收入：系统菜品订单扣除营业优惠后的金额，不包括卡券订单。营业收入=营业流水-营业优惠',
  channel_business_statistic_tip_2:
    '营业优惠：系统菜品订单营业优惠，包括：储值卡赠送金额支付、积分抵扣支付、营销活动折扣、券优惠等',
  channel_business_statistic_tip_3: '营业流水：菜品订单优惠前金额',
  channel_business_statistic_tip_4:
    '营业外收入：除菜品订单外的其他收入，包括储值卡、优惠券包、权益卡、礼品卡、挂账还款、订金等，不包括三方卡券订单',
  channel_business_statistic_tip_5:
    '有效订单数：去除已全部退款的订单数，有效订单数=订单数-退款订单数',
  channel_business_statistic_tip_6: '折前单均：营业流水/有效订单数',
  channel_business_statistic_tip_7: '折后单均：营业收入/有效订单数',
  channel_business_statistic: '渠道营业统计',
  operating_revenue: '营业收入',
  phone_num: '手机号',
  please_enter_your_mobile_number: '请输入手机号码',
  member_card_no: '会员卡号',
  card_type_name: '卡类型名称',
  deduction_store: '扣款门店',
  deduction_amount: '扣款金额',
  principal_deduction: '扣款本金',
  deduction_bonus: '扣款赠金',
  amount_after_deduction: '扣款后金额',
  deduction_time: '扣款时间',
  deduction_order_no: '扣款单号',
  related_consumption_order_no: '关联消费单号',
  deduction_channel: '扣款渠道',
  product_marketing_tips:
    '菜品营销统计：主要对优惠券使用的菜品进行分析，统计优惠券抵扣的菜品使用数量及金额。',
  regional_dimension: '区域维度',
  dining_area: '餐区',
  stage: '台位',
  stage_area: '台位区域',
  stage_name: '台位名称',
  search_for_stage_name: '请输入台位名称',
  table_tips1:
    '可按门店、台位区域、台位查看对应的营业流水、营业收入、营业优惠、用餐人数、人均、桌均等营业情况。',
  table_tips2:
    '台位区域、台位是按【设置】【门店设置】中信息进行划分，如需调整，可在【设置】【门店设置】中修改。',
  table_tips3: '开台率：消费桌数/台位数的百分比，用于衡量餐厅的餐桌使用效率。',
  table_tips4: '翻台率：餐桌重复使用率的意思，公式为：（消费桌数-台位数）/台位数*100%',
  table_tips5: '上座率：用餐人数/区域台位总人数上限*100%',
  table_tips6: '折前桌均：营业流水/消费桌数',
  table_tips7: '折后桌均：营业收入/消费桌数',
  table_tips8: '折前人均：营业流水/用餐人数',
  table_tips9: '折后人均：营业收入/用餐人数',
  table_tips10: '其他说明：如果就餐时不用选择就餐人数，则统计时就餐人数取1。',
  table_tips11: '用餐人数：针对堂食订单，用餐人数取开台人数，如果是扫码点餐，就取扫码选择的人数',
  number_of_stations: '台位数',
  area_stage_total_num: '区域台位总人数',
  station_type: '台位类型',
  stage_num: '台位人数',
  consume_table: '消费桌数',
  eat_num: '用餐人数',
  discount_front_table_average: '折前桌均',
  discount_late_table_average: '折后桌均',
  discount_front_num_average: '折前人均',
  discount_late_num_average: '折后人均',
  service_charge: '服务费',
  start_rate: '开台率',
  turnover_rate: '翻台率',
  attendance: '上座率',
  average_meal_time_min: '平均用餐时间(分钟)',
  table_business_statistics: '餐区/台位营业统计',
  table_business_statistics_1: '餐区台位营业统计',
  time_dimension: '时间维度',
  closing_date: '结账日期',
  business_date2: '营业日期',
  search_product_or_attributes_name: '搜索菜品或属性名称',
  product_sales: '菜品销售',
  attribute_sales: '属性销售',
  package_fee_money: '包装费',
  delivery_fee: '配送费',
  sales_mix: '销售构成',
  product_package: '菜品+套餐',
  product_package_details: '菜品+套餐明细',
  product_only: '仅菜品',
  package_only: '仅套餐',
  package_details_only: '仅套餐明细',
  statistical_methods: '统计方式',
  product_or_attributes_name: '菜品/属性名称',
  average_unit_price: '平均单价',
  average_selling_price: '平均销售单价',
  number_of_flows: '流水数量',
  sale_man: '销售员',
  single_remark: '单品备注',
  order_remark: '整单备注',
  description_report8:
    '营业收入：系统菜品订单扣除营业优惠后的金额，不包括卡券订单。营业收入=营业流水-营业优惠',
  description_report9:
    '营业优惠：系统菜品订单营业优惠，包括：储值卡赠送金额支付、积分抵扣支付、营销活动折扣、券优惠等',
  description_report10: '营业流水：菜品订单优惠前金额',
  description_report11:
    '营业外收入：除菜品订单外的其他收入，包括储值卡、优惠券包、权益卡、礼品卡、挂账还款、订金等，不包括三方卡券订单',
  description_report12: '退款金额：完成退款订单的实收部分合计，只统计菜品订单。',
  description_report13: '订单数：包含退款订单的所有菜品订单数，不包含已取消的订单',
  description_report14: '有效订单数：去除已全部退款的订单数，有效订单数=订单数-退款订单数',
  description_report15: '退款订单数：全部退款的订单数',
  category_sales_ranking_report1: '菜品点击率：该菜品销售订单数占所有菜品销售订单数的百分比',
  category_sales_ranking_report2: '客流量：这段时间内所有销售订单客户数量去重',
  category_sales_ranking_report3: '平均单价：流水金额/流水数量',
  category_sales_ranking_report4: '平均销售单价：销售金额/销售数量',
  description_report20: '平均单价：流水金额/流水数量',
  description_report21: '下单数量：等于流水数量+退款数量',
  description_report22: '流水数量：等于销售数量+赠品数量',
  description_report22_2: '流水数量：等于销售数量（除赠品）+赠品数量',
  description_report23: '下单金额：等于流水金额+退款金额',
  description_report24: '流水金额：等于销售金额+优惠金额',
  description_report25: '赠品金额：赠品原价金额',
  description_report26: '未关联菜品类别包括菜品属性/加料、包装费、配送费、第三方平台未关联的菜品',
  product_sales_summary: '菜品销售汇总',
  sku_item_number: 'SKU （货号）',
  area: '区域',
  shop: '店铺',
  mall_product_order: '商城订单',
  points_redemption_order: '积分兑换订单',
  express_mall_statistics_tip_1:
    '商城营业收入：系统商城订单扣除营业优惠后的金额，商城营业收入=商城营业流水-商城营业优惠',
  express_mall_statistics_tip_2: '商城营业优惠：系统商城订单营业优惠，包括：积分抵扣金额等',
  express_mall_statistics_tip_3: '商城营业流水：系统商城订单优惠前金额',
  express_mall_statistics_tip_4: '退款金额：完成退款订单的实收部分合计，只统计商城订单。',
  express_mall_statistics_tip_5:
    '有效订单数：去除已全部退款的商城订单数，有效订单数=订单数-退款订单数',
  express_mall_statistics_tip_6: '退款订单数：全部退款的商城订单数',
  mall_business_flow: '商城营业流水',
  mall_operating_income: '商城营业收入',
  mall_business_discounts: '商城营业优惠',
  refund_order_number: '退款订单数',
  total_refund_money: '退款金额',
  express_mall_statistics: '快递商城统计',
  order_type1: '订单类型',
  statistical_interval: '统计间隔',
  signle_average_price: '单均价',
  passenger_flow: '客流',
  order_avg_price: '客单价',
  per_diner: '用餐人均',
  session_business_statistics: '餐/时段营业统计',
  performance_mode_composition: '业务场景构成',
  single_point_sales: '单点销量',
  sing_point_amount: '单点金额',
  sales_within_the_package: '套餐内销量',
  package_amount: '套餐金额',
  card_type: '卡类型',
  customer_custom_value_report: '会员扣款记录',
  dining_type: '就餐方式',
  query_by_store_code_and_name: '搜索门店代码或者名称(多个逗号分隔)',
  franchise_store: '加盟店',
  direct_store: '直营店',
  goods_summary: '菜品汇总',
  order_quantity_01: '下单数量',
  order_amount: '下单金额',
  flow_money: '流水金额',
  refund_flow: '退款流水',
  sales_number_except_gift: '销售数量(除赠品)',
  sale_money: '销售金额',
  for_sale_all_amount: '优惠金额',
  platform_commission_money: '平台佣金',
  ref_order_count: '关联订单数',
  customer_click_through_rate_sales_quantity_customer_traffic: '顾客点击率：销售数量/客流量',
  product_sale_ranking: '菜品销售排行',
  commodity_barcode: '菜品条码',
  sales_number: '销售数量',
  number_of_sales_orders_for_goods: '菜品销售订单数',
  order_numbers: '订单数',
  product_click_through_rate: '菜品点击率',
  customer_click_through_rate: '顾客点击率',
  search_goods_category: '搜索菜品类别',
  store_wants_goods: '门店要货',
  please_select_distribution_warehouse: '请选择配货仓库',
  distribution_warehouse: '配货仓库',
  choose_customer: '选择客户',
  name_phone_card_no: '客户姓名/手机号/关联卡号',
  deposit_source: '储值来源',
  deposit_type: '储值类型',
  store_value_increase_balance: '储值（增加余额）',
  store_value_reduce_balance: '储值（减少余额）',
  adjust_fact_recharge: '调整本金',
  merchant_import: '商户导入',
  re_deposital: '客户储值退款',
  customer_recharge: '客户储值',
  merchant_recharge: '商户充值',
  gift_consume: '消费有礼',
  collect_card: '注册有礼',
  gift_level: '升级有礼',
  return_without_order: '无单退款',
  card_no: '卡号',
  cutomer_name: '客户名称',
  phone_number: '手机号码',
  deposit_id: '储值单号',
  deposit_channel: '储值渠道',
  deposit_location: '储值门店',
  deposit_pay_type: '支付方式',
  deposit_money_count: '储值本金',
  gift_money_count: '储值赠金',
  deposit_money: '储值金额',
  after_deposit_money: '储值后余额',
  customer_stored_value_report: '会员储值明细',
  search_phone_cardNo_orderNo: '搜索手机号、卡号、订单号',
  cash_card: '现金卡',
  times_card: '菜品次卡',
  deposit_card: '储值卡',
  gift_card_buy: '礼品卡购买',
  gift_card_rebuy: '礼品卡购买退回',
  gift_card_consume: '客户消费',
  gift_card_refund: '客户消费退款',
  merchant_send_gift_card: '商家赠送礼品卡',
  fun_game_prize: '趣味竞猜奖品',
  cancel_payment: '取消支付',
  customer: '客户',
  gift_card_tmpls: '礼品卡模板',
  change_time: '变动时间',
  change_type: '变动类型',
  change_gift_money: '变动赠金',
  change_principal: '变动本金',
  change_location: '变动门店',
  gift_card_balance_log: '礼品卡明细',
  dynamic: '活跃',
  archived: '归档',
  draft: '草稿',
  has_been_active: '已生效',
  part_active: '部分失效',
  none_active: '全部失效',
  not_active: '未生效',
  card_tmpls_name: '卡模板名称',
  activated: '已激活',
  issued: '已发放',
  activation_rate: '激活率',
  cancel_money_or_times: '核销金额/次数',
  use_money_or_times: '可用余额/次数',
  sequence: '次',
  coupon_template_analysis: '券模板分析',
  gift_card_analysis: '卡模板分析',
  card_tmpl_kind: '卡模板类型',
  issue_date: '发放日期',
  write_off_date: '核销日期',
  full_reduce: '券模板',
  discount_coupon: '折扣券',
  reduce_minus_coupon: '立减券',
  freight_coupon: '运费券',
  exchange_voucher: '兑换券',
  exchange_coupon_a_b: '买A赠B券',
  free_pass: '限制数量免单券',
  s_coupon_reduction: '减至券',
  vouther_name_state: '券模板状态',
  expired: '已过期',
  not_started: '未开始',
  stoped: '已停用',
  write_off_store: '核销门店',
  write_off_channels: '核销渠道',
  usage_note: '用途备注',
  search_usage_note: '搜索用途备注',
  discount_ticket_tmpl_name: '券模板名称',
  full_reduce_id: '券模板ID',
  released_quantity: '发放数量',
  write_off_number: '核销数量',
  writeoff_rate: '核销率',
  write_off_money: '核销金额',
  pulling_amount: '拉动金额',
  pull_rate: '拉动率',
  sale_discount_income: '售券收入',
  category_sales_ranking: '类别销售排行',
  take_out_platform: '外卖平台',
  location_take_out_platform: '门店-外卖平台',
  OMS_Order_Analysis: '三方订单分析',
  platform_order_analysis_report: '三方订单分析报表',
  whether_virtual_phone: '是否为虚拟手机号',
  whether_system_custom: '是否为系统客户',
  customer_order_count: '客单量',
  sales_consumptions: '原材料销售消耗报表',
  sensitive_operation_report: '敏感操作统计',
  modified_quantity_amount: '修改数量金额',
  number_of_price_changes: '修改价格次数',
  modify_price_amount: '修改价格金额',
  number_of_gifts: '赠送次数',
  amount_of_gift: '赠送金额',
  number_deletions: '删除数量次数',
  number_deletions_amount: '删除数量金额',
  delete_order_qty: '整单删除次数',
  delete_order_money: '整单删除金额',
  discount_nu_qty: '单据折扣次数',
  discount_nu_money: '单据折扣金额',
  pending_orders: '挂单次数',
  number_of_returns: '退货次数',
  money_of_returns: '退货金额',
  inverse_closing_frequency: '反结账次数',
  inverse_closing_frequency_money: '反结账金额',
  money_box_was_opened: '打开钱箱次数',
  invalid_business_card_printing_form: '制卡单作废',
  gift_card_voided: '礼品卡作废',
  create_mark_up_purchase: '创建加价购',
  total_number_of_additional_purchases: '加购总件数',
  additional_purchase_amount: '加购金额',
  questionnaire_survey: '问卷调查',
  loading_questionnaire_survey: '正在加载 问卷调查',
  deleting_questionnaire_survey: '正在删除 问卷调查',
  ending_questionnaire_survey: '正在结束 问卷调查',
  create_questionnaire_survey: '创建问卷调查',
  questionnaire_upload_image_tip_1: '1、上传图片尺寸建议1:1，若不设置则用户端不展示',
  questionnaire_upload_image_tip_2: '2、添加【其他】项，用户端勾选后可输入文字，最多添加1个其他项',
  questionnaire_upload_image_tip_3: '3、最多可添加15个选项',
  max_add_n_options: '最多添加{{n}}个选项',
  satisfaction_evaluation: '满意度评价',
  service_attitude: '服务态度',
  service_speed: '服务速度',
  very_dissatisfying: '非常不满意',
  dissatisfying: '不满意',
  ordinary: '一般',
  satisfying: '满意',
  very_satisfying: '非常满意',
  mt: '美团',
  douyin: '抖音',
  ks: '快手',
  koubei: '口碑',
  deposite: '储值',
  gift_card: '礼品卡',
  benefit_card: '权益卡',
  discount_ticket_pack: '优惠券包',
  repay_on_account: '挂账还款',
  down_payment: '订金',
  search_performance_mode: '搜索业务类型',
  order_pay_status: '订单支付状态',
  partial_payment: '部分付款',
  already_paid: '已付款',
  partial_refund: '部分退款',
  refunded: '已退款',
  abolished: '已作废',
  request_refund_take_out_platform: '申请退款（外卖平台）',
  refuse_refund_take_out_platform: '拒绝退款 (外卖平台)',
  business_receipt_detail_text1:
    '1.支付金额：支付流水金额，例如余额支付100元（本金80赠金20），则支付金额为100元。',
  business_receipt_detail_text2:
    '2.支付优惠：支付金额中算作优惠部分的金额。例如余额支付100元（本金80赠金20），则优惠金额为20元。',
  business_receipt_detail_text3:
    '3.实收金额：支付金额中算作收入部分的金额。例如余额支付100元（本金80赠金20），则实收金额为80元。',
  pay_time: '支付时间',
  pay_money: '支付金额',
  payment_preference: '支付优惠',
  paid_in_amount: '实收金额',
  businessReceiptDetail: '营业收款明细',
  groupPurchaseCouponRecord: '三方券核销记录',
  amount_involved: '涉及金额',
  session_product_statistics: '餐/时段菜品统计',
  return_product_statistics_report: '退菜/退货统计',
  please_choose_allow_policy: '请选择门店要货',
  allow_request_rule_desc: '如果仅门店下,该物品设置不可要货，则仅该门店不允许要货',
  business_type: '业务类型',
  businessCategory: '业务大类',
  businessSubcategories: '业务小类',
  businessReceiptStatistics_text:
    '1.收款小计：统计该支付方式所有业务场景的支付总和，包括：营业收入、储值、礼品卡、权益卡、优惠券包、挂账还款、订金等',
  businessReceiptStatistics_text_new:
    '2.优惠券支付：券模板如果设置了券实收, 用了这个券实收的优惠券订单, 会统计成优惠券支付',
  businessReceiptStatistics_text1:
    '3.美团券支付是订单里面用的那张券实际支付的金额，例如在美团花5元买了一张券，使用券支付时，美团券支付5元',
  businessReceiptStatistics_text2:
    '4.抖音券支付是订单里面用的那张券实际支付的金额，例如在抖音花6元买了一张券，使用券支付时，抖音券支付6元',
  businessReceiptStatistics: '营业收款统计',
  please_input_sku: '请输入物品货号',
  business_store_number: '业务门店编号',
  business_store_name: '业务门店名称',
  check_store_number: '结算门店编号',
  check_store_name: '结算门店名称',
  cost_name: '费用项目',
  serial_number: '序号',
  real_total_sales_money: '菜品销售金额',
  registered_members: '注册会员数',
  sale_person_statistic: '销售员统计',
  received_the_number_coupons_received_statistical_period: '发放时间内优惠券发放的总数量',
  used_the_number_used_coupons_received_within:
    '发放时间内发放的优惠券中，核销日期内已核销的优惠券总数量',
  write_off_amount_coupon_template: '使用优惠券的订单中，优惠券核销的金额',
  active_order_sales_amount: '使用优惠券的订单销售金额',
  pulling_amount_tips:
    '除去优惠券优惠后的订单实付金额，举例：订单100元，优惠券抵扣30元，剩余70元实付金额即为拉动金额',
  pull_rate_tips: '拉动金额/核销金额，反映优惠券的拉动效果',
  verification_rate_tips: '核销率=发放数量/核销数量，代表发放的优惠券中，已核销的优惠券数量占比',
  event_order_customer_tips:
    '在发放时间内发放过优惠券的用户中，在核销时间内有核销记录的客户人数，需要去重',
  event_order_new_customer_tips:
    '在发放时间内发放过优惠券的用户中，在核销时间内有核销记录的新客人数，需要去重',
  sale_discount_income_tips: '在发放时间内发放的优惠券其购券实付金额合计',
  activity_customer_ordered: '拉动消费人数',
  activity_new_customer_ordered: '拉动消费新客',
  received_gift_ttips: '店铺已发放的礼品卡数量',
  active_count_tips: '店铺已激活的礼品卡数量',
  bound_total_amount_tips: '已激活总量/已发放总量',
  write_off_money_gift_tips: '使用礼品卡消费的金额',
  available_money_tips: '剩余礼品卡总余额金额',
  cancel_times_of_card: '使用菜品次卡核销的次数',
  left_times_of_card: '剩余菜品次卡可用次数',
  available_balance: '可用余额',
  write_off_count: '核销次数',
  available_count: '可用次数',
  non_operating_income: '营业外收入',
  customer_order_price: '客单价',
  business_target_report: '营业指标同环比',
  cashierStatistics_text:
    '1.收款小计：统计该支付方式所有业务场景的支付总和，包括：营业收入、储值、礼品卡、签单还款等。',
  account_suspension_pay: '挂账还款',
  cashier_statistics: '收银员统计',
  deposit_report_analysis: '储值分析',
  proportion: '占比',
  new_principal_amount: '新增本金金额',
  bonus_amount_newly_added: '新增储值赠送金额',
  new_stored_value_order: '新增储值订单',
  stored_value_consumption_principal: '储值扣减本金金额',
  stored_value_consumption_gift_amount: '储值扣减赠金金额',
  new_consumption_orders: '储值扣减订单',
  newly_added_storage_value_principal_amount_orders: '新增储值本金金额订单占比',
  stored_value_consumption_principal_proportion: '储值扣减本金金额占比',
  value_gift_amount_orders: '新增储值赠送金额订单占比',
  location_date: '门店-日期',
  store_payment_method: '门店-支付方式',
  device_number: '设备编号',
  please_input_device_number: '请输入设备编号',
  gate_name: '档口名称',
  enable_function: '开启功能',
  screen_settings: '配菜屏设置',
  screen_settings1: '传菜屏设置',
  screen_settings2: '制作屏设置',
  kds_settings: 'KDS设置',
  check_store: '结算门店',
  pay_trade_subtitle:
    '因为上游银行或通道清算每天15:00做上一个交易日清结算业务，交易汇总仅支持查询截止到昨天已对账的数据',
  del_confirm_is: '确认要删除 {{title}} 吗？',
  record: '日志',
  pos_built_in: 'POS内置',
  bluetooth: '蓝牙',
  classic_bluetooth: '经典蓝牙',
  drive: '驱动',
  port: '端口',
  sale_order: '菜品结账单',
  order_return: '菜品退货单',
  card_checkout: '卡券结账单',
  card_order_return: '卡券退货单',
  stored_value_note: '储值单',
  member_stored_value_note: '会员储值单',
  anti_deposit_order: '反储值单',
  point_exchange_order: '积分兑换单',
  product_rank: '菜品排行',
  product_type_rank: '类别排行',
  inventory_adjust_order: '库存调整单',
  print_num: '打印份数',
  batch_no: '批次号',
  label_print: '标签打印',
  print_template: '打印模版',
  batch_set_printing_templates: '批量设置打印模版',
  label_print_form: '标签打印单',
  LABEL: '自提标签单',
  price_label_print_form: '价签打印单',
  expiry_price_label_print_form: '效期签打印单',
  back_kitchen_menu: '后厨退菜单',
  chef_master_list: '后厨总单',
  kitchen_order_distribution: '后厨分单',
  business_overview: '营业概览',
  product_selling_list: '菜品沽清单',
  collection_ranking: '收款排序',
  all_pay_name: '支付方式名称',
  current_sort: '当前排序',
  comprehensive_data_statistics: '综合数据统计',
  composition_of_product_categories: '菜品分类构成',
  business_scenario_composition: '业务场景构成',
  queuing_settings: '排队设置',
  queue_call_settings: '排队叫号设置',
  store_selection_list: '门店选择列表',
  click_a_single_page: '点单页',
  confirm_order_page: '确认订单页',
  order_details_page: '订单详情页',
  queue_display: '排队显示',
  status_setting: '状态设置',
  color_selection: '颜色选择',
  relaxed: '轻松',
  production_quantity_less_than: '制作数量低于',
  warning: '警告',
  production_quantity_higher_than: '制作数量高于',
  time_setting: '时间设置',
  current_quantity_not_full: '当前数量未满',
  production_time_is: '制作时长为',
  every_full_quantity_after_exceeding: '超出后数量每满',
  production_time_increased: '制作时长增加',
  queuing_display_position: '显示位置',
  enable_status_display: '启用状态展示',
  within_minutes: '分钟以内',
  be_careful: '注意',
  cannot_be_empty: '不可为空',
  minute_value: '分钟',
  cannot_less_than_or_equal_to_quantity_of_easy_production: '不能小于或等于轻松制作数量',
  cannot_less_than_or_equal_to_relaxed_time: '不能小于或等于状态为轻松的时间',
  queued_call_display_location_required: '排队叫号显示位置必选',
  queue_settins_tip: '门店排队路径根据当前设置的数量显示对应数量的状态',
  brand_manage: '品牌管理',
  brand_tatus: '品牌状态',
  brand_logo: '品牌LOGO',
  brand_intro: '品牌介绍',
  deactivate: '停用',
  brand_id: '品牌ID',
  actived: '已启用',
  create_brand: '创建品牌',
  compile_success: '编辑成功',
  compile_fail: '编辑失败',
  pos: 'POS',
  pos_name: 'POS机',
  kds_equipment: 'KDS设备',
  printer: '打印机',
  cloud_printer: '云打印机',
  equipment_setting: '设备管理',
  pos_type: 'POS类型',
  binding_state: '绑定状态',
  equipment_state: '设备状态',
  equipment_title: '设备名称',
  please_input_equipment_title: '请输入设备名称',
  host: '主机',
  store_default: '门店默认',
  bound: '已绑定',
  not_bound: '未绑定',
  equipment_code: '设备码',
  invalid_name: '已失效',
  refresh: '刷新',
  expire_date: '到期时间',
  create_equipment: '创建设备',
  set_host: '设为主机',
  unbind: '解绑',
  unbind_success: '解绑成功',
  application_status: '状态',
  application_version: '版本',
  search_area: '搜索区域',
  activation_quantity: '激活数量',
  total_precipitate_money: '截止统计周期最后一天的历史现金卡/储值卡的总额',
  total_precipitate_count: '截止统计周期最后一天的历史菜品次卡的总次数',
  precipitate_money: '期末沉淀金额',
  precipitate_count: '期末沉淀次数',
  rename: '重命名',
  move_up: '上移',
  move_down: '下移',
  new_classification_succeeded: '新建分类成功',
  parent_classification: '所属上级分类',
  success: '成功',
  available_point: '可用积分',
  available_point_tips: '可用积分：为当前正常可使用的积分',
  total_point: '总积分',
  loading_customer_list: '正在加载 客户列表',
  total_point_tips: ' 总积分：为用户当前的全部积分，包含冻结积分',
  freezn_point: '冻结积分',
  search_customer_with: '搜索 客户',
  freezn_point_tips:
    ' 冻结积分：在未完成支付的情况下，为了避免重复使用积分，会将未支付订单中使用的积分冻结，为冻结积分；将未支付订单取消即可将冻结积分解冻。',
  total_balance: '总余额',
  total_balance_tips: ' 总余额：为用户当前的全部余额，包含冻结余额',
  freezn_balance: '冻结余额',
  freezn_balance_tips_1: '冻结余额：1.待处理状态的申请储值退款单据中，实充金额与赠送金额的合计；',
  freezn_balance_tips_2: '2.商家设置冻结储值金额后，客户储值的金额会被冻结。',
  freezn_after_function_tips:
    '冻结后，会员的积分和储值功能将不再能使用，不再享受会员权益，小程序无法进行相关操作。确定冻结？',
  are_you_sure_thaw: '确定要解冻吗？',
  adjust_balance_deposite_rule_other_reward: '注：调整余额不触发储值规则，不额外赠送任何奖励',
  available_point_tip: '筛选条件下会员可用积分总数之和',
  point_expend_rate_tip: '累计消耗积分/累计发放积分',
  total_give_out_point_tip: '筛选条件下积分发放总和',
  total_consume_point_tip: '筛选条件下积分消耗总和',
  expired_point_tip: '筛选条件下已过期积分总数',
  interact_customer_count_tip: '筛选条件下有消耗或获取积分行为的会员数',
  gain_interact_customer_count_tip: '筛选条件下有获取积分行为的会员数',
  expend_interact_customer_count_tip: '筛选条件下有消耗积分行为的会员数',
  point_expend_rate: '积分消耗率',
  expired_point_count: '已过期积分数',
  interact_customer_count: '互动会员总数',
  gain_interact_customer_count: '获取积分会员数',
  expend_interact_customer_count: '消耗积分会员数',
  total_give_out_point: '累计发放积分',
  total_consume_point: '累计消耗积分',
  expired_point: '过期积分',
  point_statistics_tip: '积分消耗率与互动会员数提升，说明积分有效刺激到会员的活跃度。',
  point_analysis_report: '积分分析',
  point_analysis: '积分分析',
  point_statistics: '积分统计',
  point_trend: '积分趋势',
  give_out_point: '发放积分',
  expend_point: '消耗积分',
  interact_customer: '互动会员数',
  point_total_got_distribution: '积分累计获取分布',
  point_total_consume_distribution: '积分累计消耗分布',
  point_report: '积分报表',
  give_out_type: '发放途径',
  give_out_point_value: '发放积分值',
  expend_type: '消耗途径',
  expend_point_value: '消耗积分值',
  store_unfinished_order_statistics: '门店未完成订单统计',
  cash_pledge: '押金',
  benefit_card_analysis: '权益卡分析',
  benefit_card_customer: '权益卡客户',
  not_benefit_card_customer: '非权益卡客户',
  money_rate: '金额占比',
  customer_order_count_rate: '客单量占比',
  customer_order_product_count: '客单菜品数',
  current_customer_count: '当前客户数',
  cumulative_customer_count: '累计客户数',
  cumulative_sale_money: '累计销售金额',
  cumulative_renew_money: '累计续费金额',
  benefit_card_purchase_count: '权益卡购买次数',
  benefit_card_sale_money: '权益卡销售金额',
  choose_datetime_range_data: '所选时间内数据',
  benefit_card_data: '权益卡数据',
  generate_production_command_order: '生成生产指令单',
  production_command_order: '生产指令单',
  export_production_command_order: '导出生产指令单',
  dimension_of_raw_materials: '原料维度',
  task_release_date: '任务发布日期',
  produce_product_info: '加工品信息',
  raw_material_info: '原材料信息',
  production_order: '生产任务单',
  plan_production_quantity: '计划生产数量',
  production_order_no: '生产任务单号',
  produciton_product_desc: '共发布{{num}}条任务，可在生产任务单中分配',
  sit_down_setting: '手机点餐设置',
  sit_down_tip: '顾客到店就餐，扫码下单',
  self_pickup_settings: '自提设置',
  self_pickup_tip: '顾客线上下单，到店自提',
  takeout_settings: '外卖设置',
  takeout_tip: '顾客线上下单，商家配送',
  group_meal_self_pickup_settings: '团餐-自提设置',
  group_meal_self_pickup_tip: '团餐客户线上下单，到店自提',
  group_meal_takeout_settings: '团餐-外卖设置',
  group_meal_takeout_tip: '团餐客户线上下单，商家配送',
  go_set_it_up: '更改配置',
  week_retained_users: '{{name}}周留存用户数',
  week_retention_rate: '{{name}}周留存率',
  day_retained_users: '{{name}}日留存用户数',
  daily_retention_rate: '{{name}}日留存率',
  time_p: '次',
  order_distance_limit: '点单距离限制',
  headquarters_setting: '总部设置',
  location_setting: '门店设置',
  order_conversion_rate_tips:
    '访问到下单到支付过程中发生的数据变化展示。浏览人数包含微信小程序，不包含平台小程序、POS和网页后台。',
  mall_traffic_overview_report: '商城流量概况',
  view_examples: '查看示例',
  monday: '周一',
  tuesday: '周二',
  wednesday: '周三',
  thursday: '周四',
  friday: '周五',
  saturday: '周六',
  sunday: '周日',
  del_distribution_tips: '确定删除该方案，删除后无法恢复',
  locations_participate_count: '{{count}}家门店参加',
  locations_not_participate_count: '{{count}}家门店不参加',
  num_zone_join: '{{num}}个区域参加',
  num_zone_exclude: '{{num}}个区域不参加',
  temporary_assignment: '临时指定',
  daily_settlement: '日结',
  monthly_settlement: '月结',
  cash_on_delivery: '货到付款',
  payment_before_shipment: '款到发货',
  settlement_method: '结算方式',
  auxiliary_quantity: '辅助数量',
  main_parameters: '主参数',
  unitPrice: '单位价格',
  unit_of_Measurement_desc: '被菜品成本卡、生产配方、虚拟物品使用时，无法修改单位及换算率',
  please_enter_name: '请输入姓名',
  applet: '小程序',
  title: '标题',
  the_length_of_appid_must_be_18_digits: 'appid的长度必须为18位的',
  mp_path: '小程序路径',
  cover: '封面',
  please_enter: '请输入',
  associated_with_the_enterprise: '关联到企业的',
  please_view_the_path_of_the_mini_program: '请在小程序管理后台，数据分析中查看小程序路径',
  web_page: '网页',
  link_name: '链接',
  please_enter_the_correct_link_format: '请输入正确的链接格式',
  picture: '图片',
  please_upload_pictures: '请先上传图片！',
  text_content: '文本内容',
  video: '视频',
  please_upload_image: '请上传视频',
  material_library: '素材库',
  batch_delete: '批量删除',
  confirm_delete_transfer: '是否确定删除？（删除后无法复原）',
  delete: '删除',
  creation_time: '创建时间',
  text: '文本',
  search: '搜索',
  customer_source: '客户来源',
  loss: '流失',
  remain: '留存',
  is_vip: '是否为会员',
  support: '是',
  not_support: '否',
  tag_name: '标签',
  synchronize_customers: '同步客户',
  label: '打标签',
  customer_exception: '该客户存在异常，请联系管理员',
  processing_state: '处理状态',
  delivery_status: '发货状态',
  unprocessed: '未处理',
  successful_retweet: '重推成功',
  have_ignored: '已忽略',
  undelivery: '未发货',
  shipped: '已发货',
  partial_shipment: '部分发货',
  ready: '已准备',
  o_received: '已收货',
  pending_order: '待接单',
  has_taken_order: '已接单',
  order_receiving_exception: '接单异常',
  distribution_anomaly: '配送异常',
  abnormal_payment: '支付异常',
  deposit_exception: '储值异常',
  abnormal_order: '异常订单',
  retweet: '重推',
  ignore: '忽略',
  batch_retweet: '批量重推',
  batch_ignore: '批量忽略',
  abnormal_reason: '异常原因',
  ignore_success: '忽略成功',
  ignore_acknowledgement: '忽略确认',
  confirm_ignore: '是否确认忽略',
  repush_confirmation: '重推确认',
  confirm_repush: '是否确认重推',
  redelivery: '重新配送',
  refund: '退款',
  re_delivery_confirmation: '重新配送确认',
  sure_to_resend: '是否确认重新配送',
  look: '查看',
  pending_fulfillment_order: '待发货',
  repaired_successfully: '重新配送成功',
  pending_processing: '待处理',
  payment_platform_status: '支付平台状态',
  appeal_success: '申诉成功',
  refund_success: '退款成功',
  appeal: '申诉',
  refresh_check: '重新检测',
  select_used_narks_add_to_product: '从以下列表中选择之前使用的标记，并将其添加到此菜品。',
  all_labels: '所有标签',
  add_tag_tip: '如未找到目标标签，可尝试点击更新同步标签，或直接新增',
  customer_base: '客户群',
  group_Name: '群名称',
  group_leader: '群主',
  group_size: '群人数',
  join_the_group_on_the_same_day: '当日进群',
  withdrawal_on_the_same_day: '当日退群',
  sync_customer_groups: '同步客户群',
  ready_to_pick_up: '已准备自提',
  to_be_picked_up: '待自提',
  account_outstanding: '未结账',
  account_closed: '已结账',
  withdrawn_order: '已撤单',
  cleared_table: '已清台',
  invite_to_join_the_group_1: '直接邀请入群',
  invite_to_join_the_group_2: '邀请链接入群',
  scan_code_into_group: '扫码进群',
  staff: '员工',
  visitors: '访客',
  group_owner_management: '群主管理',
  belong_department: '所属部门',
  search_department: '搜索部门',
  sex_male: '男',
  sex_female: '女',
  employee_management: '员工管理',
  tips: '提示',
  application_role: '应用角色',
  binding_time: '绑定时间',
  total_customers: '客户总数',
  community_data: '社群数据',
  total_groups: '群总数',
  join_the_group_today: '今日入群',
  withdrawal_from_group_today: '今日退群',
  today_add: '今日新增',
  today_loss: '今日流失',
  employee_interface_manage: '员工接口管理',
  order_record: '订单记录',
  account_details: '账号详情',
  export_license_account: '导出许可账号',
  interface_permission_sceret: '接口许可密钥',
  wecompany_role_management: '企微角色管理',
  no_query_role_management: '未查询到企微角色管理',
  loading_role_management: '正在加载企微角色管理',
  sure_you_want_to_delete_role: '确定要删除角色吗',
  sure_you_want_to_delete_group_code: '确定要删除社群活码吗',
  sure_you_want_to_delete_channel_code: '确定要删除渠道活码吗',
  role_name: '角色名称',

  common_order: '普通订单',
  joint_order: '拼单订单',
  reserve_order: '预定订单',
  return_no_without_order: '无单退货单',
  commodity_reservation_sheet: '菜品预约单',
  group_order: '拼团订单',
  group_relay: '群接龙订单',
  group_meal: '团餐',
  bill_scanning_code: '扫码买单',
  local_delivery: '本地配送',
  self_picked: '到店自提',
  express_local_deliver: '快递配送',
  return_without_receipt: '无单退货',
  return_goods: '退货',
  export_details: '导出明细',
  report_type: '报表类型',
  fixed_report: '固定报表',
  custom_report: '自定义报表',
  report_fields: '报表字段',
  location_selected: '已选门店',
  payment: '付款',
  send_out_goods: '发货',
  variant_name: '规格名称',
  attributes: '菜品属性',
  barcode: '条码',
  product_origin_price: '菜品原价',
  product_discounts: '菜品优惠',
  discounted_price: '优惠后价格',
  permission_wecom_error_tips:
    '60020，错误信息：访问ip不在白名单之中；服务商正在申请IP白名单，请稍后再试。',
  please_permission_wecom: '请授权企业微信',
  scrm_wechat_application_title: '链接企业微信，让企业运营更简单',
  scrm_wechat_application_title_sub:
    '通过小程序，h5等与企业微信相结合，让营销触达更有效。通过统一的会员管理，让工作更简单。',
  authorized_agent_development_application: '授权代开发应用',
  completion_of_authorization: '代开发应用授权完成',
  scan_code_to_use_lezhi_enterprise_micromanager: '扫码使用乐檬餐饮企微管家',
  authorized_development_application: '授权开发应用——乐檬餐饮企微管家',
  authorized_development_application_subtitle:
    '使用企微扫码授权开发应用，客户群发，社群群发等总部下发任务，员工可在手机端接收信息',
  using_enterprise_scaning: '使用企业微信扫码',
  config_contact_secret_tips:
    '代开发应用授权已完成，请联系客成经理完成企微官方后台的代开发应用配置',
  have: '有',
  accounts_will_expired: '账号即将过期，请尽快续费',
  accounts_expired: '账号已过期，请尽快续费',
  sub_industry_of_the_enterprise: '企业所属子行业',
  enterprise_id: '企业ID',
  application_logo: '应用Logo',
  application_expiration_time: '到期时间',
  application_available_accounts: '可用账号',
  application_free: '企微应用费用说明',
  wechat_add_purchase_account: '企微助手增购账号',
  wechat_account_fee_renewal: '企微助手账号续费',
  enterprise_permanent_authorization_code: '企业永久授权码',
  application_name: '应用名称',
  surplus: '剩余',
  buy_now: '立即购买',
  account_renewal: '账号续费',
  add_purchase_account: '增购账号',
  application_free_desc:
    '因企业微信向服务商收取“接口调用许可费”，企微应用将按照新的方式收费，点击下方按钮查看详情。',
  amount_number: '账号数',
  and_above: '及以上',
  fee_standard: '收费标准（元）',
  yuan_account_year: '元/账号/年',
  discuss_personally: '面议',
  charging_for_account_fee: '账号费由企业微信收取',
  charging_policy: '收费政策',
  charging_standards_follows: '收费标准如下：',
  application_account_fee_desc:
    '说明：1、增购账号不影响功能有效期。    2、账号数计费不能跨层级，比如商户需要300个账号，收费=5×50+（200-5）×40+（300-200）×30=11050',
  application_cost_desc: '企微应用费用说明',
  dear_lemon_user: '尊敬的乐檬用户',
  hello: '您好',
  application_cost_desc_content:
    '由于企业微信自2022年5月16日起对全行业服务商收取接口调用许可费，为了更好的长期、健康、稳定的服务商户， 2022年5月16日后安装应用的商户，按照新的收费标准：收费方式为软件服务费+账号费。详细费用说明如下，敬请悉知：',
  cost_rules:
    '账号数计费不能跨层级，比如商户需要300个账号，收费=5×50+（200-5）×40+（300-200）×30=11050',
  lemon_production_team: '乐檬产品团队',
  year_month_day: '2024年01月02日',
  thanks_for_you: '感谢您对乐檬一直以来的理解与支持！',
  mini_program_payment_verification: '小程序付费验证',
  short_message: '短信',
  create_equity_account: '创建权益账户',
  title_of_account: '账户名称',
  equity_account: '权益账户',
  search_for_account_name: '搜索账户名称',
  dywm_self_sales_auth_tip:
    '要开始在抖音自助核销上销售您的菜品，并在本地管理您的抖音自助核销订单和菜品等，请先绑定抖音商家',
  account_type_2: '账户类型',
  store_account_settings: '门店账户设置',
  suit_to_location: '适用门店',
  export: '导出',
  export_success: '正在导出，请前往任务中心查看',
  function_description: '功能说明',
  batch_operation: '批量操作',
  not_returned: '未退货',
  returning: '退货中',
  returned: '已退货',
  return_merchandise: '退货菜品',
  restock: '重新入库',
  keep_archives: '存档',
  order_archived_successfully: '订单存档成功',
  unarchive: '取消存档',
  unarchive_order: '取消存档订单',
  order_unarchived_successfully: '订单取消存档成功',
  accept_order: '接单',
  order_agreed_refund: '订单同意退款',
  order_received_successfully: '订单接单成功',
  order_agrees_refund_successfully: '订单同意退款成功',
  dining_out: '出餐',
  dining_out_success: '出餐成功',
  cancel_order: '取消订单',
  agree_refund: '同意退款',
  refuse_refund: '拒绝退款',
  please_enter_reason_rejecting_refund: '请输入拒绝退款理由',
  reject_order: '拒单',
  please_select_reason_rejection: '请选择拒单理由',
  order_deleted: '订单已删除',
  other_operations: '其它操作',
  refuse_refund_order: '拒绝退款订单',
  order_rejected_successfully: '订单拒绝退款成功',
  rejected_order__successfully: '订单拒单成功',
  cancelled: '已取消',
  order_money1: '订单金额',
  application_infomoration: '应用信息',
  charging_standard: '收费标准',
  wecom_renewal_desc: '开通需要支付软件功能费及账号使用费',
  software_function_fee: '软件功能费',
  buy_and_renewal: '购买与续费',
  software_function_renewal: '软件功能续费',
  cost_accounts: '续费账号',
  only_choose_selected: '只可续费已绑定员工的账号',
  add_purchase_account_tip: '增购账号不能为0',
  renew_account_tip: '请至少勾选1个续费账号',
  affirm: '确认',
  current_number_of_accounts: '当前账号数',
  costs: '费用',
  selected_accounts: '选中账号数',
  pay_one_yaer: '续费一年',
  delivery_platform_orders: '外卖平台订单',
  meituan_waimai_API_call: '外卖平台API调用',
  support_platform: '支持平台',
  call_base_setting: '叫号基础设置',
  order_overtime_limit: '订单超时限制',
  voice_call_setting: '语音叫号设置',
  call_switch: '语音叫号开关',
  call_switch_tip: '开启后，叫号时将会在相应叫号端触发语音提示',
  call_content: '语音叫号内容',
  call_num: '叫号次数',
  call_speed: '叫号语音速度',
  fast: '快速',
  slow: '慢速',
  abort: '中止',
  hook: '挂失',
  unhook: '解挂',
  support_order_type: '支持订单类型',
  collected_order_display: '已取餐订单显示',
  app: '管家APP',
  order_assistant_app: '点餐助手',
  channels: '销售渠道',
  coupon: '优惠券',
  full_reduction_full_discount: '满减满折',
  time_limit_discount: '限时折扣',
  second_half: '满X件Y折',
  show_second_half: '查看满X件Y折',
  full_gift: '满赠',
  figt_deposit: '储值活动',
  gift_birthday: '生日有礼',
  friend_fission: '好友裂变',
  collect_stamp: '集点卡',
  point_mall: '积分商城',
  pop_up_coupon: '弹窗发券',
  gift_sign_in: '签到有礼',
  get_discount: '领券活动',
  send_discount: '精准营销',
  freight_reduction: '减运费',
  any_choice: 'N元任选',
  recommend_product: '推荐菜品',
  new_customer_exclusive: '新客专享',
  random_fullReduce: '随机立减',
  enter_greater_zaro_and_less_ten_tips: '请输入大于0且小于10的1位小数',
  check_at_least_one_member_price_or_current_price: '会员价或现价至少勾选一个',
  check_at_least_one_member_price_or_current_price1: '权益卡价或现价至少勾选一个',
  saving_failed_product_transfer_quantity_cannot_zero: '保存失败，菜品转移数量不能为0',
  enter_specified_price: '输入指定价格',
  between_discount: '0.1-9.9之间',
  import_reduction_amount: '输入减价金额',
  choose_goods: '选择菜品',
  discount_method: '优惠方式',
  adjust_price_location: '改价门店',
  adjust_price_order: '调价单',
  adjust_product: '调价菜品',
  adjust_product_tip:
    '现价不填则读取菜品档案价格同一个菜品不同等级会员价只能选择同一种优惠方式，例如所有等级设置指定价格，或者设置折扣，或者设置减价',
  adjust_price_order_info: '调价单信息',
  adjust_price_order_order_no: '调价单号',
  effect_time: '生效时间',
  immediate_effective: '立即生效',
  fixed_time_effective: '定时生效',
  create_adjust_price_order: '创建调价单',
  edit_adjust_price_order: '编辑调价单',
  copy_adjust_price_order: '复制调价单',
  cancel_adjust_price_order: '作废调价单',
  delete_adjust_price_order: '删除调价单',
  submit_adjust_price_order: '提交调价单',
  adjust_price_dimension: '调价维度',
  total_discount_money: '折扣',
  special_price: '特价',
  special_price_not_support_pos_application: '特价类型暂不支持POS应用，仅支持微店铺和平台小程序',
  modify_specified_price_bulk: '批量修改指定价格',
  batch_modification_discount: '批量修改折扣',
  bulk_modification_reduction: '批量修改减价',
  reduce_price: '减价',
  product_cost_price: '成本价',
  current_location_price: '当前门店价',
  current_price: '现价',
  give_discount: '打折',
  appoint_price: '指定价格',
  product_price_rounding: '取整',
  product_price_rounding_desc:
    '针对每个等级规则，选择优惠方式为打折、或减价时，可以设置去分/去角和分',
  retain_dime_and_cent: '保留角和分',
  remove_cent: '去掉分',
  remove_dime_and_cent: '去掉角和分',
  get_product_price: '读取档案价格',
  product_top: '菜品置顶',
  product_move_up: '菜品上移',
  product_move_down: '菜品下移',
  product_bottom: '菜品置底',
  must_order_product: '必点菜',
  must_order_product_plan_search: '根据必点菜方案名称查询',
  enter_scheme_name: '请输入方案名称',
  plan_channels: '方案渠道',
  required_point_type: '必点类型',
  plan_status: '方案状态',
  create_plan: '创建方案',
  plan_time: '方案时间',
  plan_cycle: '方案周期',
  show_must_order_product_plan: '查看必点菜方案',
  copy_must_order_product_plan: '复制必点菜方案',
  create_must_order_product_plan: '创建必点菜方案',
  edit_must_order_product_plan: '编辑必点菜方案',
  loadding_must_order_product_plan: '正在加载必点菜方案',
  end_must_order_product_plan: '结束必点菜方案',
  confirm_end_must_order_product_plan: '确定结束必点菜方案，结束后无法恢复',
  delete_must_order_product_plan: '删除必点菜方案',
  confirm_delete_must_order_product_plan: '确定删除必点菜方案，删除后无法恢复',
  sell_mode: '销售模式',
  in_store_cash_register: '店内收银',
  table_meal_mode: '台位点餐模式',
  table_meal_mode_tip:
    '仅乐檬餐饮台位版生效，在台位POS或者乐檬点餐助手APP点击“桌台”并选择某个桌台进行点餐结账',
  direct_ordering_mode: '直接点餐模式',
  scan_order_mode: '扫码点餐模式',
  scan_order_mode_tip: '顾客用手机扫桌台上的台位码进行点餐，然后由服务员送至桌台',
  // direct_ordering_mode_tip: '直接进行点餐结账，乐檬餐饮非台位版及乐檬餐饮台位版在快餐版或在台位版点击“快餐”生效',
  direct_ordering_mode_tip: '仅乐檬餐饮非台位版生效，非台位POS直接进行点餐结账',
  online_self_pickup: '线上自提',
  online_self_pickup_takeout: '线上自营外卖',
  plan_detail: '方案详情',
  specify_station_type: '指定台位类型',
  search_empty_station: '搜索 台位类型',
  no_query_station: '未查询到台位类型',
  select_station_type: '选择台位类型',
  please_enter_station_type_name: '请输入台位类型名称',
  loading_station: '正在加载 台位类型...',
  pre_people_must_order: '每人必点1份',
  pre_people_must_order_tip: '适合餐具、茶位费、蘸料等每人必点的场景',
  each_order_must: '每笔订单必点1份',
  each_order_must_tip: '适合纸巾、火锅锅底等每单或每桌必点，不按人数算的场景',
  change_sell_mode_tip:
    '选中的销售模式不支持设置必点类型为“每人必点1份”，已为您自动更改为“每笔订单必点1份',
  fixed_products: '固定菜品',
  optional_products: '可选菜品',
  essential_rules: '必点规则',
  product_to_be_must: '必选菜品',
  select_product_less_than_100: '最多选100个菜品',
  product_add_to_cart: '必选菜品自动加入购物车',
  product_add_to_cart_tip:
    '“固定菜品”按所设置的必选要求将必选菜品加入购物车，若必选菜品是套餐且有可选菜品组，将弹窗展示菜品由服务员或客户进行选择后加入购物车；“可选菜品”则弹窗展示所有备选必点菜品由服务员或顾客进行选择后加入购物车',
  customer_can_update: '顾客可手动修改必选菜品',
  customer_can_update_tip: '若可以修改，顾客可将数量改为“0”',
  place_check: '下单时检查必点菜品',
  place_check_tip: '下单时检查购物车或已下单菜品内是否有必选菜品',
  checkout_check: '结算时检查必选菜品',
  checkout_check_tip: '结账时检查已下单菜品内是否有必选菜品',
  only_tip: '仅进行提示',
  can_not_checkout: '不能结账',
  please_select_sell_mode: '请先选择销售模式',
  please_enter_plan_name: '请输入方案名称',
  please_choose_sell_mode: '请选择销售模式',
  cart_tip: '必选菜品自动加入购物车的销售模式至少选择一项',
  customer_tip: '顾客可手动修改必选菜品的销售模式至少选择一项',
  order_check_tip: '下单时检查必点菜品的销售模式至少选择一项',
  settle_check_tip: '结算时检查必选菜品的销售模式至少选择一项',
  product_time_period: '菜品时段',
  recommend_add_purchase: '推荐加购',
  collect_point: '集点卡',
  store_order_discount: '储值下单优惠',
  lucky_draw_gift: '抽奖有礼',
  scan_code_pay_discount: '优惠买单',
  title_display: '标题显示',
  food_delivery_code: '取餐码',
  no_customers: '无客户',
  no_name_provided: '未提供姓名',
  del_supplier_role_with_no: '请确认是否删除[{{name}}]',
  supplier_user_role: '供应商用户角色',
  supplier_user: '供应商用户',
  supplier_whchat_unbind: '供应商微信解绑',
  read_supplier_whchat_unbind: '读取供应商微信解绑',
  whchat_unbind: '微信解绑',
  confirm_unbind: '确认解绑吗？',
  confirm_unbind_tip:
    '解绑后，此账号将不会收到订货信息，如需再次绑定，需到供应商管理界面再次扫码绑定',
  bind_wechat_nickname: '已绑定微信昵称',
  times: '次',
  call_number_setting: '叫号设置',
  weapp: '微店铺',
  channel_code: '渠道活码',
  add_grouping: '新增分组',
  bulk_download: '批量下载',
  code_name: '活码名称',
  please_enter_code_name: '请输入活码名称',
  search_location: '搜索门店',
  all_location: '全部门店',
  designate_location: '指定门店',
  use_staff: '使用员工',
  today_new_add_friends_num: '今日新增好友数',
  number_of_lost_friends_today: '今日流失好友数',
  Number_of_lost_friends_in_the_past_seven_days: '近7日流失好友数',
  new_seven_add_friends_num: '近7日新增好友数',
  new_add_friends_total: '新增好友总数',
  retained_friends: '留存好友数',
  new_add_friends_num: '新增好友数',
  total_number_friends_added: '添加好友总数',
  total_loss: '流失总数',
  create_channel_code: '创建渠道活码',
  download_channel_code: '下载渠道码',
  all_group: '全部分组',
  please_input_group_name: '请输入分组名称',
  cannot_input_spaces: '不能输入空格',
  add_success: '添加成功',
  confirm_delete_module: '确认要删除 {{title}} 吗',
  after_del_group_not_recovery: '确定删除分组，删除后无法恢复',
  enter_group_name: '请输入分组名称',
  add_custom_group: '新增自定义分组',
  edit_custom_group: '编辑自定义分组',
  del_custom_group: '删除自定义分组',
  group: '分组',
  group_name: '分组名称',
  mp_qr_code: '小程序二维码',
  select_group: '选择分组',
  design_store_do_not_particpate: '指定门店不参加',
  delete_area_succeeded: '删除区域成功',
  move_area_up_successfully: '上移区域成功',
  move_area_down_successfully: '下移区域成功',
  move_area_succeeded: '移动区域成功',
  add_subarea: '添加子区域',
  delete_area: '删除区域',
  change_store_area: '变更门店区域',
  area_renamed_successfully: '区域重命名成功',
  area_rename: '区域重命名',
  area_name: '区域名称',
  subregion_added_successfully: '子区域添加成功',
  new_area: '新增区域',
  superior_region: '所属上级区域',
  change_area_succeeded: '变更区域成功',
  confirm_want_to_delete_the_selected_area: '确认要删除所选区域吗？',
  deleted_region_content: '仅删除区域，不删除区域下的门店，该区域的门店自动归入到上一级区域',
  please_enter_a_region_name: '请输入区域名称',
  select_location_zone: '请选择区域',
  batch_import_account_benefits: '批量导入账户权益',
  default_template_for_account_equity: '账户权益默认模板',
  apply_after_sale: '申请售后',
  after_sale_completion: '售后完成',
  deposit_card_retrieve: '储值卡回收',
  refund_shipping: '退还运费',
  deliver_fee_total_money: '运费',
  only_you_see_reason: '只有您和其他工作人员才能看到此原因',
  restock_product: '重新入库菜品',
  items_that_have_been_refunded_willbe_removed: '已退款的项目将从订单中删除。',
  under_delivery: '正在发货中',
  picking_up: '正在取货中',
  please_fill_remarks_reason: '退款原因必填',
  order_refund_successful: '订单退款成功',
  the_goods_have_been_refunded_successfully: '菜品已退款成功',
  the_goods_have_been_put_back_into_storage: '菜品已操作重新入库',
  abstract: '摘要',
  commodity_subtotal: '菜品小计',
  product_mount_suffix: '件菜品',
  total_refund: '退款总额',
  no_products_selected: '未选择任何菜品',
  this_order_is_pending_payment: '此订单正在等待付款',
  ok_refund_money: '可退金额',
  amount_are_refunding_different_total_suggested_refund: '您正在退款的金额与建议的退款总额不同',
  updating: '更新中',
  returnable_quantity: '可退数量',
  refund_quantity: '退款数量',
  customer_base_searth: '搜索客户群',
  customer_base_searthing: '正在搜索群聊',
  whether_to_automatically_reate_a_group: '是否自动建群',
  go_group_person: '进群人数',
  back_group_person: '退群人数',
  automatic_group_building_tips:
    '群聊达到人数上限后（上限人数为200人），以原群主的身份自动创建新群（一个活码最多可拥有5个群聊，当达到5个群聊将不会再自动建群）',
  automatic_group: '自动建群',
  set_group_meaasge: '设置群消息',
  total_number_of_group_members_retained: '群成员留存总数',
  total_number_of_group_members_loss: '群成员流失总数',
  create_community_01_code: '创建社群活码',
  batch_import_of_store_account_benefits: '批量导入门店账户权益',
  default_template_for_store_account_settings: '门店账户设置默认模板',
  customer_changed_cancelled_order: '客户更改/取消了订单',
  fraudulent_order: '欺诈性订单',
  after_sale_status: '售后状态',
  item_not_available: '菜品不可用',
  payment_declined: '付款遭拒',
  order_has_been_canceled: '订单已取消',
  other: '其他',
  cancellation: '作废',
  void_transaction: '作废交易',
  authorized_amount: '订单金额',
  stock: '库存',
  reason_for_cancellation: '取消原因',
  notify: '通知',
  lbs_add_friends: 'LBS加好友',
  lbs_draws_into_group: 'LBS引流入群',
  pocket_code_is_required: '兜底活码必选',
  link_name_required: '链接名称必填',
  create_lbs_friends: '创建LBS加好友',
  p_please_enter_name: '请输入名称',
  p_link_name: '链接名称',
  link_name_tips: '名称不会展示给用户，用于企业记录链接',
  select_pocket_code: '选择兜底活码',
  search_pocket_code: '搜索兜底活码',
  copywriting1: '文案一',
  copywriting2: '文案二',
  please_enter_copy: '请输入文案',
  here_background_image: '这里是背景图片',
  selective_code: '选择活码',
  this_what_copy_typed: '这是{{name}}输入的内容',
  please_enter_link_name: '请输入链接名称',
  pocket_code: '兜底活码',
  create_link: '新建链接',
  employee_friend_code: '配置门店渠道活码',
  friend_code_tips:
    'LBS加好友功能，可设置渠道活码关联对应门店，设置成功后自动定位对应门店推送员工渠道活码，实现快捷添加门店员工为加好友，添加成功后发送欢迎语',
  channel_code_association: '渠道活码关联',
  number_of_friends_added: '添加好友人数',
  friend_code_list: '好友码列表',
  query_by_store_name: '根据门店名称查询',
  loading_lbs_friends_code: '正在加载好友码',
  no_query_lbs_friends_code: '未查询到好友码',
  download_lbs_promotion_code: '下载LBS推广码',
  lbs_promotion_code: 'LBS推广码',
  download_lbs_qr_code: '下载LBS二维码',
  lbs_qr_code: 'LBS二维码',
  de_authorize: '去授权',
  download_lbs_applet_code: '下载LBS小程序码',
  copy_path: '复制路径',
  negotiate_time_with_merchant: '与商家协商时间',
  self_pick_quickly: '尽快到店自提',
  deliver_now: '尽快送达',
  estimated_delivery_time: '预期送达时间',
  expected_pickup_time: '预期取货时间',
  china: '中国',
  no_shipping_address_provided: '未提供收货地址',
  recall: '重新调用',
  call_success: '调用成功',
  order_marked_shipped: '订单已标记为已发货',
  order_marked_picked_up: '订单已标记为已取货',
  mark_shipped: '标记已发货',
  marked_picked_up: '标记已取货',
  initiate_delivery: '发起配送',
  ready_to_pick: '准备订单',
  call_rider: '呼叫骑手',
  product_has_been_shipped: '菜品已发货',
  called_rider: '已准备订单',
  ready_for_pickup: '已准备取货',
  mark_as_shipped: '标记为已发货',
  marked_as_picked_up: '标记为已取货',
  canceled: '取消发货',
  shipping_canceled: '已取消配送',
  shipping_cancel: '取消配送',
  edit_tracking: '修改发货',
  shipment_canceled: '已取消发货',
  confirm_receipt: '确认收货',
  edit_supplierUser_with_name: '编辑供应商用户[{{supplierName}}]',
  create_supplierUser_with_name: '创建供应商用户[{{supplierName}}]',
  gift_card_order: '礼品卡订单',
  right_card_order: '权益卡订单',
  ticket_pack_order: '券包订单',
  payment_status_2: '支付状态',
  un_pay: '未付款',
  balance_pay: '余额支付',
  gift_card_payment: '礼品卡支付',
  customer_phone: '客户手机号',
  view_details: '查看详情',
  copy_settings_to_other_stores: '复制设置到其他门店',
  copy_content: '复制内容',
  category_dimension: '分类维度',
  all_categories: '全部类别',
  first_level_category: '一级类别',
  secondary_category: '二级类别',
  account_fee: '账号费',
  branch: '门店',
  select_employees: '选择员工',
  select_operation_mode: '选择操作方式',
  search_operation_mode: '搜索操作方式',
  operation_time: '操作时间',
  operation_function: '操作功能',
  operation_mode: '操作方式',
  operation_log: '操作日志',
  client_ip: '客户端IP',
  terminal_name: '终端名称',
  authorized_user: '授权用户',
  customers_of_total_contain: '企业微信客户总人数，包含已被删好友的历史客户',
  customers_of_total_notcontain: '企业微信客户净人数，不包含已被删好友的历史客户',
  customers_of_total_notcontain_add: '企业微信新增客户净人数，不包含已被删好友的历史客户',
  compared_to_the_previous_day: '较上一日',
  community_code: '社群活码',
  customer_group_sends: '客户群发',
  community_post: '社群群发',
  group_send_assistant: '群发助手',
  join_group_people: '包含退群人数',
  number_of_friends_added_tip: '包含流失人数',
  wechat_ranking: '排行',
  delivery: '配送',
  logistics: '物流',
  rider_did_not_accept_order: '骑手（或快递员）未接单',
  rider_has_accepted_order: '骑手（或快递员）已接单',
  no_accept_order: '未接单',
  deliverying: '配送中',
  mercury_2: '水星2.0（微商城）',
  wholesale_sales_list: '批发销售单',
  light_meal: '轻餐',
  mars_product: 'Mars产品',
  ama_product: 'AMA产品',
  wxjsps: '微信即时配送（WXJSPS）',
  mtps: '美团配送（MTPS）',
  sftc: '顺丰同城急送（SFTC）',
  sjps: '商家配送（SJPS）',
  dada: '达达快送（DADA）',
  uu: 'UU跑腿（UU）',
  arrived: '已送达',
  speed_of_light: '光速达-{{number}}',
  fast_reach: '快速达-{{number}}',
  arrive_in_time: '及时达',
  ss: '闪送（SS）',
  cd: '餐道（CD）',
  kdn: '快递鸟（KDN）',
  stay: '在',
  can_sale: '上有售',
  can_not_sale: '上不可售',
  state: '状态',
  sale_price: '售价',
  customer_member_price: '会员价',
  subtract: '减',
  discount: '折',
  variant_number: '个多规格',
  not_tracked_quantity: '未跟踪数量',
  category: '类别',
  create_standard_product: '创建标准菜品',
  product_document_not_uploaded_successfully: '菜品文档还未上传成功',
  product_import: '菜品导入',
  create_import_task_success: '正在导入，请前往任务中心查看',
  import: '导入',
  import_product_and_no: '导入菜品，任务号',
  location_tag: '门店标签',
  tag_label_name: '标签名称',
  use_location: '使用门店',
  please_input_tag_name: '请输入标签名称',
  select_start_date: '选择开始日期',
  select_end_date: '选择结束日期',
  import_image_info1: '将要导入的图片打包成压缩包(.zip)导入，如：图片压缩包.zip。',
  import_image_info2:
    '图片支持gif、jpeg、png、bmp，推荐像素 800 * 800，大小不超过 10M，压缩包大小请勿超过100MB。',
  import_image_info3: '每张图片的图片名称为对应菜品的菜品名称，如：杨枝甘露.jpg。',
  import_image_info4:
    '一个菜品需要导入多张图片时，图片文件名用下划线隔开。格式：菜品名称_数字。如：杨枝甘露_1.jpg、杨枝甘露_2.jpg',
  import_image_info5:
    '勾选设置为默认图片，则导入的图片会被设置成菜品默认图片。同时导入多张图片时，则第1张图片为默认图片。',
  file_size_exceeds_system_limit: '文件大小超出系统限制',
  please_upload_the_correct_file_format: '请上传正确的文件格式',
  image_size_exceeds_limit: '图片大小超出限制',
  image_import: '图片导入',
  set_as_default_image: '设置为默认图片',
  after_receiving_order: '接单后',
  after_receiving_order_before_scheduled_delivery_time: '接单后且预约送达时间前',
  location_status: '门店状态',
  deactivate_store: '停用门店',
  enable_store: '启用门店',
  temporary_branch_closed: '临时闭店',
  recover_business: '恢复营业',
  contacts: '联系人',
  select_location: '请选择门店',
  close_branch_tip_1: '门店闭店后，门店可继续登录系统查看营收数据、分账数据，进销存数据。',
  close_branch_tip_2: '是否将已选中的门店设置为闭店状态？',
  close_branch_tip_3: '是否将已选中的门店设置为恢复营业状态？',
  active_or_stop_tip: '是否将已选中的门店设置为{{type}}状态？',
  batch_delete_product_forever: '永久删除菜品',
  batch_delete_product_forever_desc:
    '永久删除菜品后会停止菜品在系统中的应用，且将无法恢复，请谨慎操作',
  batch_delete_product_forever_desc_2: '如果绑定了外卖平台菜品，会自动解除绑定关系',
  batch: '批量',
  products_complete: '菜品成功',
  please_go_to_the_mission_center_to_view_details: '，请去任务中心查看详情',
  product_status_delete_clash: '菜品无法删除，存在状态为“活跃”的套餐菜品',
  product_status_delete_clash_tips: '存在于套餐中，无法进行删除，其他菜品删除成功',
  conflict_product_symbol: '冲突菜品：',
  replenishment_stock_quantity_required: '补足库存数量必填',
  mall_product: '商城菜品',
  batch_edit_product_complete: '批量修改完成，请去任务中心查看详情',
  product_will_modify_all_variants: '多规格菜品将修改所有子规格',
  product_status: '菜品状态',
  sf_store_id: '顺丰门店ID',
  dada_store_id: '达达门店ID',
  mt_store_id: '美团门店ID',
  cd_store_id: '餐道门店ID',
  kdn_store_id: '快递鸟门店ID',
  whether_recover_branch: '是否将 {{name}} 恢复营业',
  temporary_close_branch_tip:
    '门店临时闭店后，门店大部分业务将无法进行，可继续登录系统查看营收数据、分账数据，进销存数据。',
  whether_close_branch: '是否将 {{name}} 临时闭店',
  store_deactivated_all_businesses_of_the_store_cannot_carried_out:
    '若停用门店，则该门店所有业务都无法进行。',
  store_not_used_for_storing_inventory_shipping_orders_or_selling_products_please_disable_it:
    '如果此门店不用于存放库存、发货订单或销售产品，请将其停用。',
  deactivated_stores_will_not_included_in_your_store_limit_n:
    '已停用的门店不会计入您的 门店个数限制（N个）。',
  effective_stores_will_affect_your_limit_on_the_number_of_stores:
    '有效门店会影响您的 门店个数限制。',
  please_enter_the_store_code: '请输入门店代码',
  please_enter_the_store_name: '请输入门店名称',
  store_area: '门店区域',
  belong_region: '所属区域',
  pre_deposit: '预储值',
  activity_name: '活动名称',
  please_enter_the_activity_name: '请输入活动名称',
  activity_title: '活动标题',
  please_enter_the_activity_title: '请输入活动标题',
  activity_title_placeholder: '请输入活动标题，用于小程序/pos活动名称展示，不填写默认展示活动名称',
  activity_rules: '活动规则',
  discount_rules: '优惠规则',
  discount_rules_tip:
    '例：每满5件优惠3件，按价格最低，则表示价格最低的3件享受优惠，按价格最高，则表格价格最高的3件享受优惠',
  discount_rules_price_order_asc: '按价格最低',
  discount_rules_price_order_desc: '按价格最高',
  cycle_discount_is: '是否循环',
  second_half_rules_tip:
    '根据您的运营规则可以输入折扣为5和0，实现第xx份半价和第xx件免单；您也可以选择优惠类型是特价，输入金额为9.9元，实现第xx份9.9元',
  active_status: '活动状态',
  enter_activity_name: '请输入活动名称',
  customer_info: '客户信息',
  warehouse_cost: '菜品库成本',
  inventory_cost: '库存成本',
  maximum_9999: '最大值9999',
  fen: '分',
  please_select_a_time: '请选择时间',
  max_select: '最多可选择',
  select_freight_template: '请选择运费模板',
  edit_clash: '修改冲突',
  product_status_edit_clash: '菜品状态无法修改为“草稿/存档”，是因为存在状态为“活跃”的套餐菜品',
  kit_product_status_edit_clash:
    '套餐菜品状态无法修改为“活跃”，是因为存在状态为“草稿/存档”的明细菜品',
  conflict_goods: '冲突菜品',
  correspond_package: '对应套餐',
  gram: '克',
  filter_product_template_pla: '根据菜品模板名称查询',
  tmpl_name: '模板名称',
  template_description: '模板描述',
  template_description_pla: '请输入模板描述',
  add_template: '加入模板',
  are_you_sure_add_template: '确定批量添加菜品到所选模板中吗？',
  select_product_template: '选择模板',
  batch_select_template_success: '批量选择模板成功',
  read_headquarters_price_if_not_fill_member_price: '会员价不填则读取售价',
  price_save_success: '价格保存成功',
  product_price_cannot_be_negative: '菜品价格不能为负数',
  product_price_cannot_be_higher_than_location_sale_price: '菜品价格不能高于门店售价',
  product_price_cannot_be_higher_than_headquarters_price: '菜品价格不能高于售价',
  cannot_be_lower_than_location_sale_price_range: '不能低于门店售价范围',
  headquarters_price_not_null1: '售价不能为负数',
  batch_set_price: '批量设置价格',
  product_list: '菜品列表',
  mp_location_product_list: '微店铺菜品列表',
  platform_applet_product_list: '平台小程序菜品列表',
  confirm_clear_selected_product_customer_member_price_is1: '清空所选菜品{{name}}吗？',
  confirm_clear_selected_product_price_is: '清空所选菜品价格吗？',
  clean: '清空',
  product_pricing_rules:
    '会员价不填则优先读取菜品库对应等级的会员价, 菜品库对应等级的会员价不存在则读取门店售价，门店售价不存在则读取总部统一价',
  edit_price_tips: '指定价格：设置固定的会员价格',
  edit_price_tips1: '折扣：在售价基础上打折，会根据售价实时变化',
  edit_price_tips2: '在原价基础上减价，会根据售价实时变化',
  product_pricing_rules1: '选择菜品的原价或售价可以不进行填写，不填写默认不应用于该菜品',
  setting_price: '设置价格',
  print_coupon_order: '打印卡券订单',
  confirm_stop_scan_code: '确定要停用{{title}}? 停用后无法扫码买单',
  location_sale_price_range: '门店售价范围',
  location_sale_price: '门店售价',
  for_each_level_rule: '针对每个等级规则，可以设置抹角/抹分操作',
  count_tips: '【去掉角】和【去掉角和分】会先进行四舍五入计算。',
  batch_edit_price_title: '已选择 {{length}} 个规格，将选中的菜品及所有规格进行如下设置',
  integer_mode: '取整方式',
  retain_angles_minutes: '保留角和分',
  remove_divide: '去掉分',
  remove_corners_and_divide: '去掉角和分',
  maximum: '最大值',
  maximum_999: '最大值999',
  sale_price_range: '售价范围',
  origin_price: '参考价',
  product_name_cannot_empty: '菜品名称不能为空',
  product_type_cannot_be_null: '菜品类别不能为空',
  shorthand_characterle_cannot_empty: '速记码不能为空',
  daily_initial_planned_inventory_not_null: '每日初始计划库存不能为空',
  kilogramme: '公斤',
  gramme: '斤',
  metafield: '元字段',
  metafield_name: '元字段名称',
  metafield_name_required: '请输入元字段名称',
  namespace: '命名空间',
  namespace_required: '请输入命名空间',
  create_metafield: '创建元字段',
  edit_metafield: '编辑元字段',
  use_metafield: '使用元字段',
  code_key: '秘钥',
  code_key_required: '请输入秘钥',
  description: '描述',
  description_required: '请输入描述',
  text_min: '最小长度',
  text_min_required: '请输入最小长度',
  text_max: '最大长度',
  text_max_required: '请输入最大长度',
  value_tips: '提示文案',
  value_tips_required: '请输入提示文案',
  value_type: '内容类型',
  value_type_required: '请选择内容类型',
  field_type: '信息格式',
  field_type_required: '请选择信息格式',
  field_type_tooltip: '信息格式保存后不允许修改',
  value_options: '选项内容',
  value_options_placeholder: '键入回车键或者逗号添加选项',
  value_options_required: '选项内容不能为空',
  date_can_be_over_the_current_date: '可超过当天日期',
  choice_max_required: '请输入最多选择项',
  number_min: '最小值',
  number_min_required: '请输入最小值',
  number_max: '最大值',
  number_max_required: '请输入最大值',
  number_max_precision: '最大精度',
  number_max_precision_required: '请输入最大精度',
  fields_can_expand_various_functions_in_the_store: '可拓展店铺中各个功能的字段',
  ok_to_delete_the_meta_field: '确定删除元字段？',
  delete_item_meta_field: '删除菜品元字段',
  want_to_delete_the_meta_field_grouping: '确定要删除元字段分组吗',
  guide_customer_to_fill_in_personal_information_can_help_you_better_understand_the_store_user_portrait_and_prepare_for_subsequent_marketing:
    '引导客户填写个人资料可以帮助您更好地了解店铺用户画像，为后续营销做好准备。',

  switch: '开关',
  date_time: '日期时间',
  single_choice: '单选',
  multiple_choice: '多选',
  decimal: '小数',
  quality_guarantee_period: '保质期',
  integer: '整数',
  required: '必填',
  headquarters_price_must_within_store_price_range: '售价必须在门店价格区间范围内',
  product_specification_barcode_cannot_duplicate: '菜品规格条码不允许重复',
  product_multiple_codes_one_product_cannot_empty: '菜品一品多码不可为空',
  elm_product_attribute_required: '淘宝闪购·餐饮菜品属性必选',
  eb_product_attribute_required: '淘宝闪购·零售菜品属性必选',
  titok_product_attribute_required: '抖音外卖菜品类目必选',
  multi_specification_attribute_name_required: '多规格属性名称必填',
  title_cannot_empty: '标题不能为空',
  order_quantity_cannot_be_null: '起购数量不能为空',
  small_program_side_display_null: '小程序端展示文案必填',
  cannot_access_this_item: '无法访问该菜品，检查 URL 并重试。',
  delivery_method: '配送方式',
  system_auto_generate_sku: '请输入SKU',
  length_cannot_exceed: '长度不可超过{{t}}个字符',
  type_enter_to_add_options: '键入回车键添加选项',
  barcode_example: '条码 （ISBN、UPC、GTIN 等）',
  product_cover_helptext:
    '该封面图用于小程序菜品加购弹框大图模式，仅支持 gif、jpeg、png、bmp 4种格式，推荐像素 375 * 210 px，大小不超过 10M。',
  gift_cards: '礼品卡',
  used_cannot_be_returned: '已使用，无法进行退货',
  used_can_not_be_returned: '已使用，无法退货',
  card_specifications: '卡规格',
  return_reason_1: '退款原因',
  refund_coupon_orders: '退款卡券订单',
  when_refunding_coupon_package_orders_refund_amount_calculated_based:
    '优惠券包订单退款时，按照未使用的优惠券的实际支付金额计算退款金额。',
  logistics_information_required: '物流信息必填',
  after_sale_processing: '售后处理中',
  rejected_refund: '已拒绝退款',
  cancelled_refund: '已撤销退款',
  refund_type: '退款类型',
  only_refund: '仅退款',
  refunds: '退货退款',
  order_created_location: '下单门店',
  return_number: '退货编号',
  search_return_number: '搜索退货编号',
  search_customer_phone: '搜索客户手机号',
  refund_no: '退款编号',
  pick_up_number: '取餐号',
  product_money: '菜品金额',
  express_delivery: '快递',
  after_sale_order: '售后订单',
  batch_agree: '批量同意',
  batch_refuse: '批量拒绝',
  batch_agree_to_refund: '批量同意退款',
  batch_refusal_of_refunds: '批量拒绝退款',
  refund_orders_number: '当前已选退款单数',
  refund_money_back: '退款金额将原路退回到买家账户。',
  sure_batch_agree_refund: '确定批量同意退款？',
  batch_refuse_refund_tip:
    '建议您与买家协商后，再确定是否拒绝退款。如您拒绝退款后，买家可修改退款申请协议重新发起一次退款',
  bill: '单',
  batch_agree_refund_successfully: '批量同意退款成功',
  batch_refuse_refund_successfully: '批量拒绝退款成功',
  handle_notes: '处理备注',
  please_fill_in_the_rejection_remarks: '请填写拒绝备注',
  bill_merchant_template: '无台位POS票据',
  location_print_setting: '门店打印设置',
  small_bill_self_delivery_design: '小票(自提单)设计',
  delivery_order_design: '配送单设计',
  card_order_design: '卡订单设计',
  shift_order_design: '交班单设计',
  kitchen_return_order: '后厨退菜单',
  label_design: '标签设计',
  price_tag_design: '价签设计',
  expiry_tag_design: '效期签设计',
  export_after_sales_orders: '售后订单导出',
  failed_please_try_again_later: '{{type}}失败，请稍后重试',
  product_after_sales_information: '菜品售后信息',
  refund_details: '退款详情',
  order_status: '订单状态',
  refund_instructions: '退款说明',
  refund_voucher: '退款凭证',
  refund_statu: '退款状态',
  refund_processin_time: '退款处理时间',
  product_does_not_match_actual_product: '菜品与实物不符',
  product_damaged: '菜品有损坏',
  not_send_out_at_appointed_time: '未按约定时间发货',
  delivery_time_out: '配送超时',
  logistics_signed_but_not: '物流显示签收但实际未收到货',
  not_like_or_want: '不喜欢/不想要',
  whether_to_restock: '是否重新入库',
  processing_remarks_required: '处理备注必填',
  agree_remark_information_not_filled: '同意备注信息未填写',
  agree_to_refund_successfully: '同意退款成功',
  order_refused_to_refund: '订单拒绝退款',
  denied_refund_successfully: '拒绝退款成功',
  rejected_remark_information_not_filled: '拒绝备注信息未填写',
  shipping_fee_rejected_refunded_successfully: '运费拒绝退款成功',
  save_create: '保存并继续创建',
  exist_sku: '已存在SKU',
  exist_barcode: '已存在菜品条码',
  confirm_continue_to_save: '是否要继续保存？',
  exist_mark_code: '已存在菜品标识',
  specification_name_cannot_duplicate: '规格名称不可以重复',
  specification_name_cannot_empty: '规格名称不能为空',
  edit_product_variant: '编辑规格',
  create_variant: '创建多规格',
  delete_variant: '删除规格',
  crad_order_export: '卡券订单导出',
  card_coupon_after_sales_order: '卡券售后订单',
  export_coupon_after_sales_orders: '导出卡券售后订单',
  after_sales_processing_information: '售后处理信息',
  buyer_applies_after_sales: '买家申请售后',
  merchant_processes_refund_request: '商家处理退款申请',
  variants_and_options_has_changed_please_save: '规格选项已变更，请保存后再操作',
  add_other_options: '添加其它选项',
  option: '选项',
  large: '大号',
  alignment: '对齐方式',
  be_at_the_left: '居左',
  be_at_the_center: '居中',
  be_at_the_right: '居右',
  margin_bottom: '下边距',
  print_font_size: '打印字号',
  template_preview: '模板预览',
  brought_the_wrong_thing: '买错了',
  product_category_oms_el: '菜品类目（淘宝闪购·餐饮）',
  please_select_product_category_oms_el: '请选择菜品类目',
  please_select_product_category_option_oms_el: '请选择菜品类目属性',
  product_material_oms_el: '菜品原料（淘宝闪购·餐饮)',
  please_select_product_material_oms_el: '请选择菜品原料',
  sold_time: '售卖时间',
  after_sales_progress: '售后进度',
  packaging: '包装物（费用类）',
  invalidator: '作废人',
  voidTime: '作废时间',
  availability_status: '供货状态',
  processed: '已处理',
  bulk_submission: '批量提交',
  product_category_oms_eb: '菜品类目（淘宝闪购·零售）',
  please_select_value: '请选择值',
  only_windows_drive_print_mode_takes_effect: '仅Windows驱动打印模式生效',
  only_windows_drive_print_image_mode_takes_effect: '仅Windows驱动按图片打印模式支持',
  normal_multiplier_effect_in_command_printing_mode: `指令打印模式下为"正常"的倍高效果`,
  product_line_tips: '勾选后，每个菜品末尾自动增加分割线',
  reserve_order_flag: '仅在预订单中展示',
  presentation_style: '展示样式',
  show_as_numbers: '展示为数字',
  display_as_barcode: '展示为条码',
  displayed_as_barcode_and_number: '展示为条码+数字',
  qr_code_height_needs_x_please_check: '二维码高度需要在{{minWidth}}-{{maxWidth}}之间,请检查',
  tracking_information_updated: '已更新物流信息',
  unarchive_product: '将菜品取消存档',
  archive_product: '将菜品存档',
  unarchive_product_desc: '取消将此菜品存档会将其状态更改为“草稿”，这样您就可以再次对其进行处理。',
  specification_value_required: '规格名称必填',
  delete_product: '删除菜品',
  cancel_archiving_succeeded: '取消存档成功',
  archive_succeeded: '存档成功',
  edit_product: '编辑菜品',
  sure_delete_product_because_operate_can_not_undone: '您是否确定要删除菜品 ',
  this_operation_cannot_undone: '此操作无法撤销',
  save_changes_and_unarchive_product_is: '保存更改并将菜品取消存档？',
  save_changes_and_archive_product_is: '保存更改并将菜品存档？？',
  archive_product_desc:
    '将此菜品存档将从您的销售渠道中隐藏菜品。您可以使用菜品列表中的状态筛选条件查找该菜品。',
  conflict_kit_symbol: '冲突套餐：',
  ticket_design: '小票设计',
  format_modification: '格式修改',
  mall_settings: '商城设置',
  edit_cashier_receipt_rules: '编辑收银小票规则',
  edit_label_printing_rules: '编辑标签打印规则',
  edit_kitchen_printing_rules: '编辑后厨打印规则',
  copy_cashier_receipt_rules: '复制收银小票规则',
  copy_label_printing_rules: '复制标签打印规则',
  copy_kitchen_printing_rules: '复制后厨打印规则',
  create_cashier_receipt_rules: '创建收银小票规则',
  create_label_printing_rules: '创建标签打印规则',
  create_kitchen_printing_rules: '创建后厨打印规则',
  cashier_receipt: '收银小票',
  label_ticket: '标签小票',
  chef_receipt: '后厨小票',
  order_directly: '直接点餐',
  report_receipt: '报表小票',
  member_receipt: '会员小票',
  SETTLEMENT: '堂食结账单',
  PRE_SETTLEMENT: '预结账单',
  SIGN_IN: '签收小票',
  WITHDRAW_FOOD_ORDER: '退菜单',
  TURN_FOOD_ORDER: '转菜单',
  TURN_TABLE: '转台单',
  CALL_UP_ORDER: '叫起单',
  DINING_IN_LABEL: '堂食标签单',
  TAKE_OUT_LABEL: '自提/外卖标签单',
  URGE_FOOD_ORDER: '催菜单',
  URGE_TABLE_ORDER: '催台单',
  SALE_ORDER: '自提结账单',
  CARD_ORDER_RETURN: '菜品退货单',
  DISCOUNT_TICKET_BILL: '优惠券小票',
  MEMBER_CONSUME_BILL: '会员扣款单',
  POINT_CONSUME_BILL: '积分扣款小票',
  TAKEOUT: '外卖结账单',
  CHECK_ORDER: '对菜单',
  down_payment_and_earnest_money_form: '订金/押金单',
  blank: '空白',
  no_print: '不打印',
  print_one: '打印1份',
  print_two: '打印2份',
  print_three: '打印3份',
  product_variant_multiple_codes_one_product_cannot_empty: '菜品规格一品多码不可为空',
  delete_variants: '删除多规格',
  sure_delete_variant_because_operate_can_not_undone:
    '您是否确定要删除 多规格 {{title}}？此操作无法撤销。',
  day_before: '前{{dayInAdvance}}天',
  birthday_current_day: '生日当天',
  birthday_current_week: '生日当周',
  birthday_current_month: '生日当月',
  sms_signature: '【短信签名】',
  sms_gift_content: '【赠送内容】',
  sms_discount_content: '【优惠券内容】',
  return_t_unsubscribe: '回T退订',
  distribute_time: '发放时间',
  sms_merchant_name: '【店铺名称】',
  sms_tips_first: ' 已输入{{input}}字(含签名与尾缀)，按{{ssmNumber}}条短信计费。',
  sms_tips_second: '【店铺名称】和【赠送内容】是变量标签，实际发送短信内容以预览为准。',
  review: '审核',
  counter_audit: '反审核',
  create_time_desc: '创建时间 (新-旧)',
  create_time_asc: '创建时间 (旧-新)',
  true: '是',
  false: '否',
  third_code: '第三方编码',
  whether_difference: '是否存在差异',
  to_be_paid: '待支付',
  canceld: '已取消',
  not_paid: '未支付',
  refunding_01: '申请退款中',
  refuse_denied: '退款被拒绝',
  became_invalid: '订单已失效',
  operate_record: '操作记录',
  not_invoiced: '未开票',
  invoiced: '已开票',
  have_paid: '已支付',
  not_pay: '未支付',
  location_year: '/店/年',
  point_location_year: '/点/店/年',
  supply_chain: '供应链',
  station_pos_point: '台位版POS点位',
  member_crm_professional: '会员CRM专业版',
  supply_chain_basic: '供应链基础版',
  supply_chain_professional: '供应链专业版',
  separate_member: '分账-会员',
  separate_revenue: '分账-营收',
  separate_supply_chain: '分账-供应链',
  wechat_software_fee: '企微助手软件功能费',
  level_up: '升级',
  jump: '跳转',
  lezhi_service: '乐檬餐饮服务',
  service_type: '服务类型',
  renew_success: '续费成功',
  due_date: '到期日期',
  rise: '起',
  buy: '购买',
  software_fee_renewal: '软件功能续费',
  wechat_software_fee_renewal: '企微助手软件功能续费',
  wechat_software_fee_renewal_tip: '企微助手软件功能已到期，请先续费软件功能',
  details: '详情',
  billing_record: '开票记录',
  billing_status: '开票状态',
  billing_shop: '开票门店',
  invoice_number: '发票号码',
  invoice_content: '发票内容',
  invoice_details: '发票详情',
  invoice_code: '发票代码',
  please_select_invoice: '请选择发票',
  please_enter_invoice_title: '请输入发票抬头',
  invoice_title_required: '发票抬头必填',
  loading_invoice_title: '正在加载 发票抬头......',
  invoice_amount: '开票金额',
  please_enter_invoice_amount: '请输入开票金额',
  invoice_amount_required: '开票金额必填',
  date_of_drawing: '开票日期',
  screening_invoice_number: '根据发票号码查询',
  loading_billing_record: '正在加载 开票记录......',
  download_invoice: '下载发票',
  not_found_billing_record: '未查询到开票记录',
  default_store_hours: '默认门店营业时间',
  invoice: '开发票',
  keyword_search_not_empty: '关键字不能为空',
  taxpayer_identification_number: '纳税人识别号',
  change_filter_search_term: '尝试更改筛选条件或搜索词。',
  keyword_search: '关键字搜索',
  invoice_management: '发票管理',
  invoice_type: '发票类型',
  issuing_body: '开票主体',
  issuing_explain: '开票说明',
  create_subject: '创建主体',
  screening_of_sellers: '筛选开票主体',
  loading_invoice: '正在加载 发票......',
  loading_issuing_body: '正在加载 开票主体......',
  name_of_invoicing_entity: '开票主体名称',
  billing_channel: '开票通道',
  not_found_issuing_body: '未查询到开票主体',
  look_suit_to_location: '查看适用门店',
  confirm_delete_content_header: '确定要删除“{{name}}” 吗？',
  confirm_delete_content_issuing: '确定要删除主体 {{name}}，删除后无法恢复',
  create_a_billing_body: '创建开票主体',
  nono: '诺诺',
  name_of_taxpayer: '纳税主体名称',
  please_enter_your_tax_name: '请输入纳税名称',
  taxpayer_identification_number_required: '纳税人识别号必填',
  please_enter_taxpayer_identification_number: '请输入纳税人识别号',
  business_details_address: '企业详细地址',
  please_enter_business_details_address: '请输入企业详细地址',
  account_bank_name: '开户行名称',
  account_bank_name_require: '开户行名称必填',
  please_enter_the_bank_name: '请输入开户行名称',
  a_bank_account: '开户行账号',
  a_bank_account_required: '开户行账号必填',
  please_enter_your_bank_account_number: '请输入开户行账号',
  taxpayer_telephone: '纳税人电话',
  please_enter_taxpayer_phone_number: '请输入纳税人电话',
  receiving_phone: '短信接收手机',
  please_enter_receiving_phone: '请输入短信接收手机',
  please_enter_appkey: '请输入AppKey',
  get_token: '  请获取Token',
  small_scale_taxpayer: '小规模纳税人',
  general_taxpayer: '一般纳税人',
  tax_rate: '税率',
  please_enter_the_tax_rate_: '请输入税率，税率区间1 - 99',
  tax_service_name: '税收服务名称',
  please_enter_tax_service_name: '请输入税收服务名称',
  please_select_the_applicable_store: '请选择适用门店',
  invoice_allowed: '允许开票',
  payee: '收款人',
  please_enter_the_payee: '请输入收款人',
  reviewer: '复核人',
  please_enter_the_reviewer: '请输入复核人',
  drawer: '开票人',
  please_enter_drawer: '请输入开票人',
  drawer_name_required: '开票人姓名必填',
  billing_limit: '开票限额',
  please_enter_billing_limit: '请输入0.01-999999.99',
  tax_rate_setting: '税率设置',
  flat_rate: '统一税率',
  project_name: '项目名称',
  project_info: '项目信息',
  uniform_name: '统一名称',
  please_enter_uniform_name: '请输入统一名称',
  billing_setup: '开票设置',
  billing_time: '开票时间',
  billing_time_custom: '开票时间: 自定义',
  billing_time_cannot_empty: '开票时间不能为空',
  billing_time_pla: '请输入1-92',
  invoicing_is_allowed_inside: '内允许开票',
  billing_tips_1:
    '1、提交发票信息表后，电子发票将于1-3个工作日内发送至您的邮箱。（每月1-3日，在财务报税过程中不能开具发票）。',
  billing_tips_2: '2、目前仅支持增值税电子普通发票、增值税电子专用发票。',
  billing_tips_3:
    '3、仅允许付费成功后在系统30天内申请电子发票，超出此时间请发邮件至finance@cnlemon.net进行开票申请，需提供当时的支付回单，开票名称及税号。',
  billing_tips_4: '4、因税务要求，不允许跨年开票处理。',
  information: '信息',
  ordinary_invoice: '普通发票',
  vat_invoice: '增值税专用发票',
  pay_module: '支付模式',
  pay_status: '支付状态',
  pay_success_time: '付款时间',
  order_desc: '订单描述',
  view_invoice: '查看发票',
  create_invoice: '创建发票',
  company_address: '企业地址',
  company_phone: '企业电话',
  company_phone_require: '企业电话必填',
  address_can_not_be_null: '地址必填',
  chain_version_type: '供应链版本',
  open_platform_request_class_push_class_interface: '开放平台请求类及推送类接口',
  number_of_successful_calls_open_platform_gateway: '调用至开放平台网关成功的次数',
  thank_you_for_understanding_support_of_lezhi_retail: '感谢您对乐檬餐饮一直以来的理解与支持！',
  mt_interface_cannot_called_enough_times_affect_mt_function:
    '若美团接口可调用次数不足，将影响美团外卖库存同步功能。请提前充值确保次数充足。',
  notes_on_meituan_charge_range:
    '注意事项：美团平台对于API的收费范围、业务类型、收费标准会不定期发生调整，届时乐檬将会通过系统公告等方式提前通知',
  querying_remaining_callable_times: '正在查询剩余可调用次数',
  charge_description: '收费说明',
  call_details: '调用明细',
  to_recharge: '去充值',
  push_statistics: '推送统计',
  meituan_takeaway_api_interface_charge_prompt:
    '由于美团自2022年1月1日起对全行业对接外卖API接口调用进行收费，为了更好的长期、健康、稳定的服务商户，乐檬餐饮将于2022年11月1日起正式开始收费，收费规则如下:',
  toll_interface: '收费接口',
  interface_charging_standard: '价格（元/百次）',
  call_source: '调用来源',
  billing_rules: '计费规则',
  inventory_synchronization_api: '库存同步API',
  lezhi_retail_team: '乐檬餐饮团队',
  date_day: '日',
  oms_mt_api: '外卖平台API调用服务',
  meituan_interface_callable_times: '外卖平台接口可调用次数',
  please_enter_minimum_number_of_times: '请输入最少次数',
  less_than_calls: '调用次数少于',
  times_hour: '次时',
  call_times_balance_reminder: '调用次数余额提醒',
  autograph: '签名',
  please_enter_minimum_number_of_transactions: '请输入最少笔数',
  enter_correct_mobile_number: '请输入正确的手机号码',
  original_mobile_phone_number_verification_code: '输入原手机号码验证码',
  please_enter_original_mobile_phone_number_verification_code: '请输入原手机号码验证码',
  please_enter_correct_email_address: '请输入正确的电子邮件地址',
  getting_configuration_information: '正在获取配置信息',
  sms_reminder: '短信提醒',
  email_reminder: '电子邮件提醒',
  no_reminder_has_been_set: '暂未设置提醒',
  sms_balance_reminder_settings: '短信余额提醒设置',
  lemon_software: '乐檬软件',
  please_enter_a_signature_name: '请输入签名名称',
  please_upload_basic_voucher: '请上传基础凭证',
  please_upload_power_of_attorney: '请上传委托授权书',
  submitted_successfully: '提交成功',
  not_submitted: '未提交',
  requesting_signature_information: '正在请求签名信息',
  signature_setting_reminder: '签名信息不能存在“乐檬”字样',
  basic_voucher: '基础凭证',
  note_please_upload_business_license: '注：请上传营业执照',
  power_of_attorney: '授权委托书',
  note_fill_in_power_of_attorney_according_to_template_instructions:
    '注：请按模板说明填写授权委托书（填写内容标红），填写好后上传截图',
  download_power_of_attorney_template: '下载委托授权书模板',
  submit_for_review: '提交审核',
  details_not_found_within_seven_days: '未查询到7天内明细',
  try_to_view_all_details: '尝试查看所有明细',
  description_of_domestic_sms_package: '给您的客户发送短信通知，和群发营销短信给您的客户时使用',
  querying_remaining_available_sms: '正在查询剩余可用短信',
  remaining_sms_available_in_current_store: '当前店铺剩余可用短信',
  decorate_navigation_suspended_window: '店铺装修悬浮窗',
  not_enabled: '未启用',
  enable_or_not: '是否启用',
  read_suspended_window: '查看悬浮窗',
  remind_once_a_day: '每天提醒一次',
  record_not_found: `找不到 记录`,
  try_to_change_filter_criteria: '尝试更改筛选条件',
  meituan_takeout_call_service: '外卖平台API调用服务',
  requesting_meituan_takeout_details: `正在请求 美团外卖明细`,
  call_interface_here: '调用接口此处',
  after_recharging_meituan_takeout_can_synchronized: '充值后可同步外卖平台订单到当前系统',
  pen: '笔',
  please_enter_minimum_number: '请输入最少条数',
  mtordertips:
    '具体调用以下收费接口：waimai/ng/dish/queryFoodList-查询门店菜品列表waimai/dish/updateStock-更新菜品库存【sku的库存】waimai/dish/mapping-建立菜品映射',
  not_device_same_purchase_product: '不能设置相同的购买菜品',
  takeout_api_call_service: '外卖平台API的调用服务',
  domestic_sms_package: '国内短信包',
  lemon_sms_service_prompt: '乐檬短信服务，高质量专属通道，各种场景秒达用户，帮您提升转化率',
  order_now: '立即订购',
  after_recharging_system_inventory_specified_goods_can_automatically_synchronized_to_takeout:
    '充值后可使用外卖平台库存同步功能',
  please_enter_a_value_greater_than_zero: '请输入大于0的值',
  dear_lezhi_retail_user: '尊敬的乐檬餐饮用户',
  platform_charging_rules:
    '由于线上平台技术对接成本提高，为了更好的长期、健康、稳定的服务商户， 结合当前市场发展情况，乐檬餐饮将于2022年9月1日起对外卖平台的接单功能收费，收费规则如下：',
  recharge_package: '充值套餐',
  number_of_take_out_orders: '外卖订单数',
  standard_package_price: '标准套餐定价(元)',
  unit_price: '单价(元)',
  univalent: '单价',
  orders_with_sufficient_recharge:
    '若订单数不足，系统将不再接收第三方平台的订单，请提前充值确保次数充足。',
  recharge_now: '立即充值',
  thank_you: '感谢您对乐檬餐饮一直以来的理解与支持',
  charge_publicity_time: '2022年8月22日',
  yesterday_rise: '昨日',
  please_configure_data_display_content: '当前未配置数据展示内容，请配置',
  configure_more_features: '配置更多功能，让客户可以详细了解您的业务。',
  package_one: '套餐1',
  package_two: '套餐2',
  package_three: '套餐3',
  querying_remaining_available_orders: '正在查询剩余可用订单',
  remaining_orders_available_in_current_store: '当前店铺剩余可用订单',
  basic_rule: '基本规则',
  point_deduct_rule: '积分抵扣规则',
  not_found_info: '暂无信息',
  point_got_rule: '积分获取规则',
  point_order_source: '参与积分的订单来源',
  oms_order_sync: '外卖平台订单同步服务',
  platform_charge_notice: '关于对美团外卖/淘宝闪购·餐饮平台接单功能的收费通知',
  number_of_orders_less_than: '订单数少于',
  pen_hour: '笔时',
  order_balance_reminder: '订单余额提醒',
  purchase_time: '订购时间',
  not_found_record: '找不到记录',
  purchase_service: '订购服务',
  short_message_balance_reminder: '短信余额提醒',
  reacquire: '重新获取{{remainSecond}}s',
  get_verification_code: '获取验证码',
  platform_call: '平台小程序调用',
  platform_api_quotas_notice: '关于【调用平台小程序手机号快速验证组件收费】的通知',
  platform_api_quotas_rules:
    '由于微信自2023年8月28日起对获取手机号次数进行收费，需要登录小程序后台【付费管理】中进行充值后才可以使用一键获取手机号的功能。',
  platform_api_quotas_rules_tip:
    '平台小程序需要由乐檬餐饮商户中心进行代充，可前往【设置】-【增值服务】中进行充值，收费规则如下：',
  wechat_official_instructions: '微信官方说明',
  wechat_official_charges: '同微信官方收费',
  only_supported_in_wechat_miniprogram: '仅支持微信小程序',
  wechat_phone_verify_service: '微信手机号实时验证组件调用服务',
  wechat_get_phone_times: '微信获取手机号调用次数',
  remind_three_day: '提醒三天',
  remind_call_times_balance: '调用次数余额提醒',
  audit_fail: '审核失败',
  auditing: '审核中',
  batch_audit: '批量审核',
  audit_status: '审核状态',
  commodity_maintenance: '菜品维护',
  search_by_product_name_initials: '根据菜品名称 / 首字母搜索',
  add_product_2: '添加菜品',
  device_type: '设备类型',
  unlimited_no: '无限制',
  this_week: '本周',
  this_month: '本月',
  this_quarter: '本季度',
  this_year: '本年度',
  days_number: '天数',
  month_number: '月数',
  year_number: '年数',
  custom: '自定义',
  please_input_query_days: '请输入查询天数',
  please_input_query_months: '请输入查询月数',
  please_input_query_years: '请输入查询年数',
  days_number_is_not_null: '{{name}}不能为空',
  amount_value_with_unit: '元余额',
  sheet: '张',
  removed_successfully: '移除成功',
  do_you_want_to_remove_this_item: '是否要移除此菜品',
  sms_charging_rule: '已输入{{wordNum}}字（含签名与尾缀），按{{smsNum}}条短信计费',
  sms_charging_rule_desc: '注：计费以实际发送时的短信字数为准（签名变更可能会影响字数）',
  order_clerk: '点单员',
  next_person: '下单人',
  notification_sms: '通知短信',
  verification_code_sms: '验证码短信',
  marketing_sms: '营销短信',
  voice_message: '语音短信',
  received: '已接收',
  has_been_sent: '已发送',
  fail_in_send: '发送失败',
  send_date_is_required: '发送日期必选',
  no_push_details_found: '未查询到推送明细',
  sms_push_details: '短信推送明细',
  requesting_push_details: '正在请求推送明细信息',
  getting_push_statistics: '正在获取推送统计',
  current_statistical_period: '当前统计周期',
  total_number_of_sms_senders: '短信总发送人数',
  number_of_successful_sms_arrivals: '短信成功到达人数',
  number_of_charging_messages: '短信计费条数',
  push_details: '推送明细',
  recent_details: '最近明细',
  receiving_number: '接收号码',
  all_history: '所有历史记录',
  sms_balance_reminder: '短信余额提醒',
  sms_signature_without_bracket: '短信签名',
  sms_signature_describe: '短信签名必须通过审核才可正常使用短信服务',
  send_sms: '发送短信',
  sms_content: '短信内容',
  sms_discount_tips_second: '【店铺名称】和【优惠券内容】是变量标签，实际发送短信内容以预览为准。',
  notifiction_setting_tips:
    '为避免骚扰客户，限制短信通知时间范围08:00-22:00，若发券时间在显示时间外，则延迟至下一个08:00统一通知。',
  deliver: '送',
  scene_description: '场景描述',
  scene_description_text1:
    '详细描述已上线业务的使用场景，并提供可以验证这些业务的网站链接、已备案域名地址、应用市场下载链接、公众号或小程序全称等信息。',
  scene_description_text2:
    '对于登录场景，还需提供测试账号密码。信息完善的申请说明会提高签名、模板的审核效率。',
  bar_hour: '条时',
  piece: '条',
  page: '页',
  number: '号',
  number_type: '数字',
  recharge_time: '充值时间',
  number_of_recharge_items: '充值条数（条)',
  pay_in_fact_money_items: '实付金额（元）',
  placing_an_order: '下单人',
  placing_an_order_phone: '下单人手机号',
  no_query_recharge_record: '未查询到充值记录',
  this_option_apply_mp_1: '此选项超出限制后，将不参加限时折扣活动，按照活动前的价格购买。',
  sms_group_send_tips:
    '计费说明：当前{{wordNum}}字，预计发送条数为{{smsNum}}条（实际发送时，签名、变量长度、回T退订四个字等会影响总字数）。',
  senting: '发送中',
  order_time_allowed: '允许预订单时段',
  business_hours_only: '仅营业时间',
  all_hours_including_non_business_hours: '全部时间，包括非营业时间',
  immediate_improvement: '立即完善',
  please_improve_the_SMS_signature_first: '请先完善短信签名',
  unable_to_recharge_temporarily: '暂无法充值',
  please_enter_the_correct_signature_name: '请输入正确的签名名称',
  mini_filing_description: '小程序备案说明',
  other_types: '其他类型',
  total_number_of_senders: '总发送人数',
  number_of_successful_arrivals: '成功到达人数',
  billing_number: '计费数',
  successfully_arrived_at_the_source: '成功到达来源',
  incorrect_date_format: '日期格式有误',
  no_more_push_records_found: '未查询到更多推送记录',
  sms_push_statistics: '短信推送统计',
  real_time_data_statistics: '实时数据统计',
  remaining_sms: '剩余短信',
  push_record: '推送记录',
  cut_off: '截止',
  hour_value: '小时',
  notify_desc_1: '使用小程序模板消息，需先授权小程序；并于小程序后台添加小程序服务类目：',
  notify_desc_2: '生活服务',
  notify_desc_3: '百货/超市/便利店',
  notify_desc_4:
    '每个小程序最多可同时启用50个一次性订阅模板，已添加的模板一旦达到50个，可能无法正常推送消息，此时请商家',
  notify_desc_5: '进入小程序后台',
  notify_desc_6:
    '删除部分不启用的模板，删除后重新勾选对应的小程序订阅消息，系统会重新创建已开启的模板。',
  notify_desc_7: '使用公众号模板消息需要遵守：',
  notify_desc_8: '微信公众平台运营规范',
  notify_desc_9: '，频繁发送营销类模板消息存在被封禁的风险。',
  notify_desc_10: '公众号模板消息需要在',
  notify_desc_11: '公众号后台',
  notify_desc_12: '选择模板消息行业：',
  notify_desc_13: '百货/超市/便利店',
  notify_desc_14:
    '每个公众号最多可同时启用25个模板消息，已添加的模板一旦达到25个，可能无法正常推送消息，此时请商家进入',
  notify_desc_15:
    '删除部分不启用的模板，删除后重新勾选对应的公众号模板消息，系统会重新创建已开启的模板。',
  notify_desc_16: '使用短信通知，需先购买短信包服务，充值短信条数。',
  notify_desc_17:
    '如果同时勾选了公众号模板消息和小程序订阅消息，只应用公众号模板消息；当公众号模板消息失效时，应用小程序订阅消息。',
  notify_desc_18:
    '如果您在授权之前已添加【小程序订阅消息】，请在授权完成后重新勾选所有【小程序订阅消息】。',
  copy_success: '复制成功',
  copy_failed: '复制失败',
  download_mp_code: '下载小程序码',
  your_mp_version_not_match: '您的微信小程序版本不支持',
  un_bind_mp: '您尚未绑定小程序',
  go_bind_mp: '去绑定小程序',
  no_can_download_qr_code: '没有可供下载的小程序码',
  extension: '推广',
  extension_location: '推广门店',
  searching_bind_mp_is: '正在查询是否绑定小程序',
  creating_mp_qr_code: '正在生成小程序二维码',
  querying_group_data: '正在请求拼团数据',
  invite_open_group: '快来一起拼团吧！',
  exchange_category: '兑换类型',
  aisle_type: '通道类型',
  aisle_location: '通道门店',
  delivery_service: '配送服务',
  recipient_name: '收件人姓名',
  recipient_phone: '收件人手机',
  recipient_addres: '收件人地址',
  recipient_latitude_longitude: '收件人经纬度',
  whether_make_appointment: '是否预约单',
  courier_name: '配送员姓名',
  courier_phone: '配送员电话',
  order_delivery_price: '订单配送价格',
  available_amount: '优惠可用金额',
  actual_price_paid: '实际支付价格',
  distributor_information: '配送员信息',
  batch_quantity_message: '批量设置库存完成，请去任务中心查看详情',
  batch_setting_quantity_success: '批量设置库存成功',
  go_to_read_detail: '正在{{operation}}，请前往任务中心查看',
  confrim_batch: '确认要批量{{operation}}菜品吗？',
  recipient_people: '收件人',
  appointment_order: '预约订单',
  dywm_sales_auth_tip:
    '要开始在抖音外卖上销售您的菜品，并在本地管理您的抖音外卖订单和菜品等，请先绑定抖音商家',
  douyin_merchant_id_binding: '抖音商家ID绑定',
  douyin_merchant_id: '抖音商家ID',
  read_dywm_auth_manager: '查看抖音外卖授权管理',
  dywm_auth_manager: '抖音外卖授权',
  stop_sell_dy_products_tip: '暂不支持下架菜品，只能将库存修改为0停止售卖。或至抖音后台操作。',
  complete: '完成',
  store_bind_settings: '门店绑定设置',
  store_bind_settings_operation: '可管理对应的门店的菜品和订单等操作',
  authoried: '已授权',
  binding_new_merchants: '绑定新商家',
  bind_now: '立即绑定',
  please_enter_the_merchant_id: '请输入商家ID',
  notify_product_example_1: '冰激凌蛋糕*1，蜡烛*22，草莓果盒*2',
  notify_product_example_2: '黄山休宁松萝茶*1',
  notify_product_example_3: '冰激凌蛋糕*1，蜡烛*12，草莓果盒*2',
  notify_product_example_4: '黄山休宁有机茶*1',
  notify_product_example_5: '冰激凌蛋糕，蜡烛，草莓果盒',
  pick_address: '取货地址',
  address_example_2: '江苏省南京市建邺区',
  order_date_time: '订单时间',
  total_number_of_items: '品项总数',
  total_order_quantity: '总订购数',
  reminder: '温馨提示',
  pick_up_location: '提货门店',
  pick_up_time: '提货时间',
  already_picked_remard_value: '感谢您在(店铺名称)购买菜品。',
  location_name_example: '翡翠湾店',
  no_group: '未成团',
  grouped: '已成团',
  grouping: '拼团中',
  full_group: '满团',
  product_example_1: '黄山毛峰',
  product_example_1_unit: '黄山毛峰*1',

  product_example_2: '黄山休宁松萝茶',
  product_example_3: '冰淇淋雪糕*1，蜡烛*1，草莓果盒*1',
  group_buy_send_time_desc: '拼团成功或者失败时，发送通知消息',
  group_buy_state_notify: '拼团状态通知',
  group_buy_order_pay_success: '您的拼单订单已支付成功~',
  group_buy_result_notify: '拼团结果提醒通知',
  group_buy_result_notify_tip: '您有新的拼团订单已经组团成功',
  group_buy_result_remind: '拼团结果提醒',
  group_information: '拼团信息',
  group_details: '拼团详情',
  group_state: '成团状态',
  group_people: '成团人数',
  joint_group_people: '拼团人数',
  pay_order_no: '付款单号',
  pay_success_money: '付款金额',
  list_of_product: '菜品清单',
  pay_money_ready: '待支付金额',
  pay_reminder: '支付提醒',
  order_cancel_pay_fund: '订单即将取消，请尽快付款',
  endline_time: '截止时间',
  click_to_detail: '点此查看详情',
  payment_money: '付款金额',
  refund_status: '退款状态',
  refund_fail: '退款失败',
  fake_product_templete: '屯溪绿茶',
  click_to_order_evaluation: '点击进行订单评价',
  merchant_order_evaluation_reminder_to: '商家回复客户评价后立即发送',
  merchant_name_1: '商家',
  merchant_example_1: '乐檬餐饮家的体验店',
  comment_content_tips: '你家的东西真不错',
  reply_content: '回复内容',
  reply_content_01: '谢谢您的评价，下次光临',
  change_reason: '变动原因',
  point_modify_value: '积分变动值',
  expire_time: '过期时间',
  effective_point: '有效积分',
  change_money: '变动金额',
  balance_change_sms_content:
    '您在(店铺名称)的会员卡号(会员卡号)余额变动:(变动金额)，当前余额:(当前余额)，变更时间:(变更时间)，变动类型:消费/充值',
  account_balance: '账户金额',
  member_account_example: '乐檬餐饮会员',
  efficity_time: '生效时间',
  no_efficity_time: '失效时间',
  current_leve: '当前等级',
  origin_level: '原等级',
  current_growth: '当前成长值',
  remark_desc: '备注说明',
  level_name_example_1: '金卡会员',
  level_name_example_2: '银卡会员',
  expired_date: '过期日期',
  ticket_qty: '优惠券数量',
  discount_strength: '优惠力度',
  vouther_type_example_1: '折扣券',
  discount_strength_example_1: '5折',
  ticket_expired_remind_sms_content:
    '您在(店铺名称)有(优惠券到期数量)张优惠券将于(到期天数)天后到期，请尽快使用。',
  ticket_reminder_example_1: '您的优惠券即将过期',
  coupon_name_example_1: '【代金券】100-20',
  coupon_name_example_2: '五折券',
  coupon_name: '券名称',
  deading_date: '截止日期',
  sign_in_reminder_example: '今天还没有签到哦',
  sign_in_reward: '签到奖励',
  sign_in_reward_example: '每次签到奖励1积分',
  sign_days: '签到天数',
  merchant_designation: '商家名称',
  card_name: '卡券名称',
  gift_card_reminder: '礼品卡即将到期，请在规定时间内使用',
  festival_gift_card: '节日礼品卡',
  limited_time_discount_activities: '限时折扣活动',
  take_it_from_the_store: '到店自提',
  group_buy: '拼团',
  group_order_no: '拼单',
  vip_system: '会员体系',
  coupon_reminder: '优惠券提醒',
  sign_in_remind: '签到提醒',
  member_balance: '会员余额',
  member_point: '会员积分',
  oms_ebls: '淘宝闪购·零售',
  ebls_auth_manager: '淘宝闪购·零售授权',
  read_ebls_auth_manager: '查看淘宝闪购·零售授权管理',
  ebls_authed: '淘宝闪购·零售已授权',
  authorization_manager: '授权管理',
  auth_new_merchant: '授权新商户',
  immediate_auth: '立即授权',
  auth_merchant: '已授权商户',
  elm_sales_auth_tip:
    '要开始在淘宝闪购·餐饮上销售您的菜品，并在本地管理您的淘宝闪购·餐饮订单和菜品等，请先授权淘宝闪购·餐饮',
  elm_authed: '淘宝闪购·餐饮已授权',
  ebls_sales_auth_tip:
    '要开始在淘宝闪购·零售上销售您的菜品，并在本地管理您的淘宝闪购·零售订单和菜品等，请先授权淘宝闪购·零售',
  tiktok_self_auth: '抖音自助核销授权管理',
  tiktok_self_locations: '抖音自助核销门店列表',
  tiktok_self_products: '抖音自助核销门店菜品',
  tiktok_self_setting: '抖音自助核销设置',
  cancel_empower_shop: '取消授权门店',
  cancel_auth_success: '取消授权成功',
  mt_shop_list: '美团外卖门店列表',
  auth_state: '授权状态',
  cancel_auth: '取消授权',
  store_auth: '门店授权',
  mt_location_id: '美团门店ID',
  elm_location_id: '淘宝闪购·餐饮门店ID',
  mt_location_name: '美团门店名称',
  elm_location_name: '淘宝闪购·餐饮门店名称',
  filter_location_name_code: '筛选门店名称或门店代码',
  querying_location: '正在请求 门店',
  read_mt_shop_setting: '查看美团外卖门店列表',
  mt_shop_setting: '美团外卖门店设置',
  read_elm_shop_list: '查看淘宝闪购·餐饮门店列表',
  elm_shop_setting: '淘宝闪购·餐饮门店列表',
  empower_shop: '授权门店',
  once_auth: '立即授权',
  operate_confirm: '操作确认',
  are_sure_cancel_auth_location: '确定取消授权该门店？',
  designation: '名称',
  wechat_mp_unbind: '未授权',
  region: '所在地区',
  location_list: '门店列表',
  authorization_success: '授权成功',
  request: '请输入正确的门店ID',
  ebls_location_id: '淘宝闪购·零售门店ID',
  ebls_location_name: '淘宝闪购·零售门店名称',
  ebls_store_products: '淘宝闪购·零售门店菜品',
  ebls_store_products_fetch: '淘宝闪购·零售门店菜品抓取',
  bind_ebls_shop: '绑定淘宝闪购·零售门店',
  ebls_shop: '淘宝闪购·零售门店',
  read_ebls_shop_list: '查看淘宝闪购·零售门店列表',
  ebls_shop_setting: '淘宝闪购·零售门店列表',
  douyin_takeaway_store_number_id: '抖音外卖门店编号ID',
  douyin_takeaway_store_number_name: '抖音外卖门店编号名称',
  read_dywm_shop_list: '查看抖音外卖门店列表',
  dywm_shop_setting: '抖音外卖门店列表',
  douyin_store_binding: '抖音门店绑定',
  dywm_store_products: '抖音外卖门店菜品',
  dywm_store_products_fetch: '抖音外卖门店菜品抓取',
  read_dywm_setting: '查看抖音外卖设置',
  dywm_setting: '抖音外卖设置',
  edit_dywm_setting: '编辑抖音外卖设置',
  dy_location_id: '抖音门店ID',
  please_enter_correct_platform_store_id: '请输入正确的平台门店id',
  please_selecet_authorized_merchant: '请选择授权商户',
  to: '至',
  clash_detail_time_to_location: '活动时间内，参与活动门店存在',
  clash_detail_record_amount: '条记录',
  clash: '冲突',
  location_number: '家门店',
  participate: '参加',
  un_limited: '不限制',
  oms_complete: '完成',
  dywm_authed: '抖音外卖已授权',
  complete_time: '完成时间',
  ticket_money: '优惠券金额',
  after_end_can_not_recovery: '确定结束活动，结束后无法恢复',
  after_del_can_not_recovery: '确定删除活动，删除后无法恢复',
  edit_point_exchange: '编辑积分兑换',
  copy_point_exchange: '复制积分兑换',
  create_point_exchange: '创建积分兑换',
  read_point_exchange: '查看积分兑换',
  end_point_exchange: '结束积分兑换',
  del_point_exchange: '删除积分兑换',
  end_confirm_is: '确认要结束 {{title}} 吗?',
  create_mall_product: '创建商城菜品',
  must_freight_template: '运费模板必选',
  edit_mall_product: '编辑商城菜品',
  delete_mall_product: '删除商城菜品',
  edit_mall_product_variants: '编辑商城菜品规格',
  delete_mall_product_variants: '删除商城菜品规格',
  create_mall_variant: '创建商城菜品规格',
  levitated_sphere: '悬浮球',
  pop_up_advertise: '弹窗广告',
  HOME_PAGE_NAME: '首页',
  home_page: '首页',
  click_single_page: '点单页',
  use_center_page: '个人中心页',
  advertise_mangae: '广告管理',
  read_advertise_mangae: '查看广告管理',
  end_advertise_mangae: '结束广告管理[{{title}}]',
  delete_advertise_mangae: '删除广告管理[{{title}}]',
  activity_dates: '活动日期',
  activity_status: '活动状态',
  location_suitable_to: '适用门店',
  collect_stamp_activity: '集点卡活动',
  no_collect_stamp_activity: '未查询到集点卡活动',
  select_collect_stamp_activity: '选择集点卡活动',
  search_activity_name: '搜索活动名称',
  join_location: '参与门店',
  not_found_friend_fission: '未查询到好友裂变活动',
  select_friend_fission_activity: '选择好友裂变活动',
  loading_friend_fission: '正在加载 好友裂变',
  fun_game: '趣味竞猜',
  activity_date: '活动时间',
  custom_activity_date: '活动时间: 自定义',
  no_query_fun_game_activity: '未查询到趣味竞猜活动',
  select_fun_game: '选择趣味竞猜',
  gift_lucky_draw_activities: '抽奖有礼活动',
  lucky_group_empty_tip: '未查询到抽奖有礼活动',
  choose_gift_rewards_draw: '选择抽奖有礼活动',
  group_activities: '拼团活动',
  not_join_location_count: '家门店不参与',
  join_location_count: '家门店参与',
  no_query_group_activity: '未查询到拼团活动',
  select_group_activities: '选择拼团活动',
  group_people_number: '成团人数',
  group_relay_activities: '群接龙活动',
  group_relay_empty_tip: '未查询到群接龙活动',
  choose_group_relay: '选择群接龙活动',
  receive_coupon_center: '领券中心',
  page_setting: '页面设置',
  not_found_discount_ticket_pack: '未查询到优惠券包',
  edit_decorate_recevice_coupon_center: '编辑店铺装修领券中心',
  decorate_recevice_coupon_center: '店铺装修领券中心',
  add_decorate_recevice_coupon_center: '新建店铺装修领券中心',
  read_decorate_recevice_coupon_center: '查看店铺装修领券中心',
  boot_page: '首屏启动页',
  enter_custom_picture: '请上传自定义图片',
  edit_boot_page: '编辑首屏启动页',
  decorate_navigation_boot_page: '店铺装修首屏启动页',
  read_boot_page: '查看首屏启动页',
  product_content_management: '菜品内容管理',
  batch_set_message: '批量设置留言',
  welcome: '欢迎您的光临',
  edited_asc: '已编辑(旧-新)',
  edited_desc: '已编辑(新-旧)',
  title_name_asc: '标题名称(A-Z)',
  title_name_desc: '标题名称(Z-A)',
  blank_space: '空白',
  default: '默认',
  decorate_navigation_content_management: '店铺装修内容管理',
  fiter_product: '筛选菜品',
  product_series: '菜品系列',
  no_product_category_information: '暂无菜品类别信息',
  material_management: '素材管理',
  read_decorate_navigation_custom_module_list: '查看店铺装修自定义模版列表',
  decorate_navigation_custom_module: '店铺装修自定义模块',
  delete_custom_module: '删除自定义模版',
  batch_delete_custom_module: '批量删除自定义模版',
  edit_custom_module_page_name: '编辑自定义模版页面名称',
  modified_success: '修改成功',
  copy_custom_module: '复制自定义模版',
  not_custom_module: '没有自定义模块',
  delete_module: '删除模块',
  grid: '网格',
  list: '列表',
  customiz_page: '自定义模块',
  custom_module_desc:
    '自定义模块主要用于店铺页面装修；您可以制作一个“自定义模块”，然后把它嵌入到其它任何店铺页面中。',
  please_enter_module_name: '请填写模块名称',
  custom_module_name: '自定义模块名称',
  custom_module_setting: '自定义模块设置',
  return_custom_module_page: '返回自定义模块页面',
  view_load_animation: '查看加载动画',
  decorate_navigation_load_animation: '店铺装修加载动画',
  edit_load_animation: '编辑加载动画',
  read_classification_template: '查看分类模版',
  decorate_navigation_classification_template: '店铺装修分类模版',
  main_window_setting_icon: '请完善主窗口设置图标',
  sub_window_setting_icon: '请完善子窗口设置图标',
  edit_suspended_window: '编辑悬浮窗',
  create_suspended_window: '创建悬浮窗',
  read_gift_card: '查看礼品卡',
  decorate_navigation_gift_card: '店铺装修礼品卡',
  please_add_tile_content: '请添加平铺内容',
  please_add_grouping_content: '请添加分组内容',
  group_title_cannot_empty: '分组标题不能为空',
  group_subtitle_cannot_empty: '分组子标题不能为空',
  group_add_cannot_empty: '分组添加内容不能为空',
  edit_gift_card: '编辑礼品卡',
  read_commodity_page_template: '查看菜品页模版',
  decorate_navigation_commodity_page_template: '店铺装修菜品页模版',
  descorate_navigation_package_decoration: '店铺装修套餐页面装修',
  add_to_card: '加入购物车',
  please_fill_in_title_name: '请填写标题名称',
  please_fill_in_purchase_button: '请填写加购按钮',
  please_fill_in_buy_button: '请填写购买按钮',
  complete_auxiliary_navigation_information: '请完善添加的辅助导航信息',
  please_add_at_least_one_recommended_advertisement: '请添加至少一个推荐广告',
  please_recommend_the_advertisement: '请为推荐广告',
  add_picture: '添加图片',
  picture_one: '一',
  picture_two: '二',
  picture_three: '三',
  picture_four: '四',
  picture_five: '五',
  picture_six: '六',
  picture_seven: '七',
  picture_eight: '八',
  picture_nine: '九',
  picture_ten: '十',
  edit_commodity_page_template: '编辑菜品页模版',
  create_commodity_page_template: '创建菜品页模版',
  decoration_page: '装修页面',
  related_goods: '关联菜品',
  commodity_page_template: '菜品页模板',
  add_commodity_page_template: '新增菜品页模板',
  filter_template: '筛选模版',
  product_page_template: '菜品页模版',
  read_decorate_navigation_list_template: '查看店铺装修列表模版',
  decorate_navigation_list_template: '店铺装修列表模版',
  edit_decorate_navigation_list_template: '编辑店铺装修列表模版',
  list_template: '列表模板',
  decorate_navigation_point_shop: '店铺装修积分商城',
  please_fill_page_name: '请填写页面名称',
  mall_page: '商城页面',
  integral: '积分',
  balance: '余额',
  read_shop_page: '查看店铺页面',
  decorate_navigation_shop_page: '店铺装修店铺页面',
  configure_three_asset_informatio: '需要选择三种资产',
  edit_shop_page: '编辑店铺页面',
  create_shop_page: '创建店铺页面',
  flower_template: '鲜花模板',
  tea_module: '茶饮模板',
  light_meal_module: '轻餐模板',
  cure_module: '烘焙模板',
  tea_with_milk_module: '奶茶模板',
  fruit_template: '水果模板',
  cooked_food_template: '熟食模板',
  create_new_page: '创建新页面',
  blank_space_module: '空白模板',
  ues_template: '使用模板',
  read_shop_page_list: '查看店铺页面列表',
  shop_name: '店铺名称',
  label_operate_content: '为店铺页面[{{operationPage}}]打标签',
  operate_success: '操作成功',
  delete_home_page_warning: '批量删除不可以删除主页',
  batch_delete_shop_page: '批量删除店铺页面',
  delete_shop_page: '删除店铺页面',
  set_home_page_operate_content: '将店铺页面[{{name}}]设为主页',
  setting_fail: '设置失败',
  copy_shop_page: '复制店铺页面[{{name}}]',
  no_shop_page: '没有店铺页面',
  delete_page: '删除页面',
  page_face: '页面',
  home: '主页',
  setting_home: '设为主页',
  page_name: '页面名称',
  belong_location: '归属门店',
  update_time: '更新时间',
  filter_page_name: '筛选页面名称',
  merchant_page: '店铺页面',
  active: '启用',
  distribution_location_operate_content: '为店铺页面[{{operationPage}}]分配门店',
  distribution_success: '分配成功',
  online_store_status: '网店状态',
  number_of_selected_items: '已选{{selectedResources}}条',
  not_query_location: '未查询到门店',
  please_enter_location_name: '请输入门店名称',
  area_change: '请选择省市区',
  provinces_and_cities: '省市区',
  please_select_custom_image: '请选择自定义图片',
  my_point: '我的积分',
  exchange_history: '兑换历史',
  read_point_mall: '查看积分商城',
  edit_point_mall: '编辑积分商城',
  point_mall_setting: '积分商城设置',
  return_point_mall_page: '返回积分商城页面',
  category_template: '分类模板',
  read_search_page: '查看搜索页',
  decorate_navigation_search_page: '店铺装修搜索页',
  please_fill_default_keyword: '请填写默认关键词',
  please_fill_hot_word: '存在未填写的热词，请输入后再保存',
  edit_search_page: '编辑搜索页',
  create_search_page: '创建搜索页',
  search_page: '搜索页',
  share_store_copy: '分享给您一个宝藏店铺，赶紧来探秘',
  collate_together: '一起拼单',
  read_share_page_list: '查看分享页列表',
  share_page: '分享页',
  please_fill_custom_share_title: '请填写自定义分享标题',
  please_select_custom_share_page: '请选择自定义分享图片',
  edit_share_page: '编辑分享页',
  decorate_navigation_share_page: '店铺装修分享页',
  edit_classification_template: '编辑分类模版',
  hot_sell: '热销',
  read_merchant_navigation_template: '查看店铺导航模板',
  decorate_navigation_store_navigation: '店铺装修店铺导航',
  please_improve_primary_navigation_information: '请完善一级导航信息',
  please_improve_secondary_navigation_information: '请完善二级导航信息',
  please_add_navigation: '请添加导航',
  please_improve_navigation_information: '请完善导航信息',
  edit_merchant_navigation_template: '编辑店铺导航模板',
  create_merchant_navigation_template: '创建店铺导航模板',
  merchant_navigation_template: '店铺导航模板',
  edit_store_style: '编辑全店风格',
  decorate_navigation_store_style: '店铺装修全店风格',
  read_store_style: '查看全店风格',
  wecheat_applet_page_style: '微信小程序页面风格',
  secondary_classification: '二级分类',
  settle_accounts: '结算',
  classification: '分类',
  another_order: '再来一单',
  immediate_payment: '立即支付',
  page_color_system: '页面色系',
  system: '系统',
  theme_color: '主题颜色',
  secondary_color: '辅助颜色',
  top_color_system: '顶部色系',
  system_color_tootip: '仅适用于微信小程序，装修页面和用户中心可单独修改顶部颜色',
  table_order: '台位点单',
  edit_table_order: '编辑分享页',
  decorate_navigation_table_order: '店铺装修台位点餐',
  address_management: '地址管理',
  my_shop: '我的门店',
  personal_information: '个人信息',
  account_setting: '账户设置',
  user_head: '用户头部',
  user_assets: '用户资产',
  membership_card: '会员卡',
  my_features: '我的功能',
  advertising_position: '广告位',
  my_order: '我的订单',
  edit_user_center: '编辑用户中心',
  decorate_navigation_user_center: '店铺装修用户中心',
  read_user_center: '查看用户中心',
  return_user_center_list: '返回用户中心列表',
  current_page_user_center: '当前页面：用户中心',
  sort_page: '分类页',
  self_pick_sort: '分类页自提',
  local_delivery_sort: '分类页配送',
  cart: '购物车',
  user_center_page: '用户中心',
  point_goods: '指定菜品',
  point_kit: '指定套餐',
  point_category: '指定类别',
  order_list: '全部订单',
  refund_aftersale: '售后记录',
  list_address: '地址列表',
  member_code: '会员码',
  point_user_protocol: '指定用户协议',
  advice_feedback: '建议反馈',
  mall_home_page: '商城主页',
  appoint_mall_product: '指定商城菜品',
  reserve_page: '菜品预约',
  mine: '我的',
  choose: '选择',
  group_buying_list: '拼团列表',
  friend_joint_order: '好友拼单',
  discount_ticket_pack_list: '优惠券包列表',
  select_discount_ticket_pack: '选择优惠券包',
  group_relay_list: '群接龙列表',
  choose_new_customer_exclusive: '选择新客专享',
  function_page: '功能页面',
  crm_page: '营销页面',
  marketing_activities: '营销活动',
  page_tag: '页面标签',
  series_name: '系列名称',
  other_page: '其他页面',
  custom_page: '自定义页面',
  enter_custom_page_address: '请输入自定义页面地址',
  link_address: '链接地址',
  link_address_help_text: '小程序已支持跳转至关联的公众号的文章，其他链接暂不支持跳转。',
  page_path: '页面路径',
  page_path_help_text: '仅支持跳转当前小程序路径',
  not_query_more_link_address: '未查询到更多链接地址信息',
  select_activity_message: '最多允许添加5个活动',
  add_jump_link: '添加跳转链接',
  add_goods_category: '添加菜品类别',
  no_pictures: '暂无图片哦～',
  no_video: '暂无视频哦～',
  move_to: '移动到',
  file_name_cannot_empty: '文件名称不可为空',
  update_file_name_success: '修改文件名称成功',
  not_query_more_material: '未查询到更多素材信息',
  create_date: '创建日期',
  delete_photo_tip: '删除图片后，不会对已使用该图片的相关业务造成影响。',
  delete_video_tips:
    '视频被删除后将无法恢复，所有使用该视频的页面对应的视频都无法播放或访问，请慎重操作。',
  confirm_delete_image: '确认要删除所选图片吗',
  confirm_delete_video: '确认要删除所选视频吗',
  please_select_icon: '请选择图标',
  choose_n_yuan_activity: '选择N元任选活动',
  read_discount_ticket_pack: '查看优惠券包',
  select_specified_kit: '选择指定套餐',
  picture_name_rule: '图片命名不能包含空格，请检查上传的图片命名!',
  card_face_style: '卡面风格',
  purity: '纯色',
  card_face_background_color: '卡面背景颜色',
  card_face_background_img: '卡面背景图片',
  card_face_background_img_size: '建议尺寸：318*118',
  copy_setting: '文案设置',
  copywriting_color: '文案颜色',
  style_setting: '样式设置',
  margin_top: '上边距',
  side_margin: '左右边距',
  module_fillet: '模块圆角',
  page_name_cannot_empty: '页面名称不可为空',
  please_add_at_least_one_graphic_advertisement: '请添加至少一个图文广告',
  please_provide_picture: '请为图片',
  please_fill_custom_name_activity_product: '请填写活动菜品的自定义名称',
  title_name_cannot_empty: '标题名称不可为空',
  please_add_banner_image: '请添加广告图片',
  head_background: '头部背景',
  head_background_color: '头部背景颜色',
  head_background_img: '头部背景图片',
  head_background_img_recommended_size: '建议尺寸',
  style_one: '样式一',
  style_two: '样式二',
  style_three: '样式三',
  position_of_personal_portrait: '个人头像位置',
  txt_color: '文本颜色',
  hide: '隐藏',
  order_style: '订单样式',
  display_according_to_order_progress:
    '按照订单进度展示分为：待付款、待自提、待发货、待收货维度展示；',
  display_by_order_type: '按照订单类型展示分为：门店订单、积分商城订单、礼品卡订单、权益卡订单。',
  applet_order_display: '小程序订单展示',
  applet_order_display_control_copy: '控制商家小程序订单列表不同订单的入口展示和隐藏',
  shop_order: '门店订单',
  points_mall_order: '积分商城订单',
  benefit_card_order: '权益卡订单',
  voucher_package_order: '券包订单',
  pay_refund: '退款记录',
  from_you: '距您',
  select_image: '选择图片',
  search_you_want: '搜索你想要的',
  module_reached_maximum: '模块数量已达最大值，不可继续添加',
  sign_in_immediately: '立即签到',
  sweetness: '甜度',
  measure: '尺寸',
  sale_volume: '销量',
  default_food_name: '桂花银耳青苹果豆腐慕斯',
  default_food_desc: '0脂肪0添加',
  favourable: '优惠',
  preferential_superposition: '优惠叠加',
  preferential_superposition_tip:
    '买家下单仅可与勾选的活动类型同时使用，如果不勾选，参加满X件Y折活动后的菜品不可以使用优惠券。',
  special_discount: '优惠折扣',
  default_full_decrement: '满200减20',
  half_price_second_piece: '第二件半价',
  send_from: '中国上海 快递7.00元',
  send_to: '配送至：宁波市鄞州区新明街道',
  return_shop_page: '返回店铺页面',
  save_and_continue: '保存并继续',
  component_management: '组件管理',
  remove_all_modules: '移除所有组件',
  confirm_remove_all_modules: '确定移除所有组件？',
  content_setting: '内容设置',
  module_style: '模块样式',
  related_content: '关联内容',
  custom_classification: '自定义分类',
  template_style: '模板样式',
  detail_list: '详细列表',
  dual_column_mode: '双列模式',
  large_image_mode: '大图模式',
  more_content: '更多内容',
  popular_goods: '畅销菜品',
  popular_goods_display_time_three_days: '设置最近3天，展示最近3天的畅销菜品；',
  popular_goods_display_time_seven_days: '设置最近7天，展示最近7天的畅销菜品；',
  popular_goods_display_time_one_month: '设置最近30天，展示最近30天的畅销菜品；',
  popular_goods_display_number: '最多显示12个菜品，需要系统菜品销量大于0才会显示。',
  past_three_days: '最近3天',
  past_weeks: '最近7天',
  past_months: '最近30天',
  popular_goods_picture_size: '畅销菜品类别图片，建议上传72*72像素的png图片',
  package_settings: '套餐设置',
  package_corner_label: '套餐角标',
  package_copy: '套餐文案',
  select_specification: '选规格',
  select_combo: '选套餐',
  product_display: '菜品展示',
  product_series_pictures: '菜品系列图片',
  product_category_picture: '菜品类别图片',
  number_of_categories: '类别数量',
  short_title: '短标题',
  reason_recommendation: '推荐理由',
  product_sale_volume: '菜品销量',
  crossed_prices: '划线价格',
  search_entrance: '搜索入口',
  search_style: '搜索样式',
  system_classification_sorting: '系统分类排序',
  data_completion_and_readding: '请先把之前的数据补全再添加',
  page_style: '页面样式',
  mode_type_save_picture: '餐饮样式不支持长按保存图片，零售样式支持长按保存图片',
  template_setting: '模版设置',
  default_template: '设置菜品默认模板',
  description_associated_product_template: '除了关联菜品外，所有菜品默认使用该模板。',
  inventory_sales_display: '库存/销量显示',
  show_sales_volume: '显示销量',
  show_inventory: '显示库存',
  top_style: '顶部风格',
  standard: '标准',
  immersive: '沉浸式',
  transaction_button: '交易按钮',
  add_button: '加购按钮',
  purchase_button: '购买按钮',
  recommended_advertising: '推荐广告',
  show: '展示',
  product_detail_advertisement_picture_propose:
    '最多添加5个图片，鼠标拖拽调整图片顺序， 建议像素345*145',
  auxiliary_navigation: '辅助导航',
  add_up_to_three: '最多添加三个',
  icon: '图标',
  select_icons: '选择图标',
  lisr_template_dispose_desc:
    '此处可以设置店铺全部菜品和菜品系列的列表展示，也可以修改页面分享的标题、描述等内容',
  navigation_bar_settings: '导航栏设置',
  top_background: '顶部背景',
  background_color: '背景颜色',
  background_picture: '背景图片',
  size_color: '字体颜色',
  card_setting: '卡片设置',
  biserial: '双列',
  arrange_style: '排列样式',
  waterfall_flow: '瀑布流',
  product_style: '菜品样式',
  white_ground_and_no_border: '无边白底',
  card_projection: '卡片投影',
  outline_and_white_background: '描边白底',
  product_border_raduis: '菜品圆角',
  product_spacing: '菜品间距',
  display_setting: '显示设置',
  list_template_desc:
    '推荐理由和短标题需要在【店铺装修】【菜品装修】【内容管理】中设置。如果菜品同时含有以下内容，只展示优先级最高的部分：会员价标签>>推荐理由',
  product_detail_dsiplay: '菜品详情展示',
  standard_edition: '标准版',
  concise_version: '简洁版',
  top_style_background_img:
    '建议尺寸375*88px，可上传营销图、品牌标志等，建议背景底色与分类页底色相同',
  gift_card_picture_propose: '最多添加5个图片，鼠标拖拽调整图片顺序， 建议像素690*150px',
  photo_ads: '图文广告',
  recommend_product_display_limit: '推荐菜品需要设置活动后才会显示',
  activity_product: '活动菜品',
  activity_product_tooltip:
    '增加活动菜品分类，展示系统设置的折扣菜品，包括满减满折、满X件Y折活动；',
  most_display_product_number: '最多展示100个菜品。',
  custom_name: '自定义名称',
  discount_item_category_picture_size: '折扣菜品类别图片，建议上传72*72像素的png图片',
  activity_display: '活动展示',
  choose_dining_information_before_dining_in_the_cafeteria: '堂食就餐前选择就餐信息',
  click_standard_edition_product: '标准版：点击菜品时，跳转详情页显示菜品详情',
  click_concise_version_product: '简洁版：点击菜品时，弹框显示菜品详情',
  other_instructions: '其他说明',
  if_both_of_the_following_contents_are_included_only_the_highest_priority_part_will_be_displayed_activity_tag_member_price_tag_recommendation_reason:
    '如果点单页菜品同时含有以下内容，只展示优先级最高的部分：活动标签>>会员价标签>>推荐理由',
  double_column_mode_does_not_display_product_sales_by_default: '双列模式默认不展示菜品销量',
  shopping_cart_settlement_display: '购物车结算展示',
  shopping_cart_settlement: '购物车结算',
  single_entry: '拼单入口',
  single_style: '拼单样式',
  fighting_alone_name: '拼单自定义名称',
  joint_order_category_picture_size: '建议上传24*24像素的图片',
  coupon_entry: '优惠券入口',
  tripartite_coupon_entry: '三方券入口',
  go_shopping: '去抢购',
  please_add_limited_time_discount_activity: '请添加限时折扣活动',
  please_add_activity_display_name: '请添加活动显示名称',
  product_style_setting: '菜品样式设置',
  transparent_and_no_border: '无边透明',
  activity_content_setting: '活动内容设置',
  count_down: '倒计时',
  crossed_price: '划线价',
  remaining_inventory: '剩余库存',
  list_style: '列表样式',
  activity_setting: '活动设置',
  activity_drag_sort: '添加活动（最多5个，可拖动排序）',
  sort_type: '排序方式',
  add_items_reverse_order_time: '按活动菜品添加时间倒序',
  show_name: '显示名称',
  add_to: '添加',
  product_text_setting: '菜品文字设置',
  get_the_countdown: '抢购倒计时',
  to_a_group: '去拼团',
  add_activity: '添加活动',
  only_add_activities_not_started: '仅支持添加未开始和进行中的活动',
  two_in_a_row: '一行两个',
  choose_a_group_event: '请选择拼团活动',
  please_add_benefit_card: '请添加权益卡',
  border_fillet: '边框圆角',
  shadow: '阴影',
  please_add_collection_card_activity: '请添加集点卡活动',
  card_style: '卡片样式',
  four_in_a_row: '一行四个',
  five_in_a_row: '一行五个',
  six_in_a_row: '一行六个',
  background_setting: '背景设置',
  color: '颜色',
  text_color: '文字颜色',
  content_area_style_setting: '内容区样式设置',
  most_one_activity_can_added: '最多允许添加一个活动',
  text_format: '文本格式',
  specify_date: '指定日期',
  new_product: '新品',
  number_format: '数字格式',
  single_select: '单项选择',
  multiple_choices: '多项选择',
  fill_current_day: '填写当天',
  fill_in_before: '填写日前',
  fill_in_after: '填写日后',
  enter_reason_recommendation: '请输入推荐理由',
  enter_message_title: '请输入留言标题',
  please_add_common_message: '请添加常用留言',
  enter_common_message: '请输入常用留言',
  best_sellers: '热卖',
  subheading_application_scenario: '该标题可在店铺装修的分类模板、列表模块中设置启用',
  words_written_at_departure: '留言',
  message_application_scenario:
    '该留言主要用于店铺场景：购买菜品时让买家输入留言，最多可设置10条留言',
  field_format: '字段格式',
  default_value: '默认值',
  enter_message_prompt: '请输入留言提示语',
  add_option: '添加选项',
  checked_cannot_empty: '勾选后，该字段不能为空',
  common_message_options: '常用留言选项',
  add_common_message: '添加常用留言',
  add_field: '添加字段',
  picture_material: '图片素材',
  picture_application_scenario:
    '该图片主要用于店铺装修的瀑布流模块，如果某个菜品上传过图片素材，瀑布流中优先使用图片素材',
  system_default: '系统默认',
  series: '系列',
  recommendz: '推荐',
  default_food_name2: '豆腐慕斯',
  default_food_name3: '桂花银耳',
  default_food_name4: '青苹果',
  new_customer_exclusive_empty_tip: '未查询到新客专享活动',
  filter_material_name: '筛选图片名称',
  icon_mode: '图标模式',
  list_mode: '列表模式',
  created_desc: '已编辑（新-旧）',
  created_asc: '已编辑（旧-新）',
  alpha_asc: '素材名称（A-Z）',
  alpha_desc: '素材名称（Z-A）',
  select_all: '全选',
  items_selected: '已选择{{selectSum}}项',
  confirm_delete_classification: '将要删除该分类，是否确定',
  select_specified_product: '选择指定菜品',
  search_specified_product: '搜索指定菜品',
  no_find_limited_time_discount_activities: '未查询到限时折扣活动',
  select_time_limited_discount_activities: '选择限时折扣活动',
  select_product_restrictions: '最多可选择5件菜品',
  join_customer: '参与客户',
  my_module: '我的模块',
  basic_module: '基础模块',
  basic_components: '基础组件',
  member_component: '会员组件',
  module_title: '模块标题',
  picture_advertisement: '图片广告',
  picture_and_text_navigation: '图文导航',
  product_search: '菜品搜索',
  notice: '公告',
  split: '辅助分割',
  cube: '魔方',
  rich_text: '富文本',
  marketing_component: '营销组件',
  point_exchange_activity: '积分兑换活动',
  public_account: '公众号',
  pocket: '券包',
  please_upload_title_icon_image: '请上传标题图标图片',
  please_upload_background_image: '请上传背景图片',
  please_improve_picture: '请完善图片！',
  incomplete_content_setting_information: '内容设置信息不全，请补全相关信息',
  no_select_product: '尚未选择菜品，请选择菜品后再保存',
  please_add_product_series: '请添加菜品系列',
  please_fill_menu_name: '请填写菜单名称',
  please_fill_number_displays: '请填写显示个数',
  announcement_incomplete: '公告内容不全，请补全公告内容',
  please_select_custom_icon: '请选择自定义图标',
  rubik_cube_layout_picture: '请上传魔方布局图片',
  please_upload_local_video: '请上传本地视频',
  please_paste_video_address: '请粘贴视频地址',
  please_upload_custom_cover: '请上传自定义封面',
  please_add_rich_text_content: '请添加富文本内容',
  please_select_custom_module: '请选择一个自定义模块！',
  please_add_coupons: '请添加优惠券',
  please_upload_received_picture: '请上传已领取图片',
  please_upload_unclaimed_picture: '请上传未领取图片',
  please_upload_custom_icon: '请上传自定义图标',
  please_upload_custom_background_image: '请上传自定义背景图片',
  please_upload_redemption_history_mode_icon: '请上传兑换历史模式图标',
  select_coupon_bag_activity: '请选择券包活动',
  form_field_tips: '表单信息不全，请补齐相关信息',
  collect_success: '收藏成功',
  collect_fail: '收藏失败',
  collect_limit: '已达到最大收藏数，不可以再收藏！',
  starting_from_the_event: '距活动开始',
  from_end: '距活动结束',
  this_is_the_coupon_label: '这是券包标签',
  discount_ticket_pack_tag: '券包标签',
  every_day_sign_in: '每日签到',
  any_people_group: '人团',
  display_product_name: '这里显示菜品名称',
  apple: '苹果',
  show_recommendation_reason: '这里显示推荐理由',
  add_element: '添加元素',
  hot_zone: '热区',
  written_words: '文字',
  rotation_chart: '轮播图',
  module_setting: '模块设置',
  module_height: '模块高度',
  screenshot: '截图',
  enter_text: '输入文本',
  member_name: '会员名',
  member_benefit: '会员权益',
  re_obtain: '再获取',
  upgrade_platinum_membership: '成长值即可升级为白金会员',
  acquire_membership_interests: '获取会员专享权益',
  unlock_more_benefits: '更多会员权益等你解锁，快注册吧！',
  setting_logo: '二维码logo',
  customer_avatar: '客户头像',
  font_color: '字体颜色',
  exchange_history_mode: '兑换历史模式',
  exchange_history_text: '兑换历史文字',
  please_upload_logo: '请上传LOGO设置自定义图片',
  default_module_content: '我是模块内容哦',
  default_content_description: '我是模块说明哦',
  see_more: '查看更多',
  module_sub_title: '我是模块小标题哦',
  more: '更多',
  notice_content: '公告内容',
  fill_notice_content: '请填写公告内容',
  single_link: '单链接',
  navigation_one: '导航一',
  navigation_two: '导航二',
  navigation_three: '导航三',
  navigation_four: '导航四',
  navigation_five: '导航五',
  navigation_six: '导航六',
  navigation_seven: '导航七',
  navigation_eight: '导航八',
  navigation_nine: '导航九',
  navigation_ten: '导航十',
  navigation_eleven: '导航十一',
  navigation_twelve: '导航十二',
  exhibition_activities: '展示活动',
  please_add_point_exchange_coupon: '请添加积分兑换券',
  point_redemption_activity: '积分兑换活动',
  custom_activity: '自定义活动',
  insufficient_points: '积分不足',
  exchange_completed: '已兑完',
  to_exchange: '去兑换',
  style: '样式',
  style_four: '样式四',
  nearby_stores: '附近门店',
  view_more_stores: '查看更多门店',
  default_shop_name: '月湖盛园(月湖店)',
  distance_from_you: '距离您500米',
  please_reselect_product_line: '当前菜品系列无可用菜品，请重新选择菜品系列',
  group_one: '分组一',
  group_two: '分组二',
  product_data_loading: '菜品数据加载中',
  search_product_you_want: '搜索你想要的菜品',
  preset_content: '预设内容',
  text_position: '文本位置',
  box_color: '框体颜色',
  border_color: '边框颜色',
  box_height: '框体高度',
  box_fillet: '框体圆角',
  text_setting: '文本设置',
  registration_guide_copy: '注册引导文案',
  show_position: '展示位置',
  floating_bottom: '悬浮在底部',
  notice_for_use: '使用须知',
  setting_wechat_focus_public_account_satisfy_condition: '设置小程序关注公众号，必须满足以下条件',
  merchant_wechat_public_account_setting:
    '商户后台-微信小程序-公众号设置-公众号授权中已绑定公众号（服务号）',
  setting_public_account_with_theme_unanimous: '设置的公众号需与小程序主体一致',
  use_prompt_copy_of_official_account_component_before_txt: '使用组件前，需前往',
  mini_program_background: '小程序后台',
  use_prompt_copy_of_official_account_component_after_txt:
    '在“设置”>“关注公众号”中设置要展示的公众号。',
  pay_attention_public_account_the_brand_discounts_in_real_time: '关注公众号，品牌优惠实时掌握',
  focus_on: '关注',
  the_public_account_associated_with_a_small_program: '小程序关联的公众号',
  lemon_shop: '乐檬shop',
  complete_hardware_and_product_ecology_help_users: '完善的硬件及产品生态帮助用户',
  rich_text_one: '点此编辑「富文本」内容',
  rich_text_two: '你可以对文字进行',
  rich_text_three: '等简单排版操作。',
  rich_text_four: '也可以在这里插入图片、并对图片加上超级链接，方便用户点击。',
  oblique_body: '斜体',
  underline: '下划线',
  delete_line: '删除线',
  as_well_as: '以及',
  font_sizes: '字号大小',
  rich_text_thick: '加粗',
  rich_text_color: '文字颜色',
  rich_text_background: '背景色',
  blank_height: '空白高度',
  line_style: '线样式',
  solid: '实线',
  dashed: '虚线',
  dotted: '点线',
  top_and_bottom_margins: '上下边距',
  line_width: '线宽',
  line_color: '线颜色',
  auxiliary_blank: '辅助空白',
  guide: '辅助线',
  again_collect: '再集',
  again_collect_after: '点可兑换礼品',
  convertible_gifts: '可兑换礼品',
  boot_page_tips: '打开小程序时，默认展示首屏启动页',
  forbidden: '禁用',
  custom_picture: '自定义图片',
  upload_image_tips3:
    '仅支持 gif、jpeg、 png、 bmp 4种格式，推荐像素 375 * 812，大小不超过 5M，最多上传1张',
  skip: '跳过',
  discount_ticket_type: '券类型',
  show_more_product_series: '显示更多 菜品系列',
  batch_set_subscript: '批量设置角标',
  product_subscript: '菜品角标',
  technical_identification: '乐檬提供技术支持',
  please_select_dinner_persons: '请选择就餐人数',
  start_order: '开始点餐',
  default_image: '缺省图',
  independent_entrance_prompt: '为保证页面展示效果，最多勾选两个独立入口',
  independent_entrance_display: '独立入口展示',
  float_window_icon_size: '建议尺寸：100px*100px',
  custom_picture_limit: '请上传gif、svg、png格式文件',
  load_animation_size: '建议尺寸 150 * 150像素，gif、svg、png格式',
  default_load_animation: '默认加载动画',
  custom_load_animation: '自定义动画',
  advertisement_number_limit: '最多添加6个广告,已达添加上限',
  advertising_content: '广告内容',
  rotation_advertisement: '轮播广告',
  add_up_to_six_advertisements: '最多添加6个广告，',
  first_picture_determines_module_height: '第一张图片决定模块高度',
  advertisement_size: '，鼠标拖拽可以调整广告顺序，建议宽度375px',
  module_top_spacing: '模块顶部间距',
  module_bottom_spacing: '模块底部间距',
  module_left_and_right_margins: '模块左右边距',
  picture_fillet: '图片圆角',
  by_order_type: '按照订单类型展示',
  by_order_progress: '按照订单进度展示',
  restore_default: '恢复默认',
  menu_icon: '菜单图标',
  menu_name: '菜单名称',
  edit_menu: '编辑菜单',
  add_menu: '添加菜单',
  user_defined: '用户自定义',
  icon_size: '图标尺寸',
  default_icon: '默认图标',
  add_separator: '添加分隔符',
  separator: '分隔符',
  menu_arrangement: '菜单排列',
  classic: '经典版',
  sudoku: '九宫格',
  icon_show: '图标显示',
  not_show: '不显示',
  menu_function: '菜单功能',
  top_background_color: '顶部背景颜色',
  top_background_img: '顶部背景图片',
  top_text_color: '顶部文字颜色',
  page_background_color: '页面背景颜色',
  send_save: '寄存',
  tripartite_coupon: '三方券',
  asset_allocation: '资产配置',
  module_background_color: '模块背景颜色',
  module_text_color: '模块文字颜色',
  no_advertisement_please_add: '暂无广告，请点击添加！',
  platinum_member: '铂金会员',
  next_level_need_100001_growh_value: '再获取10001成长值升级为星耀会员',
  pending_payment_order: '待付款',
  to_self_pick: '待自提',
  goods_to_be_received: '待收货',
  wechat_nickname: '微信昵称',
  essential_tools: '必备工具',
  activate_vip_membership: '开通VIP会员',
  customer_service_hotline: '客服热线',
  contact_customer_service: '联系客服',
  loading_coupon_package: '正在加载 券包',
  most_optional_50_items: '最多可选50项',
  no_query_coupon_package: '未查询到券包活动',
  select_couponpackage_activity: '选择券包活动',
  loading_coupon_package_activity: '正在加载 券包活动',
  loading_group_buy: '正在加载 拼团',
  loading_grounp_activity: '正在加载 拼团活动',
  loading_time_limit_discount: '正在加载 限时折扣',
  no_find_point_redemption_activity: '未查询到积分兑换活动',
  all_activity: '全部活动',
  activity_selected: '已选活动',
  point_exchange: '积分兑换',
  point_exchange_activity_loading: '正在加载 积分兑换活动',
  exchanged_and_current_inventory: '已兑/当前库存',
  everyone_exchange_limit_short: '每人限兑',
  clear_selected: '清除已选项',
  search_goods_serious: '搜索菜品系列',
  searching_goods_serious: '正在搜索菜品系列',
  searching_product: '正在搜索菜品',
  gift_card_themes: '礼品卡主题',
  no_find_gift_card_themes: '未查询到礼品卡主题',
  all_themes: '全部主题',
  themes_selected: '已选主题',
  select_gift_card_themes: '选择礼品卡主题',
  search_gift_card_themes_name: '搜索礼品卡主题名称',
  term_of_validity: '有效期',
  all_image: '全部图片',
  all_videos: '全部视频',
  category_name_cannot_empty: '分类名称不能为空',
  new_classification: '新建分类',
  classification_name: '分类名称',
  delete_material_center_classification: '删除素材中心分类[{{name}}]',
  material_center: '素材中心',
  rename_material_center_classification: '重命名素材中心分类',
  move_up_material_center_classification: '上移素材中心分类',
  move_down_material_center_classification: '下移素材中心分类',
  add_subcategory: '添加子分类',
  no_product_series_found: '未查询到菜品系列',
  choose_goods_series: '选择菜品系列',
  filter_goods_series_name: '筛选菜品系列名称',
  product_series_name: '菜品系列名称',
  upload_videos_error_message: '请上传mp4格式的文件',
  video_name_restrictions: '视频名称必填且不得超过20个字',
  please_upload_the_correct_video_format: '请上传正确的视频格式',
  video_size_exceeds_limit: '视频大小超出限制',
  upload_image_success: '上传视频成功',
  duration: '时长',
  upload_video: '上传视频',
  local_video: '本地视频',
  video_size_superior_limit: '请上传小于200M的视频',
  please_input_title: '请输入标题文案',
  discount_ticket_tmpl_product_exchange: '兑换券',
  purchase_a_gift_b: '满A赠B券',
  limited_quantity_of_free_vouchers: '限制数量免单券',
  exemption: '免',
  part: '件',
  discount_qty: '优惠件数',
  max_discount_qty: '最大优惠件数',
  reduced_to: '减至',
  start: '开始',
  apply: '适用',
  exchange_coupon: '兑换券',
  full: '满',
  pieces: '件',
  money_unit: '元',
  available: '可用',
  no_threshold: '无门槛',
  receive: '领取',
  collar: '领',
  take: '取',
  claim_now: '立即领取',
  nanjingwande: '南京万得大厦店',
  store_up: '储',
  default_stored_value_discount: '单次储值200减50',
  product_one: '菜品1',
  product_two: '菜品2',
  product_three: '菜品3',
  product_four: '菜品4',
  high_cost_performance: '性价比高',
  kit_title: '套餐名称',
  tangerine: '橘子',
  short_tangerine: '橘',
  kiwi_fruit: '猕猴桃',
  short_kiwi_fruit: '猕',
  watermelon: '西瓜',
  short_watermelon: '西',
  select_appoint_mall_product: '选择指定商城菜品',
  no_find_category: '未查询到类别',
  select_specified_category: '选择指定类别',
  search_specified_category: '搜索指定类别',
  agreement_name: '协议名称',
  modify_time: '修改时间',
  upload_image_error_tips: '仅支持 gif、jpeg、png、bmp 4种格式',
  upload_img: '请上传一张png、jpg、jpeg或者gif格式的文件',
  max_upload_size: '最多可上传{{size}}张',
  upload_image_requirement: '请上传一张jpg或者jpeg的图片',
  upload_succeeded: '上传成功',
  first_name_cannot_be_empty: '名字不能为空',
  sold_out: '已售罄',
  application_location: '应用门店',
  navigation: '导航',
  unchecked: '未选中',
  level_one_navigation: '一级导航',
  level_two_navigation: '二级导航',
  select_navigation_icon: '选择导航图标',
  all_series: '全部系列',
  selected_series: '已选系列',
  custom_icon: '自定义图标',
  add_navigation: '添加导航',
  page_remark: '页面备注',
  association_template: '关联模版',
  no_query_lbs_add_friends: '未查询到LBS加好友',
  select_lbs_friends: '选择LBS加好友',
  mage_and_text_customization: '图文自定义',
  confirm_delete_saved_module: '确认要删除该保存模块吗？',
  cancel_coolection_success: '取消收藏成功',
  cancel_coolection_fail: '取消收藏失败',
  modules: '个模块',
  module_saving_instructions:
    '点击模块右侧的★将模块保存，已保存的模块可一键拖入到其他页面中快捷装修。',
  not_found_get_discount: '未查询到领券活动',
  elect_voucher_collection_activity: '选择领券活动',
  module_name: '模块名称',
  custom_module_list: '自定义模块列表',
  filter_module: '筛选模块',
  searching_module: '正在搜索模块',
  module: '模块',
  end_days: '{{days}}天后结束',
  start_days: '{{days}}天后开始',
  only_has: '仅剩',
  robbed: '已抢',
  reservation_now: '立即预约',
  end: '结束',
  pieces_robbed_pieces_left: '已抢0件｜剩余0件',
  goods_have_been_robbed: '菜品已被抢光啦～',
  list_style_setting: '列表样式设置',
  three_in_a_row: '一行三个',
  slide: '滑动',
  button_color: '按钮颜色',
  default_shop_style: '默认全店风格',
  custom_color: '自定义颜色',
  font_size: '文字大小',
  small: '小号',
  middle: '中号',
  super_large: '加大号',
  font_thickness: '文字粗细',
  thin: '细体',
  thick: '加粗',
  variant_price: '菜品价格',
  product_source: '菜品来源',
  add_product_series: '添加菜品系列',
  add_up_to: '最多添加16个',
  display_mode: '展示模式',
  select_benefit_card: '选择权益卡',
  search_benefit_card_name: '搜索权益卡名称',
  benefit_card_name: '权益卡名称',
  right_name: '权益名称',
  select_product: '请选择菜品',
  duplicate: '副本',
  confirm_copy: '确定复制?',
  display_method: '展示方式',
  tile: '平铺',
  group_display_limit: '最多可添加10个分组，可拖动排序',
  group_title: '分组标题',
  group_subtitles: '分组子标题',
  gift_name: '奖品名称',
  select_collapse_icon: '选择折叠图标',
  bottom_navigation: '底部导航',
  bottom_navigation_copy:
    '店铺的各个页面可以通过导航串联起来。通过精心设置的导航，方便买家在栏目间快速切换，引导买家前往你期望的页面',
  configure_navigation_templates: '配置导航模板',
  template: '模版',
  basic_setting: '基本设置',
  unselected_status: '未选中状态',
  selected_status: '选中状态',
  search_setting: '搜索设置',
  default_keyword: '默认关键词',
  top_search_terms: '热门搜索词',
  keyword_limit: '最多可设置10个手动匹配关键词',
  hot_word: '热词',
  hot_word_icon: '热词图标',
  hot_word_style_highlighting: '热词样式 高亮',
  fee_freight: '免运费',
  effective_same_day: '当天开始生效',
  coupon_days_after: '领券{{UseByDayAfterGet}}天后可用',
  forever_effective: '永久有效',
  effective_day: '有效天数{{day}}天',
  receive_coupon_center_img_size: '建议尺寸375*278',
  show_share: '分享',
  share_title: '分享标题',
  coupon_color: '券面颜色',
  drag_sort: '最多10张，可拖动排序',
  please_add_voucher_collection_activity: '请添加券领取活动',
  lateral_sliding: '横向滑动',
  choose_color: '选择颜色',
  nape: '项',
  selectd: '已选择',
  confirm_delete_page: '确定要删除{{deleteKeys}}个页面吗',
  operate_can_not_undone: '此操作无法撤销。',
  logo_recommended_size: '建议尺寸：42*42px',
  several_modules: '个模块吗',
  add_rotation_chart: '添加轮播图',
  no_data_please_add: '暂无数据，请添加',
  switching_time: '切换时间',
  fillet_radius_disc: '圆片圆角半径',
  allocation_asset_type: '最多可配置2种资产',
  please_configure_three_asset_informatio: '请配置三种资产信息',
  growth_value: '成长值',
  headline: '大标题',
  subheading: '小标题',
  module_subtitle: '模块小标题',
  view_more_settings: '查看更多设置',
  view_more_modes: '查看更多模式',
  view_more_text: '查看更多文字',
  title_picture: '标题图片',
  upper_fillet: '上部圆角',
  lower_fillet: '下部圆角',
  fill_module_title: '填写模块标题',
  module_content: '模块内容',
  fill_module_content: '填写模块内容',
  content_description: '内容说明',
  fill_content_description: '填写内容说明',
  heading_style_setting: '大标题样式设置',
  thickness: '粗细',
  routine: '常规',
  subtitle_style_settings: '小标题样式设置',
  view_more_style_settings: '查看更多样式设置',
  background: '背景',
  background_image: '背景图',
  title_style_settings: '标题样式设置',
  title_icon: '标题图标',
  title_icon_recommended_size: '建议尺寸14*14',
  content_style_settings: '内容样式设置',
  content_description_style_settings: '内容说明样式设置',
  one_line: '一行一个',
  carousel: '轮播图片',
  select_template: '选择模版',
  advertising_quantity_limit: '最多添加 10 个广告，鼠标拖拽调整广告顺序，建议宽度750像素',
  support_long_press: '支持长按识别二维码添加微信/企业微信（仅支持jpg，png两种格式）',
  content_style: '内容样式',
  rotation_interval: '轮播间隔',
  picture_spacing: '图片间距',
  picture_size: '图片大小',
  s: '小',
  m: '中',
  l: '大',
  margin_left: '左边距',
  scroll_type: '滚动方式',
  turn_page_scroll: '翻页滚动',
  horizontal_scroll: '横向滚动',
  notice_quantity: '最多支持5条公告，可拖动排序',
  notice_horizontal_text: '请填写公告内容，如果字数过长，将在手机上横向滚动展示',
  draw_hot_zone: '绘制热区',
  navigation_content: '导航内容',
  navigation_style: '导航样式',
  fixed: '固定',
  display_quantity_per_line: '每行展示数量',
  picture_size_scheme: '图片大小方案',
  fixed_size: '固定大小',
  custom_size: '自定义大小',
  navigation_style_setting: '导航样式设置',
  title_position: '标题位置',
  picture_bottom: '图片下方',
  picture_inner: '图片内部',
  title_size: '标题大小',
  title_weight: '标题粗细',
  title_color: '标题颜色',
  display_number: '显示个数',
  video_source: '视频来源',
  select_video: '选择视频',
  paste_video_address: '粘贴视频地址',
  video_size_limit: '视频大小不超过50MB，建议上传16:9尺寸视频，仅支持mp4格式',
  only_supports_mp4: '仅支持.mp4格式的视频源地址',
  enter_video_address: '请输入视频地址',
  original_video_cover: '原视频封面',
  custom_cover: '自定义封面',
  video_advice_desc: '建议图宽高比例与视频宽高比一致',
  auto_play: '自动播放',
  open: '开启',
  afternoon: '下午',
  morning: '上午',
  last_edit_time: '上次编辑时间',
  application_page: '应用页面',
  remind: '提醒',
  is_restore_default_icon: '是否要恢复默认图标?',
  shop_home: '店铺主页',
  suspension_mode_setting: '悬浮模式设置',
  levitation_mode: '悬浮模式',
  support_drag: '支持拖动',
  main_window_setting: '主窗口设置',
  main_window_description:
    '当主窗口中包含2个及以上子窗口时，手机端页面才展示主窗口，点击可展开主窗口，再次点击将收起主窗口',
  not_expanded: '未展开',
  expanded: '已展开',
  main_window_picture_size: '建议尺寸：50*50像素的圆形png图片',
  sub_window_setting: '子窗口设置',
  main_window_info: '点击子窗口会跳到对应的页面，子窗口可以放在主窗口中，也可以作为独立入口展示',
  restore_default_icon: '恢复默认图标',
  floating_windows: '悬浮窗',
  float_window_description:
    '悬浮窗便于你在各个页面放置统一的快键入口，建议配置用户经常访问的页面入口',
  enable_float_window: '启用悬浮窗',
  add_label_store_page: '添加标签到店铺页面',
  keyword_sorting_store_page: '使用描述性关键字来帮助整理店铺页面',
  existing_label: '现有标签',
  type_enter_or_comma_to_add_options: '键入回车键或逗号键添加选项',
  used_the_x_option: `您已经使用了选项"{{tagValue}}"`,
  minimalist_style: '简约样式',
  minimalist_style_desc: '风格简约，适用于菜品数量和种类少的场景，目前暂仅支持1000个菜品。',
  rich_style: '丰富样式',
  rich_style_desc: '适用菜品种类丰富且数量多的商户，方便用户快速加购多件菜品',
  select_classification_style: '选择分类样式',
  hint: '提示语',
  required_item: '必填项',
  read_copyright_logo: '查看版权LOGO',
  decorate_navigation_copyright_logo: '店铺装修版权LOGO',
  please_upload_custom_logo: '请上传自定义LOGO',
  edit_copyright_logo: '编辑版权LOGO',
  two_left_two_right: '二左二右',
  one_left_two_right: '一左二右',
  one_top_two_bottom: '一上二下',
  one_left_three_right: '一左三右',
  rubik_cube_size: '魔方大小',
  rubik_cube_layout: '魔方布局',
  add_picture_suggestions: '选定布局区域，在下方添加图片，建议添加比例一致的图片',
  pixel: '像素',
  share_picture: '分享图片',
  decorate_table_order_title: '乐檬餐饮茶饮店（南京旗舰店）',
  add_secondary_navigation: '添加二级导航',
  navigation1: '导航1',
  navigation2: '导航2',
  navigation3: '导航3',
  navigation4: '导航4',
  merchant_navigation: '店铺导航',
  combo: '套餐',
  default_share_picture: '默认分享图',
  share_picture_size: '建议尺寸：520 * 416',
  home_page_share: '首页分享',
  joint_order_page_share: '拼单页分享',
  mini_program_homepage: '小程序首页',
  applet_spell: '小程序拼单',
  recent_searches: '最近搜索',
  special_price_of_summer_high_top_sandals: '夏款高帮凉鞋特价',
  summer_style_gaobang: '夏款高帮',
  top_search: '热门搜索',
  all_items: '所有菜品',
  part_product: '部分菜品',
  specify_goods_categories: '指定菜品和类别',
  number_applied_products: '关联菜品数',
  recently_applied_in: '最近应用在',
  total_number_applications: '共应用次数',
  add_custom_module: '新增自定义模块',
  simple_series: '菜品系列',
  mp_table_order_recommend_background_dimension: '建议尺寸 750 * 540 像素',
  mp_table_order_recommend_background_format: '支持JPG、PNG、GIF图片文件',
  mp_table_order_recommend_background_size: '文件大小不超过1MB',
  title_copy: '标题文案',
  exposure_all_count_tip:
    '活动时间内广告图片曝光的总人数，同一用户可以查看一张图片多次，去重。游客不去重。',
  exposure_total_time_tip:
    '活动时间内查看广告图片展示总次数，同一用户可以查看一张图片多次，不去重。',
  click_all_count_tip: '活动时间内用户点击广告的总人数，去重。游客不去重。',
  click_total_time_tip: '活动时间内用户点击广告图片的次数，不去重。',
  click: '点击',
  exposure: '曝光',
  all_users: '全部用户',
  new_user: '新用户',
  new_user_desc:
    '新用户就是绑定手机号的客户，但是没有有效订单的（没有购买过菜品、购买菜品全额退款，购买菜品未付款自动取消）；',
  by_member_level: '按客户等级',
  by_member_group: '按客户标签',
  first_purchase_goods_user: '首次购买菜品用户',
  first_purchase_goods_user_desc: '首次购买用户指的是绑定过手机号的客户且购买过菜品的',
  no_regist_user: '未注册用户',
  elm_store_products: '淘宝闪购·餐饮门店菜品',
  one_key_match: '一键匹配',
  match_success: '匹配成功',
  fetch_success: '抓取成功',
  elm_store_products_fetch: '淘宝闪购·餐饮门店菜品抓取',
  cancel_link_product: '取消关联菜品',
  cancel_link_success: '取消关联成功',
  cancel_link: '取消关联',
  confirm_cancel_link_is: '确认要取消关联吗？',
  stop_sell_products: '下架菜品',
  stop_sell_products_tip: '暂不支持下架菜品，只能将库存修改为0停止售卖。或至美团后台操作。',
  dywm_product: '抖音外卖菜品',
  sale_status: '售卖状态',
  on_sale: '售卖中',
  removed_from_shelves: '已下架',
  unknown: '未知',
  inventory_correlation: '库存关联',
  related: '已关联',
  no_relation: '未关联',
  associate_now: '立即关联',
  unbound: '未绑定',
  inventory_setting: '库存设置',
  online: '上架',
  offline: '下架',
  location_product: '门店菜品',
  grab: '抓取',
  batch_setting_inventory: '批量设置库存',
  max_number_error_message: '请输入小于9999的数字',
  greater_than_or_equal: '请输入大于等于0的数字',
  sell_out: '售罄',
  fill_up: '置满',
  less_than_or_equal_max: '请输入小于等于9999的数字',
  product_select: '菜品选择',
  n_product_selected: '已选择N个菜品',
  inventory_adjustment_type: '库存调整类型',
  enter_current_inventory: '录入当前库存',
  inventory_adjustment_tip: '当菜品库存调整类型为置满时，库存数默认为9999；售罄时，菜品库存为0',
  manually_enter_current_inventory: '手动录入当前库存',
  input_range: '录入范围为0-9999整数',
  operate_async: '操作同步',
  only_modify_current_store_product: '仅修改当前门店菜品',
  async_to_other_shop: '同步至其他全部门店',
  async_warn: '同步操作必须是同名菜品，同步全部门店尽量选择不超过5个菜品',
  batch_modify_package_fee_money: '批量修改包装费',
  batch_modify_inventory: '批量修改库存',
  sale_seletion: '销售选择',
  product_online: '菜品上架',
  product_offline: '菜品下架',
  product_offline_tips: '暂不支持下架菜品，只能将库存修改为0停止售卖',
  batch_setting_online_offline: '批量设置上下架',
  please_select_associated_product: '请选择关联菜品',
  associated_shop_product: '关联门店菜品',
  mt_product: '美团菜品',
  elm_product: '淘宝闪购·餐饮菜品',
  douyin_product: '抖音菜品',
  association_shop: '关联门店',
  browse: '浏览',
  dy_bind_product_warn: '抖音外卖不支持多规格菜品，请不要绑定多规格菜品',
  asnyc_product_tips:
    '该操作是将已读取到本地的第三方菜品，按菜品名称批量自动匹配，绑定菜品库的菜品，已绑定的菜品将自动忽略。',
  asnyc_product_tips1:
    '该操作是将已读取到本地的第三方菜品，按菜品条码批量自动匹配，绑定菜品库的菜品，已绑定的菜品将自动忽略。',
  asnyc_product_warn_two: '1、若是多规格菜品，规格名称必须一样',
  asnyc_product_warn_three: '2、平台菜品库不要存在重名菜品，若存在，匹配时在重名菜品中随机匹配',
  asnyc_product_warn_four: '此操作需要耗费较多时间，请耐心等待…',
  pour: '注',
  automatically_match_by_product_name: '按菜品名称自动匹配',
  bind_ele_shop: '绑定淘宝闪购·餐饮门店',
  elm_shop: '淘宝闪购·餐饮门店',
  please_enter_package_fee_money: '请输入包装费',
  package_fee_money_one_before: '1、单个菜品规格包装费超过',
  package_fee_money_one_after: '元，将定义为高额包装费',
  package_fee_money_two_before: '2、单个菜品规格高额包装费最高不能超过',
  package_fee_money_three_before: '3、该门店已经设置',
  package_fee_money_three_after: '个高额包装费的菜品规格 , 最多可以设置',
  sync_setting: '同步设置',
  automatically_synchronize_after_product_binding: '菜品绑定后自动同步',
  read_mt_setting: '查看美团外卖设置',
  mt_setting: '美团外卖设置',
  edit_mt_setting: '编辑美团外卖设置',
  read_mt_shop_product: '查看美团外卖门店菜品',
  mt_shop_product: '美团外卖门店菜品',
  mt_shop_product_one_click_matching: '美团外卖门店菜品一键匹配',
  mt_store_product: '美团门店菜品',
  product_types: '菜品类型',
  read_send_discount: '查看精准营销',
  del_send_discount: '删除精准营销',
  end_send_discount: '结束精准营销',
  terminate_confirm_is: '确认要终止 {{title}} 吗?',
  terminating_send_discount: '正在终止 精准营销',
  after_terminate_can_not_recovery: '确定终止活动，终止后无法恢复',
  kilogram1: '千克',
  number_of_people_covered: '覆盖人数',
  number_of_people_covered_desc: '统计周期内，符合参与活动条件的总人数，跨天去重',
  ticket_send_success_people_count: '发券成功人数',
  ticket_send_success_people_count_desc: '统计周期内，发券成功的人数，跨天去重',
  ticket_send_failed_people_count: '发券失败人数',
  ticket_send_failed_people_count_desc: '统计周期内，发券失败的人数，跨天去重',
  ticket_send_success_count: '发券成功数量',
  ticket_send_success_count_desc: '统计周期内，优惠券发放成功总数量',
  ticket_send_failed_count: '发券失败数量',
  ticket_send_failed_count_desc: '统计周期内，优惠券发放失败总数量',
  payment_conversion_rate: '支付转化率',
  payment_conversion_rate_desc: '统计周期内，下单人数占成功发券人数的比值',
  create_order_count: '下单人数',
  create_order_count_desc: '统计周期内，已发券客户使用发放的优惠券提交订单的人数，跨天去重',
  pay_order_count: '支付订单数',
  pay_order_count_desc: '统计周期内，已发券客户使用发放的优惠券成功下单付款的订单数',
  ticket_write_off_count: '优惠券核销数量',
  ticket_write_off_count_desc: '统计周期内，客户成功使用此活动发放的优惠券的总数',
  ticket_write_off_rate: '优惠券核销率',
  ticket_write_off_rate_desc: '统计周期内，优惠券成功核销总数量/发券成功总数量',
  ticket_write_off_money: '优惠券核销金额',
  ticket_write_off_money_desc: '统计周期内，发放的优惠券在成功订单中实际优惠的总金额',
  pulling_amount_desc:
    '统计周期内，除去活动发放的优惠券优惠后的成功订单总实付金额，举例：订单100元，优惠券抵扣30元，剩余70元实付金额即为拉动金额',
  club_card_share_group: '会员卡共享分组',
  create_share_group: '创建共享分组',
  edit_share_group: '编辑共享分组',
  share_group_name: '共享分组名称',
  choose_share_group_name: '筛选共享分组名称',
  location_in_group: '分组内门店',
  share_group: '共享分组',
  group_location_num: '门店数',
  loadding_club_card_share_group: '正在加载会员卡共享分组',
  ungrouped_location: '未分组门店',
  cancel_default: '取消默认',
  default_or_not: '是否默认',
  set_as_default: '设为默认',
  title_required: '{{title}}必填',
  read_ebls_setting: '查看淘宝闪购·零售设置',
  ebls_setting: '淘宝闪购·零售设置',
  edit_ebls_setting: '编辑淘宝闪购·零售设置',
  read_elm_setting: '查看淘宝闪购·餐饮设置',
  elm_setting: '淘宝闪购·餐饮设置',
  edit_elm_setting: '编辑淘宝闪购·餐饮设置',
  adjust_reject: '审核驳回',
  adjust_reject_reason: '驳回原因',
  please_fill_in_the_reason_for_rejection: '请填写驳回原因',
  reject_on2: '驳回',
  sms_group_sending: '短信群发',
  sms_group_sending_desc: '群发短信，提高活动营销推广',
  input_error_reject_modal: '请输入驳回原因',
  check: '查看',
  text_message_name: '群发任务名称',
  sent_sent_number: '待发送/已发送人数',
  preview_fee_number: '预计计费条数',
  pass_through: '通过',
  send_immediately_after_successful_review: '审核成功后立即发送',
  send_according_to_the_set_time_after_successful_review: '审核成功后按照设置时间发送',
  varient_label_tips: '添加小程序短链后，会员可通过短信跳转到小程序',
  sms_content_one: '短信支持退订（结尾将自动拼接“回T退订”，占模板内容4个字数）',
  sms_content_two: '短信总字数=【签名】+【短信内容】+【回T退订（4个字符）】；',
  sms_content_three: '短信长度不超过70个字，按照1条短信计费；',
  sms_content_four: '超过70个字为长短信，按照67字/条拆分成多条计费。',
  sms_content_five:
    '计费说明：当前4字，预计发送条数为1条（实际发送时，签名、变量长度、回 T退订四个字等会影响总字数）。',
  last_verify_time: '最后修改时间',
  reject_on3: '已驳回',
  wait_sent: '待发送',
  search_for_sms_name: '搜索群发任务名称',
  approved_tips_content: '审核通过后短信会根据发送条件发送到客户手机号中，同时产生短信计费。',
  insufficient_SMS_balance: '短信余额不足',
  insufficient_SMS_balance_tips:
    ' 短信余额不足您目前剩余短信条数不足以发送给选择用户，如果继续发送会导致部分用户接收不到短信，建议充值后再发送。',
  continue_sending: '继续发送',
  send_success: '发送成功',
  sent: '发送',
  confirm_cancellation_module: '确认要作废 {{title}} 吗',
  after_cancellation_can_not_recovery: '确定作废活动，作废后无法恢复',
  loading_order_distribution_anomaly: '正在加载 配送异常......',
  not_found_order_distribution_anomaly: '未查询到配送异常',
  sms_group_sending_import_template_xlsx: '短信群发导入模板.xlsx',
  cancellation_success: '作废成功',
  create_sms_group_sending: '创建短信群发',
  customer_level: '客户等级',
  customer_tag: '客户标签',
  table_import: '表格导入',
  search_customer_level: '搜索 客户等级',
  search_customer_tag: '搜索 客户标签',
  select_tag: '请选择标签',
  download_import_moudle: '下载导入模板',
  copy_title_duplicate: '-副本',
  important_value_customers: '重要价值客户',
  important_value_customers_desc: '最近有消费行为，消费频次高，金额也大',
  import_call_customer: '重要唤回客户',
  import_call_customer_desc: '最近没有消费行为，消费频次高，消费金额也大',
  import_deeply_cultivated_customers: '重要深耕客户',
  import_deeply_cultivated_customers_desc: '最近有消费行为，消费金额也高，但消费频次不高',
  import_retention_customers: '重要挽留客户',
  import_retention_customers_desc: '很久没有购买行为，消费频次也不高，但消费金额比较大',
  potential_customers: '潜力客户',
  potential_customers_desc: '最近有消费行为，消费频次高，但消费金额比较小',
  new_customer: '新客户',
  new_customer_desc: '最近有消费行为，但消费频次不高，消费金额也较小',
  generally_maintain_customers: '一般维持客户',
  generally_maintain_customers_desc: '最近有消费行为，消费频次也比较高，但金额比较小',
  lost_customer: '流失客户',
  lost_customer_desc: '很久没有消费，平时消费金额较小，消费频次也比较低',
  kit: '套餐',
  read_kit: '查看套餐',
  create_kit: '创建套餐',
  loading_kit: '正在加载 套餐......',
  edit_package: '编辑套餐',
  delete_kit: '删除套餐',
  package_details_cannot_empty: '套餐明细不可为空',
  male: '男',
  female: '女',
  picture_required: '图片必选',
  item_meta_field_desc: '可设置元字段值，并支持在价签打印中应用',
  go_setting: '前往设置',
  random_fullReduce_desc: '小程序支付享受随机立减金额',
  no_query_random_fullReduce: '未查询到随机立减',
  querying_random_fullReduce: '正在请求 随机立减',
  deleting_random_fullReduce: '正在删除 随机立减',
  ending_random_fullReduce: '正在结束 随机立减',
  end_random_fullReduce: '结束随机立减',
  random_fullReduce_data: '随机立减数据',
  create_random_fullReduce: '创建随机立减',
  input_discount_reduce_money: '请输入优惠立减金额',
  first_grade_doorsill_limit: '第一档活动预算',
  part_in_rank: '参与门槛',
  order_fact_full_money: '订单实付金额满',
  activity_rate: '活动概率',
  enter_rate: '请输入概率',
  add_activity_level: '新增活动层级',
  at_max_add_ten_levels: '最多可添加10级',
  first_grade_tip_01:
    '1.发放数量发放完成后将停止发放，若匹配的立减金额大于用户实付金额，按实付金额算',
  first_grade_tip_02:
    '2.活动概率总和为100%，如果某个层级发放数量为0，其他层级的活动概率会相应增大。',
  second_grade_tip_01: '1.用于设置活动还未结束但没有优惠金额的兜底方案',
  second_grade_tip_02:
    '2.基础活动预算发放完毕后，每笔符合条件的订单按固定值立减，建议立减金额可以设置小些',
  second_grade_doorsill_limit: '第二档活动预算',
  end_success: '结束成功',
  sure_finish_theme: '确认要结束 {{title}} 吗',
  sure_finish_theme_recover: '确定结束主题，结束后无法恢复',
  not_participate: '不参加',
  participate_person: '已参与人数',
  participate_order_number: '已参与订单数',
  refunded_order_number: '已退款订单数',
  pay_total_money: '实付总金额',
  refunded_all_total: '退款总金额',
  enter_merchant_no: '请输入商户号',
  create_sub_merchant_scret: '生成子商户密钥',
  read_to_pick_form_ontent: '通过 POS 或后台手动发送给客户。通知客户其订单可取货。',
  all_channels: '全部渠道',
  change_date_time: '变更时间',
  reduce_money_total: '立减总金额',
  pay_in_fact_money: '实付金额',
  reduce_money: '立减金额',
  refunded_at: '退款时间',
  refund_money: '退款金额',
  enter_phone_order_no: '请输入手机号、订单号',
  input_greater_than_zero_two_demical: '请输入大于0的两位小数',
  greater_than_two_decimal: '请输入大于0的2位小数',
  rate_total_lt_100: '概率总和不得大于100%',
  activity_rule: '活动规则',
  vertical_reduction: '立减',
  please_input_over_0_integer: '请输入大于0的整数',
  delete_reaches: '删除层级',
  open_using_mfa: '开启双因子校验',
  close_using_mfa: '关闭双因子校验',
  combo_good_cost: '套餐菜品成本',
  combo_detail_cost: '套餐明细成本',
  combo_cost_pricing_rules_tips:
    '设置套餐菜品成本，销售计算利润时使用套餐菜品档案中填写的成本价作为销售成本',
  combo_cost_pricing_rules_tips1:
    '设置套餐明细成本，销售计算利润时使用套餐明细中合计的单品成本作为销售成本，如果套餐明细成本都为0，则成本读取套餐菜品成本',
  no_selected_coupon: '您还没有选择优惠券~',
  coupon_available: '可用',
  my_gift_card: '我的礼品卡',
  buying_gift_card: '购买礼品卡',
  online_service: '在线客服',
  login_background_image: '登录背景图',
  zhejiang_lemeng_information_technology_co_ltd: '浙江乐檬信息技术有限公司',
  zhejiang_icp_no: '浙ICP备20024575号-9',
  your_shop_created_successfully: '您的店铺已创建成功！',
  creating_store_please_wait: '我们正在创建您的店铺，请稍等片刻',
  access_background_error_message: '您没有该店铺后台操作权限，请联系管理员',
  there_are_no_stores_in_this_area: '该区域暂无门店',
  enter_shop: '进入门店',
  access_area: '进入区域',
  enter_store: '进入店铺',
  login_account_has_changed_please_reselect_merchant: '登录账号发生变化，请重新选择商户',
  request_fail: '请求失败',
  login_title: '登录乐檬餐饮商户中心',
  get_code_erroe_message: '请输入正确的手机号码或邮箱',
  verification_code: '验证码',
  please_enter_the_verification_code: '请输入验证码',
  mobile_number_or_email: '手机号或邮箱',
  change_username: '请输入手机号码或邮箱',
  change_username_error_message: '请输入正确的手机号码或邮箱',
  please_enter_the_account_number: '请输入账号',
  login_success: '登录成功',
  password_login: '密码登录',
  forgot_password: '忘记密码',
  login: '登录',
  validate_code_error: '验证码错误',
  verify_mobile_phone_number: '验证手机号码',
  verification_code_prompt:
    '请输入发送至{{phone}}的6位验证码，有效期3分钟。如未收到，请尝试重新获取验证码或语音验证码。',
  send_voice_verification_code: '发送语音验证码',
  no_account: '还没有账号',
  existing_account: '已有账号',
  register_now: '立即注册',
  login_now: '立即登录',
  new_password: '新密码',
  please_enter_new_password: '请输入新密码',
  account_error_prompt: '手机号码/邮箱号格式有误',
  please_confirm_the_password_again: '请再次确认密码',
  confirm_password: '确认密码',
  please_enter_new_password_again: '请再次输入新密码',
  comfirm_password_empty: '请输入确认密码',
  name_cannot_be_empty: '姓名不能为空',
  wrong_mobile_number: '手机号码格式有误',
  please_input_password: '请输入密码',
  register_success: '注册成功',
  register_title: '注册乐檬餐饮商户中心',
  please_enter_your_name: '请输入姓名',
  password: '密码',
  please_input_password_again: '请再次输入密码',
  register: '注册',
  password_error_message: '密码不能少于8位',
  password_modified_successfully: '密码修改成功',
  sign_in_again: '重新登录',
  no_password_is_set_current_account: '当前账号未设置密码',
  verify_code_login: '验证码登录',
  scan_code_to_log_in: '请使用乐檬餐饮管家App扫码登录',
  qr_code_has_expired: '二维码已过期，点击',
  other_login_methods: '其他登录方式',
  chinese: '中文',
  interested_languages_and_regions: '感兴趣的语言和地区',
  select_interested_languages_and_regions: '阅览选定语言和地区的新闻',
  update: '更新',
  please_complete_security_verification: '请完成安全验证',
  repair: '修复',
  some_functions_of_the_shop_are_abnormal: '当前店铺部分功能异常，请修复',
  shop_card_add: '创建店铺',
  shop_card_add_content_text_one: '小程序+公众号一体化微信商城',
  shop_card_add_content_text_two: '赋能线下实体门店，重构消费连接',
  to_set: '去设置',
  waitting_payment_or_auto_delete_after_2_hours: '2小时后未支付将自动删除，请及时支付',
  is_payment_succeeded: '是否支付成功',
  payment_succeeded: '支付成功',
  payment_fail_go_payment_page: '支付尚未成功，即将跳转至支付页面',
  payment_failed_pay_again: '支付失败，重新支付',
  creation_time_custom: '创建时间: 自定义',
  creation_time_cannot_empty: '创建时间不能为空',
  valid_until: '有效期至',
  go_payment_page: '即将跳转至支付页面',
  going_payment_page: '即将跳转至支付页面...',
  will_go_payment_page: '即将前往支付页面...',
  this_merchant_stopped: '商户已停用',
  get_verification_code_success: '验证码获取成功',
  secondary_validation_tips: '为了您账号的安全，此次登录需要使用验证码二次验证',
  reset_password: '重置密码',
  password_rule: '密码需同时包含字母和数字，且至少8个字符',
  confirm_password_key: '两次密码输入不一致',
  reset_password_success: '密码重置成功',
  choose_channels: '选择渠道',
  refund_collect_point: '退款集点数',
  point_num: '集点数',
  source_channel: '来源渠道',
  channel: '渠道',
  order_in_fact_money: '订单实收金额',
  data: '数据',
  part_in_all_count: '参与总人数',
  order_count_all: '订单总笔数',
  order_in_fact_all_money: '订单实收总金额',
  total_collect_point: '集点总数',
  refund_total_collect_point: '退款集点总数',
  please_choose_appoint_customer: '请选择指定的客户',
  please_choose_appoint_customer_level: '请选择指定客户等级',
  please_choose_appoint_customer_tag: '请选择指定的客户标签',
  please_choose_repeat_every_week_detail: '请选择每周重复具体时间',
  select_specified_store: '请选择指定门店',
  please_select_specified_product: '请选择指定菜品',
  sale_channel_not_be_null: '销售渠道必填',
  save_number_can_not_lt: '发放数量不能少于初始值',
  please_input_integer_gt_0: '请输入大于0的整数',
  product_qty_cannot_change_limit: '分组菜品不可更改数量，分组内菜品必须不小于1件',
  product_qty_can_change_limit: '分组菜品可更改数量，分组内菜品必须不小于1件',
  kit_product_must_select: '套餐分组菜品必选',
  kit_product_qty_cannot_be_null: '套餐分组菜品数量必填',
  headquarters_price_dec: '预估毛利率=(售价-成本价)/售价*100%',
  unarchive_combo: '将套餐取消存档',
  archive_combo: '将套餐存档',
  associate_success: '关联成功',
  settlement_desk: '结算台',
  not_found_order: '未查询到订单',
  sub_title: '请添加以下信息，这将作为您的默认营业地址。您稍后可以随时更改此设置',
  shop_information: '店铺信息',
  edit_shop_information: '编辑店铺信息',
  shop_information_updated: '店铺已更新',
  contacts_sex: '联系人性别',
  contacts_name: '联系人姓名',
  please_input_contacts_name: '请输入联系人姓名',
  contacts_name_can_not_be_null: '联系人姓名必填',
  house_number: '门牌号',
  house_number_can_not_be_null: '门牌号必填',
  please_enter_house_number: '请输入门牌号',
  house_number_cannot_empty: '门牌号不可为空',
  shop_properties: '门店属性',
  select_version: '选择版本',
  basic_edition: '基础版',
  upgraded_version: '升级版',
  marketing_version: '营销版',
  chain_version: '连锁版',
  select_payment_method: '选择支付方式',
  payment_amount: '支付金额',
  submit: '提交',
  postal_code: '邮政编码',
  please_enter_postal_code: '请输入邮政编码',
  please_input_contact_phone: '请输入联系人手机号码',
  please_enter_contact_number: '请输入联系电话',
  please_select_payment_method: '请选择支付方式',
  activation_code_payment: '激活码支付',
  activation_code_cannot_empty: '激活码不可为空',
  activation_code: '激活码',
  please_enter_activation_code: '请输入激活码',
  online_payment: '在线支付',
  shop_created_successfully: '店铺创建成功',
  save_shop: '保存店铺',
  please_enter_shop_name: '请输入店铺名称',
  shop_location_not_selected: '店铺定位未选择',
  main_categories: '主营类目',
  please_select_main_categories: '请选择主营类目',
  country_region: '国家地区',
  province_city_district: '省/市/区',
  please_choose_province_city_district: '请选择省/市/区',
  address_search_error_prompt_one: '请先选择省市区再进行搜索',
  address_search_error_prompt_two: '请先填写详细地址再进行搜索',
  address_search_error_prompt_three: '未查询到当前地址坐标，请在地图上手动标记',
  detailed_address: '详细地址',
  please_enter_detailed_address: '请输入详细地址',
  search_map: '搜索地图',
  shop_type: '门店类型',
  distribution_centre_help_text:
    '开启配送中心开关以后，可向指定门店进行配货业务，需要在配送网络中设置可配送的门店',
  distribution_centre: '配送中心',
  physical_card_type: '实体卡类型',
  choose_card_type_tips: '请慎重选择，店铺创建后此参数不可修改',
  postal_code_requirements: '邮政编码必须为六位数字',
  postal_code_must_6_digit: '邮政编码须为六位',
  store_has_been_created_some_functions_are_abnormal_please_fix_it:
    '店铺已创建，部分功能异常，请修复!',
  min_short_link: '(小程序短链)',
  read_collect_stamp: '查看集点卡',
  del_collect_stamp: '删除集点卡',
  end_collect_stamp: '结束集点卡',
  create_collect_stamp: '创建集点卡',
  loading_collect_stamp: '正在加载 集点卡',
  deling_collect_stamp: '正在删除 集点卡',
  ending_collect_stamp: '正在结束 集点卡',
  view: '查看',
  point_method: '集点方式',
  purchase_appoint_goods_one: '购买指定菜品任意1件，集1点',
  single_order_amount_is_full: '单笔订单金额满',
  single_order_amount_is_each_full: '单笔订单金额每满',
  single_order_amount_unit: '元，集1点',
  calc_weekly: '按周计算',
  calc_month: '按月计算',
  sign_in_day_calc_rule: '签到天数计算规则',
  continute_sign_in_tips: '连续签到：在周期内连续签到天数达到设置的天数赠送对应的优惠。',
  continute_sign_in_tips_2: '累计签到：在周期内累计签到天数，达到设置的天数赠送对应的优惠。',
  consecutive_sign_in_rules_activity_cycles:
    ' 连续签到天数不得大于活动周期，否则连续签到奖励设置无效。',
  unlimited: '不限制',
  max_redeemable_per_person: '每人最多可兑换',
  maximum_10000: '最大值10000',
  enter_integer_between_second_thirty: '请输入2-30的整数',
  collect_point_icon: '集点卡 icon',
  customize: '自定义倍率',
  enter_choose_ticket: '请选择优惠券',
  search_ticket: '搜索优惠券',
  claim_rule: '领取规则',
  auto_claim: '自动领取',
  manual_claim: '手动领取',
  collect_point_rule: '集点规则',
  enter_person_redeemable_times: '请输入每人可兑换次数',
  all_share_mutual_relate: '全部活动互斥',
  all_share_mutual_exclustion_relate: '全部活动共享',
  all_share_mutual_relate_tip_01:
    '勾选全部活动互斥时，用户提交订单选择集点活动，则不享受其他营销活动优惠，其中营销活动包含（满减满折、限时折扣、满x件y折、N元任选、满赠、加价购、新客专享、随机立减、积分抵扣、减运费、权益卡减运费、权益卡减包装费）',
  all_share_mutual_relate_tip_02: '勾选全部活动共享时，用户提交订单既享受优惠又可以进行集点。',
  coupon_ticket_tips: '买家下单仅可与勾选的活动类型同时使用，如果不勾选，使用优惠券后不可集点',
  switch_shop: '切换店铺',
  sign_out: '退出',
  manage_lezhi_retail_account: '管理乐檬餐饮账号',
  profile_picture: '用户头像',
  client_downloads: '客户端下载',
  collect_full_exchange: '集满{{collectPoints }}点可兑换礼品',
  operating_revenue_tips:
    '系统菜品订单扣除营业优惠后的金额，不包括卡券订单。营业收入=营业流水-营业优惠',
  non_operating_income_tips:
    '除菜品订单外的其他收入，包括储值卡、优惠券包、权益卡、礼品卡、挂账还款、订金等，不包括三方卡券订单',
  number_of_valid_orders_tips: '去除已全部退款的订单数，有效订单数=订单数-退款订单数',
  refund_order_number_tips: '全部退款的订单数',
  increased_customer_amount: '新增客户数',
  passenger_flow_tips: '下过菜品订单的顾客数（会员去重）',
  customer_unit_price_01_tips: '营业收入/客流，同一个客户需要去重',
  weapp_access_qty: '微店铺访问数',
  business_flow_tips: '菜品订单优惠前金额',
  configure: '配置',
  common_function: '常用功能',
  rights_protection_on_order: '维权中',
  wechat_mp_pending_level_up: '版本待升级',
  sms_insufficient: '待续费',
  point: '点位',
  to_do_items: '待办事项',
  please_configure_to_do_items: '当前未配置待办事项，请配置',
  product_sales_ranking: '菜品销售TOP10',
  no_data_today: '今日暂无数据',
  data_profile_set: '数据概况设置',
  data_profile_set_successfully: '数据概况设置成功',
  adjust_as_follows: '按以下内容调整',
  to_do_items_set: '待办事项设置',
  shop_advent: '门店待续费，临期',
  pos_point_advent: 'POS点位待续费，临期',
  to_do_items_set_successfully: '待办事项设置成功',
  common_function_settings: '常用功能设置',
  current_function: '当前功能',
  decorate_navigation: '店铺装修',
  search_retail_functions_such_as: '搜索乐檬餐饮商户中心功能，如',
  history_search: '历史搜索',
  clear_history: '清除历史记录',
  show_all: '显示所有',
  item_result: '项结果',
  no_result_yet: '暂无结果',
  search_in_the_help_center: '在帮助中心搜索',
  clear_success: '清除成功',
  android_shop_name: '乐檬餐饮-非台位版',
  edition: '版',
  app_shop_name: '乐檬餐饮管家移动端APP',
  take_goods_screen: '乐檬餐饮TV屏',
  client_download: '客户端下载',
  click_download: '点击下载',
  jump_to_home: '跳转主页',
  help_center: '帮助中心',
  system_update: '系统更新',
  function_tab: '功能栏',
  task_center_desc: '数据导出仅保留30天，请及时下载',
  export_processing: '导出中',
  export_complete: '导出已完成',
  export_fail: '导出失败',
  import_processing: '导入中',
  import_succeed: '导入已完成',
  update_succeed: '更新已完成',
  batch_update_expected_out_at_processing: '修改发货日期进行中',
  batch_update_expected_out_at_success: '修改发货日期已完成',
  batch_update_expected_out_at_fail: '修改发货日期失败',
  printing: '打印中',
  print_succeed: '打印已完成',
  print_fail: '打印失败',
  distribute_fail: '分配失败',
  cancel_distribute_fail: '取消分配失败',
  import_detail: '导入详情',
  successfully_imported: '成功导入',
  import_failure: '导入失败',
  import_failure_reason: '导入失败原因',
  export_failure_reason: '导出失败原因',
  update_failure_reason: '更新失败原因',
  distribute_failure_reason: '分配失败原因',
  cancel_distribute_failure_reason: '取消分配失败原因',
  failure_reason: '失败原因',
  application_time: '申请时间',
  module_task_type_name: '文件类型',
  update_success: '更新成功',
  updata_fail: '更新失败',
  cancel_distribution_success: '取消分配成功',
  send_processing: '发送中',
  send_complete: '发送结束',
  settle_processing: '结算单生成中',
  settle_complete: '结算单已完成',
  settle_fail: '结算单失败',
  generate_complete: '生成完成',
  generate_fail: '生成失败',
  batch_audit_processing: '批量审核进行中',
  batch_audit_complete: '批量审核已完成',
  batch_audit_fail: '批量审核失败',
  sync_success: '同步成功',
  sync_fail: '同步失败',
  read_fail_reason: '查看失败原因',
  check_detail: '查看详情',
  check_batch_number: '查看批次单号',
  check_handle_result: '查看执行结果',
  task_percent: '任务进度',
  task_status: '任务状态',
  order_module: '订单管理',
  customer_module: '客户管理',
  marketing_module: '营销管理',
  ordering_module: '配送管理',
  inventory_module: '库存管理',
  procurement_module: '采购管理',
  processing_module: '生产管理',
  financial_module: '财务管理',
  successfully_obtained_the_verification_code: '获取验证码成功',
  select_an_initialization_module: '请选择初始化模块',
  store_initialization: '店铺初始化',
  enter_store_owner_mobile_phone_verification_code: '请输入店主手机验证码',
  obtain_store_owner_verification_code: '获取店主验证码',
  initializing_store_please_wait_a_moment: '我们正在初始化您的店铺，请稍等片刻',
  your_store_has_initialized_successfully: '您的店铺初始化成功',
  initialization: '初始化',
  failed_module: '失败模块',
  store_initialization_failed_please_try_again_later: '您的店铺初始化失败，请稍后再试',
  system_desc: '系统初始化会清除对应菜单模块的全部数据，且无法恢复，请谨慎操作！',
  this_page_asks_if_you_want_to_leave: `此页面询问您是否要离开 — 关闭浏览器可能引起系统初始化异常`,
  service_market: '服务市场',
  new: '新',
  download_fail: '导出内容为空',
  failed: '失败',
  generate_settlement_documents_reason: '生成结算单失败原因',
  batch_audit_fail_reason: '批量审核失败原因',
  page_management: '页面管理',
  product_decoration: '菜品装修',
  package_decoration: '套餐页面装修',
  content_manage: '内容管理',
  basic_settings: '基础设置',
  store_navigation_page: '店铺导航',
  member_stored_value: '会员储值',
  store_style: '全店风格',
  general_settings: '通用设置',
  copyright_logo: '版权LOGO',
  applet_page: '小程序页面',
  batch_cancel_associated_product: '批量取消关联菜品',
  batch_cancel_associated_success: '批量取消关联成功',
  batch_cancel_associated: '批量取消关联',
  confirm_batch_cancel_associated: '确认要批量取消关联吗？',
  loading_recommend_product: '正在加载 推荐菜品',
  deleting_recommend_product: '正在删除 推荐菜品',
  ending_recommend_product: '正在结束 推荐菜品',
  create_recommend_product: '创建推荐菜品',
  recommend_product_desc: '分类页设置商家推荐菜品',
  three_electronic_coupon: '三方电子券',
  mt_comment_coupon: '美团点评券',
  mt_comment_coupon_desc: '可接入美团/大众点评团购券',
  recommend_product_all_sale_amount: '推荐菜品总销量',
  activity_goods_all_sale_amount_tips: '该活动售卖的，活动菜品总数量',

  eq: '等于',
  eq_this_value: '刚好此数',
  eq_this_money: '刚好此金额',
  not_eq: '不等于',
  gt: '大于',
  gt_this_value: '大于此数',
  gt_this_money: '大于此金额',
  lt: '小于',
  lt_this_value: '小于此数',
  lt_this_money: '小于此金额',
  distribution_or_cancel_location: '分配门店/取消分配门店',
  pick_up_delivery_time: '自提/配送时间',
  cancel_distribute_modal_first_title:
    '以下菜品取消分配，将导致门店对应套餐菜品状态也转为取消分配。',
  cancel_distribute_modal_second_title: '继续：将取消分配所选菜品及冲突的对应套餐菜品',
  cancel_distribute_modal_third_title: '忽略冲突并继续：将只取消分配未冲突菜品',
  halt_sale: '停售',
  reduce_freight_data: '减运费数据',
  send_discount_data: '精准营销数据',
  freight_reduction_list: '减运费列表',
  querying_freight_reduction: '正在请求 减运费',
  deleting_freight_reduction: '正在删除 减运费',
  ending_freight_reduction: '正在结束 减运费',
  create_freight_reduction: '创建减运费',
  edit_recommend_product: '编辑推荐菜品',
  copy_recommend_product: '复制推荐菜品',
  show_recommend_product: '查看推荐菜品',
  goods_price_full: '菜品原价满',
  activity_rule_tips_first: '1.菜品原价：参与门槛以菜品原价为门槛条件。',
  activity_rule_tips_second: '2.实付金额：指菜品参与优惠活动后优惠金额作为门槛条件。',
  activity_rule_tips_third:
    '3.减配送费活动默认与其它营销活动共享，若同时有多个配送费减免优惠，则参与优惠力度最高的1个。',
  activity_desc: '活动说明',
  pay_money_full: '实付金额满',
  extra_clash_symbol: '家门店',
  marketing: '营销',
  merchant_promotion: '店铺促销',
  favourable_content: '优惠内容',
  favourable_amount: '优惠额',
  favourable_amount_cantnot_be_zero: '优惠额不能为0',
  enter_max_favourable_amount: '请输入最高优惠额',
  le_100: '不超过100',
  le_30_yuan: '不超过30元',
  check_any_choice: '查看N元任选',
  create_any_choice: '创建N元任选',
  edit_any_choice: '编辑N元任选',
  copy_any_choice: '复制N元任选',
  delete_any_choice: '删除N元任选',
  end_any_choice: '结束N元任选',
  querying_any_choice: '正在请求 N元任选',
  deleting_any_choice: '正在删除 N元任选',
  ending_any_choice: '正在结束 N元任选',
  pls_input_total_limit: '请输入总次数',
  pls_input_day_limit: '请输入每天参与次数',
  pls_input_fact_day_limit: '请输入订单实际付款金额',
  any_choice_step_rule: '阶梯设置(按满足最高层级优惠一次)',
  any_choice_cycle_rule: '循环设置（每满一次享受一次优惠）',
  any_choice_ticket_rule:
    '买家下单仅可与勾选的活动类型同时使用，如果不勾选，参加N元任选活动后的菜品不可以使用优惠券',
  any_choice_tag_rule: '示例：促销、参与活动、N元任选',
  any_choice_step_rule_1: '最多支持3级，下一级满足金额和件数需大于上一级',
  any_choice_step_rule_2:
    '若订单内菜品件数超出活动件数，则超出活动件数按照菜品金额高低，默认价高菜品参与活动，价低菜品原价支付',
  any_choice_step_rule_3: '若达到件数未达到活动金额条件，则按照原价计算，代表不参与活动',
  any_choice_step_rule_4: '若活动后的优惠金额大于买家购买的原价，则在结算页默认不使用该活动',
  choose_any: '任选',
  product_mount: '菜品件数',
  total_price: '总价',
  pls_select_limit_payments: '请选择需要限制的支付方式',
  location_price_can_not_gt_price: '门店售价不允许超出售价范围',
  location_price_can_not_lt_price: '门店售价不允许低于售价范围',
  deposit_receipt: '寄存单',
  booking_inquiry: '桌台预订',
  down_payment_and_earnest_money: '订金/押金',
  charge_management: '挂账管理',
  order_evaluation: '订单评价',
  comment_analysis: '评价分析',
  standard_commodity: '标准菜品',
  package_goods: '套餐菜品',
  product_sort: '菜品排序',
  corner_mark: '角标',
  box: '包装盒',
  store_standard_goods: '门店标准菜品',
  store_classification: '门店菜品类别',
  location_package_goods: '门店套餐菜品',
  store_property: '门店菜品属性',
  product_synchronization: '菜品同步',
  product_inventory: '菜品库存',
  inventory_synchronization: '库存同步',
  plan_inventory: '计划库存',
  customer_list: '客户列表',
  club_card_list: '会员卡列表',
  card_kind: '卡类型',
  user_portrait: '用户画像',
  rfm_analysis: 'RFM分析',
  data_definition: '数据定义',
  point_system: '积分体系',
  deposit_system: '储值体系',
  marketing_activities_center: '营销活动中心',
  crm_management: '营销活动管理',
  applet_manage: '小程序管理',
  wechat_popularize: '小程序推广',
  wechat_public_setting: '微信公众号',
  user_agreement: '用户协议',
  product_review: '菜品审核',
  remark_manage: '备注管理',
  auxiliary_screen_setting: '辅屏设置',
  exp_manage: '效期管理',
  takeaway_channels: '外卖渠道',
  we_com: '企业微信',
  branch_manage: '门店管理',
  kds_pick_up_screen: 'TV屏装修',
  printing_business: '打印业务',
  comment_setting: '评价设置',
  payment_method_settings: '支付方式',
  courier_template: '快递模板',
  aggregated_delivery: '聚合配送',
  print_sort: '打印顺序',
  system_log: '系统日志',
  print_settings: '打印设置',
  exp_goods: '效期菜品',
  merchant_payment: '商户支付',
  platform_applet_payment: '平台小程序支付',
  franchise_distribution: '加盟分账',
  data_dashboard: '数据概览',
  pay_trade: '交易汇总',
  pay_record: '支付记录',
  my_application: '我的应用',
  my_merchant: '我的商户',
  channel_config: '渠道配置',
  location_sub_merchant_config: '门店子商户配置',
  money_settings: '款项设置',
  financial_entity_change_record: '财务主体变更记录',
  flow_details: '流水明细',
  capital_flow: '资金流水',
  recrod_account_flow: '记账户流水',
  payment_record: '付款记录',
  withdrawal_record: '提现记录',
  distribution_audit: '分账稽查',
  flow_summary: '流水汇总',
  payment_record_summary: '付款记录汇总',
  distribute_bill_details: '分账明细',
  deposit_consumption_scheme: '储值消费分账方案',
  deposit_consumption_settlement: '储值消费分账结算单',
  gift_card_consumption_scheme: '礼品卡消费分账方案',
  gift_card_consumption_settlement: '礼品卡消费分账结算单',
  coupon_verification_scheme: '券核销分账方案',
  coupon_verification_settlement: '券核销分账结算单',
  headquaters_scheme: '总部分账方案',
  headquater_expense: '总部费用单',
  headquaters_settlement: '总部分账结算单',
  branch_scheme: '门店分账方案',
  branch_expense: '门店费用单',
  branch_settlement: '门店分账结算单',
  custom_scheme: '自定义分账方案',
  custom_settlement: '自定义分账结算单',
  goods_location_prop: '物品配送属性',
  ordering_control: '门店订货控制',
  system_settings: '系统设置',
  receive_order: '采购收货',
  production_plan: '生产计划单',
  production_process: '生产入库单',
  production_picking: '生产领料单',
  inventory_check: '库存盘点',
  inventory_adjustment: '库存调整',
  stock_adjust_reason: '库存调整原因',
  stock_cost_adjustment: '库存成本调整',
  transit_Goods: '物品在途',
  purchase_summary_details: '采购汇总明细',
  purchase_order_monitoring: '采购订单监控',
  material_analysis_report: '加工品原料耗用分析表',
  process_summary_report: '生产汇总表',
  entry_exit_summary: '库存进出汇总',
  entry_stock_summary: '入库汇总',
  exit_stock_summary: '出库汇总',
  statistics_of_change: '进销存变动统计',
  item_document: '物品档案',
  store_item_rule: '仓库物品规则',
  supply_chain_parameters: '供应链参数',
  app_product_setting: 'APP物品列表配置',
  business_report: '营业报表',
  sale_report: '销售报表',
  financial_report: '财务报表',
  member_report: '会员报表',
  operating_statement: '运营报表',
  business_verview: '营业概览',
  business_statistic: '营业统计',
  business_beyond_statistic: '营业外统计',
  business_details: '营业明细',
  product_overview: '菜品概览',
  product_sales_details: '菜品销售明细',
  product_location_sales_summary: '菜品门店销售汇总',
  product_marketing_report: '菜品营销统计',
  card_sale_detail: '卡券销售明细',
  customer_price_report: '客单分析',
  vip_data_report: '会员概览',
  customer_performance: '用户业绩',
  customer_deduction_report: '会员扣款记录',
  deposite_payment_method_detail: '储值支付方式明细',
  small_program_analysis: '小程序分析',
  expense_order: '费用订单',
  value_added_services: '增值服务',
  basic_information: '基础信息',
  approximately: '约',
  pos_point: 'POS点位',
  product_category_oms_et: '菜品类目（抖音外卖）',
  et_product_attribute_required: '抖音外卖菜品属性必选',
  tiktok_category_attributes: '抖音类目属性',
  set_tiktok_properties: '设置抖音外卖类目属性',
  category_property_required: '该类目属性必填',
  use_rules: '使用规则',
  package_diagram: '套餐图',
  merchandise_collocation: '菜品搭配',
  product_purchase_restriction_rule: '菜品限购规则',
  select_specified_date_type: '请选择指定日期类型',
  stock_up_before_delivery_period: '先囤后送有效期',
  after_purchase: '购买后',
  god_effective: '天有效',
  please_select_date: '请选择日期',
  please_enter_value: '请输入值',
  start_date: '开始日期',
  please_choose_start_date: '请选择开始日期',
  start_date_can_not_be_null: '开始日期必填',
  end_date: '结束日期',
  end_date_can_not_be_null: '结束日期必填',
  delivery_channel: '投放渠道',
  p_payment_method: '收款方式',
  small_program_ledger_class: '小程序分账类',
  p_subheading: '副标题',
  market_price: '市场价',
  type_commodity_industry: '菜品行业类型',
  applet_resource_id: '小程序资源id',
  recommendation: '推荐语',
  ranking_weight: '排序权重',
  please_choose: '请选择',
  small_program_bill_lading_page_jump: '小程序提单页跳转',
  please_select_delivery_method: '请选择配送方式',
  auto_renew: '是否开启自动延期',
  add_rule: '添加规则',
  add_dish_group: '添加菜品组',
  purchase_restriction_rule: '限购规则',
  add_purchase_restriction_rule: '添加限购规则',
  is_confirm_imme_true: '是否立即确认',
  superimposed_discounts_true: '可与店内其他优惠同享',
  description_rich_text: '其他说明信息',
  add_information: '添加信息',
  front_category_tag: '前台品类标签',
  refund_description: '退款规则描述',
  add_refund_description: '添加退款规则描述',
  dishes_image_list: '菜品图',
  environment_image_list: '环境图片',
  declaration_type: '说明类型',
  declaration_img: '说明图片',
  rule_heading: '规则标题',
  rule_content: '规则内容',
  subject_purchase_restriction: '限购主体',
  p_purchase_limit: '限购范围',
  add_dish: '添加菜品',
  purchase_limit_number: '限购数量',
  dish_group_name: '菜品组名',
  totality: '总数',
  choose_which: '选几',
  dishes: '菜品',
  add_dishes: '新增菜品',
  dish_name: '菜品名',
  please_enter_the_dish_name: '请输入菜品名',
  please_enter_price: '请输入价格',
  please_enter_totality: '请输入总数',
  docking_mode: '对接模式',
  add_tag: '添加标签',
  recommended_number_of_diners: '建议用餐人数',
  recommended_max_number_of_diners: '建议最多用餐人数',
  ic_card_import: 'IC卡导入',
  share_mutual_exclustion: '共享互斥',
  production_staff_summary_report: '生产人员生产汇总表',
  media_format_and_size_limit:
    '仅支持 gif、jpeg、png、bmp 4种格式，推荐像素 800 * 800，大小不超过 10M',
  cover_success: '覆盖成功',
  mark_up_purchase: '加价购',
  location_image_rule: '用于小程序展示使用，仅支持 gif、jpeg、png、bmp 4种格式，大小不超过 2M',
  get_recevice_center_share_title: '超多优惠券等你来领~',
  queued_commodity_unit: '排队叫号菜品单位',
  queued_commodity_unit_example: '例如：杯',
  landscape_screen: '横屏',
  portrait_screen: '竖屏',
  unit_of_queuing_calling_goods_cannot_empty: '排队叫号菜品单位不可为空',
  please_take_your_meal: '请取餐',
  please_go_to_the_food_pickup: '请前往取餐处取餐',
  screen_oritation: '显示方向',
  clockwise90: '顺时针90度',
  counterclockwise90: '逆时针90度',
  no_spin: '不旋转',
  mode_selection: '模式选择',
  production_mode: '制作模式',
  call_mode: '叫号模式',
  complex_mode: '综合模式',
  add_color: '添加颜色',
  number_of_voice_calls: '语音叫号次数',
  title_priority: '标题优先',
  priority_of_meal_number: '取餐号优先',
  station_number_priority: '台位号优先',
  display_order: '展示顺序',
  from_new_to_old: '从新到旧',
  from_old_to_new: '从旧到新',
  making: '制作中Making',
  authorization_des:
    '为保证所有功能的正常使用，授权时请把默认勾选的权限授权给乐檬餐饮商户中心。若还没有小程序，请在',
  wechat_public_platform: '微信公众平台',
  apply_for_new_widget: '申请新的小程序，申请成功后再到本页面重新进行绑定。',
  authorization_notice_des: '如果您在授权之前已添加【小程序订阅消息】，请在授权完成后进入',
  href_notice: '【通知】',
  authorization_notice_after_des: '页面重新勾选所有【小程序订阅消息】。',
  immediately_bind_to_wechat_applet_authorization: '立即绑定为微信小程序授权',
  wechat_applet_authorization_setting: '微信小程序授权设置',
  please_complete_authorization_new_window: '请在新窗口中完成微信小程序授权',
  authorization_failed_re_authorize: '授权失败，重新授权',
  edit_wechat_applet_synchronization_update: '编辑微信小程序同步更新',
  setting_update_success: '设置更新成功',
  are_you_sure_you_want_to_unlicense_the_applet: '确认要解除授权小程序？',
  operation_failed: '操作失败',
  read_wechat_applet_authorization_settings: '查看微信小程序授权设置',
  wechat_setting: '授权设置',
  bind_applet: '绑定小程序',
  deauthorization: '解除授权',
  instructions_for_unauthorization_popup:
    '解除授权只会解除已授权小程序与乐檬餐饮商户中心系统的授权关系，方便其他小程序对乐檬餐饮商户中心系统进行授权。 如需真正解绑小程序，需要到小程序后台进行解绑。',
  synchronize_updates: '同步更新',
  applet_code: '小程序码',
  introduce: '介绍',
  service_category: '服务类目',
  notice_attention_title:
    '为积极配合微信小程序运营规范，请根据您的经营项目，申请需要的服务类目，否则会导致小程序审核失败。',
  notice_attention_one: '生活服务>生活服务 >百货/超市/便利店（必选）',
  notice_attention_one_secondary: '订阅消息通知需要',
  notice_attention_two: '如果你的小程序涉及食品的在线交易及配送，请补充选择：',
  notice_attention_two_secondary: '商家自营>食品类目',
  notice_attention_three: '如果你的小程序涉及初级食用农产品的在线交易及配送，请补充选择：',
  notice_attention_three_secondary: '商家自营>初级食用农产品类目',
  notice_attention_four: '如果你的小程序涉及酒的在线交易及配送，请补充选择：',
  notice_attention_four_secondary: '商家自营>酒/盐类目',
  go: '去',
  application_service_category: '-设置-基本设置，申请服务类目',
  open_service_category_for_small_programs: '《小程序开放的服务类目》',
  application_guidance_guidelines: '《小程序备案操作指引》',
  applet_instruction: '小程序使用说明',
  applet_authorization: '小程序授权',
  waitting_submit: '待提交',
  in_preliminary_review: '初审中',
  initial_review_failed: '初审失败',
  wechat_is_under_review: '微信审核中',
  alipay_is_under_review: '支付宝审核中',
  wechat_audit_failed: '微信审核失败',
  alipay_audit_failed: '支付宝审核失败',
  wechat_audit_success: '微信审核成功',
  alipay_audit_success: '支付宝审核成功',
  submit_audit: '提交审核',
  resubmit_audit: '重新提交审核',
  upgraded: '已升级',
  to_be_applied_for_opening: '待申请开通',
  no_permission: '无权限',
  in_application: '申请中',
  application_fail: '申请失败',
  permission_opened: '已开通',
  view_wechat_applet_upgrade_record: '查看微信小程序升级记录',
  successfully: '成功',
  upgrade_succeeded: '升级成功',
  upgrade_to_latest_version: '升级至最新版本',
  submitted_version: '提审版本',
  precautions_for_submission_for_review:
    '提交审核时需要设置店铺信息，包括创建门店、创建菜品、添加门店菜品、创建小程序主页、设置小程序头像，设置好服务类目，授权开发管理权限等',
  view_upgrade_records: '查看升级记录',
  turn_off_automatic_upgrade: '关闭自动升级',
  turn_on_automatic_upgrade: '开启自动升级',
  cannot_add_duplicate_wechat_signals: '不可添加重复的微信号',
  automatic_upgrade_is_turned_off: '自动升级已关闭',
  automatic_upgrade_is_turned_on: '自动升级已开启',
  publishing_mode: '发布模式',
  publishing_mode_desc:
    '开关开启，小程序审核通过后自动发布；开关关闭，小程序保持当前在用的版本，不再自动发布最新版本',
  automatic_publishing: '自动发布',
  please_input_wechat: '请输入微信号',
  please_input_alipay: '请输入支付宝账号',
  preview_wechat: '预览者微信号',
  preview_alipay: '预览者支付宝账号',
  remaining_number_people_add: '剩余可添加人数：',
  be_careful_one: '一次只能输入一个微信号，点击回车确认后，可再输入下一个微信号',
  be_careful_two: '可删除预览者微信号',
  be_careful_three: '如果运营者同时也是该小程序的管理员，则无需绑定，管理员默认有体验权限。',
  audit_fail_cause: '审核失败原因',
  authorized_service: '已授权服务',
  empower: '授权',
  reaudit_tips_one: '请确保您已根据审核失败原因修改相关配置，否则将会导致审核失败；',
  reaudit_tips_two: '提交审核后不可撤回；',
  reaudit_tips_three: '如有疑问，可联系系统工作人员。',
  record_tips: '您的小程序未备案，为确保您的小程序后续顺利使用，建议您确认备案状态。 查看微信文档',
  applet_version: '小程序版本',
  current_version: '当前版本',
  system_latest_version: '系统最新版本',
  preview: '预览',
  audit_fail_message: '审核失败提示',
  display_upgrade_records: '显示近30条升级记录',
  version_number: '版本号',
  upgrade_time: '升级时间',
  confirm_start_activity: '确定要立即开始【{{name}}】吗？',
  confirm_end_activity: '确定要立即结束【{{name}}】吗？',
  confirm_delete_activity: '确定要删除【{{name}}】吗？',
  pay_by_meal_people_tip: '每位顾客收取{{fee}}元',
  pay_by_table_tip: '每个桌台收取{{fee}}元',
  pay_by_after_discount_tip: '按菜品优惠后价格收取{{rate}}%',
  pay_by_total_meal_price_tip: '按菜品价格合计收取{{rate}}%',
  pay_by_open_table_time_tip:
    '开台{{time1}}分钟收取{{fee1}}元，超过每{{time2}}分钟加收取{{fee2}}元',
  pay_by_consume_align_tip: '消费补齐金额{{fee}}元',
  start_now: '立即开始',
  end_now: '立即结束',
  n_stations: '{{n}}个台位',
  station_service_fee_not_found: '找不到台位服务费',
  create_service_fee: '创建服务费',
  confirm_service_fee_clash: '确认冲突桌台服务费',
  service_fee_clash_tip: '请确认每个桌台的服务费，同一时段每个桌台只能使用一种按就餐人数收取方案',
  check_stations_tip: '请勾选应用“{{name}}”方案的台位',
  selected_stations_tip: '（已选{{len1}}个）共{{len2}}个台位',
  pay_by_meal_people: '按就餐人数收取',
  pay_by_table: '按每张台位收取',
  pay_by_consume_amount: '按消费金额收取',
  pay_by_open_table_time: '按开台时间收取',
  pay_by_consume_align: '按消费补齐收取',
  each_yuan_person: '元/位',
  each_yuan_table: '元/桌',
  rate_by_after_discount: '菜品优惠后价格 * 设置比例',
  rate_by_total_meal_price: '菜品价格合计 * 设置比例',
  open_table: '开台',
  enter_number: '请输入数字',
  service_fee_1: '服务费',
  over_each: '超过每',
  extra_pay: '加收取',
  consume_align: '消费补齐金额',
  service_fee_name: '服务费名称',
  enter_service_fee_name: '请输入服务费名称',
  service_fee_method: '服务费方案',
  enter_service_fee_method: '请输入服务费方案',
  modify_service_fee: '修改服务费金额',
  not_in_service_products: '不计入服务费菜品',
  business_refund_money: '营业退款',
  product_state: '上下架状态',
  store_created_successfully: '门店创建成功',
  store_created_successfully_will_jump_to_the_payment_page: '门店创建成功，即将跳转至支付页面...',
  kit_items: '成套件物品',
  create_kit_with_name: '创建成套件物品{{name}}',
  business_param: '营业参数',
  making_meal: '备餐中',
  making_m: '制作中',
  repayment_receipts: '还款小票',
  order_del_aduit_confirm_is: '仅支持删除待审核的单据,确认需要删除所选单据?',
  new_arrival: '新品上市',
  hot_sale: '爆款热卖',
  recommended_by_shopkeeper: '店家推荐',
  seasonal_selection: '当季精选',
  recommended_by_store_manager: '店长推荐',
  recommended_copy: '热销爆款、甜蜜来袭',
  cure: '烘焙',
  dress: '服装',
  kit_sale_count: '套餐销售统计',
  kit_inner_product_title: '套餐内菜品名称',
  kit_dimension: '套餐维度',
  belong_kit: '所属套餐',
  closed_shop: '已闭店',
  open_shop: '营业中',
  one_click_expand: '一键展开关联菜品',
  change_product_sort_type: '更改菜品排序方式',
  click_edit_custom_page_odule: '点击编辑“自定义页面模块”',
  del_purchase_template_with_no: '删除采购模板[{{id}}]',
  oms_jd: '京东秒送',
  read_jd_shop_list: '查看京东秒送门店列表',
  jd_shop_setting: '京东秒送门店列表',
  bind_jd_shop: '绑定京东秒送门店',
  jd_shop: '京东秒送门店',
  jd_location_id: '京东秒送门店ID',
  jd_location_name: '京东秒送门店名称',
  jd_product: '京东秒送菜品',
  jd_store_products: '京东秒送门店菜品',
  business_infomation_2: '营业信息',
  wx_pa: 'H5',
  oms_mtsg: '美团闪购',
  read_mtsg_shop_list: '查看美团闪购门店列表',
  mtsg_shop_setting: '美团闪购门店列表',
  bind_mtsg_shop: '绑定美团闪购门店',
  mtsg_shop: '美团闪购门店',
  mtsg_location_id: '美团闪购门店ID',
  mtsg_location_name: '美团闪购门店名称',
  mtsg_product: '美团闪购菜品',
  mtsg_store_products: '美团闪购门店菜品',
  read_mtsg_setting: '查看美团闪购设置',
  mtsg_setting: '美团闪购设置',
  edit_mtsg_setting: '编辑美团闪购设置',
  mtsg_category_attributes: '美团闪购属性',
  set_mtsg_properties: '设置美团闪购类目属性',
  sell_mode_tips: '{{name}}为“是”时，销售模式不能为空',
  batch_sync_success: '同步库存成功',
  template_scope: '模板范围',
  product_export1: '菜品导出',
  order_archived_successfully1: '订单作废成功',
  order_unarchived_successfully1: '订单取消作废成功',
  pos_applet_product_list: 'POS菜品列表',
  abnormal_commodity: '异常菜品',
  archive_failed: '存档失败',
  archive_failed_reason: '存档失败原因',
  auto_store_receive_by_supplier_in_hours: '供应商助手订单发货完成自动生成收货单',
  auto_store_receive_by_supplier_in_hours_tip: '提示：0或空表示不会自动审核',
  matching_mode: '匹配方式',
  summary_by_location_store_type: '按门店-仓库物品汇总',
  deduction_type: '扣款类型',
  customer_consume_pos: '客户消费(POS手动调整)',
  coupon_verification_certificate: '券核销凭证',
  handover_petty_cash: '交班备用金',
  target_device: '目标设备',
  choose_device: '选择设备',
  business: '营业',
  mall: '商城',
  sales: '销售',
  member: '会员',
  financial: '财务',
  operation: '运营',
  service_fee_statistics: '服务费统计',
  card_asset: '卡券资产',
  member_operation: '会员运营',
  financial_audit: '财务稽查',
  operating_analysis: '运营分析',
  online_store: '线上店铺',
  product_kits: '菜品套餐',
  other_sales: '其他销售',
  reconciliation: '对账',
  cancel_stock_transfer_with_order_no: '作废库存转仓[{{orderNo}}]',
  product_unit: '菜品单位',
  batch_confirmation_successful: '批量确认收货成功',
  batch_confirmation_fail: '批量确认收货失败',
  batch_confirmation_goods: '批量确认收货',
  submit_qualifications: '提交资质',
  dine_in_ordering_page: '堂食点餐页',
  failed_result: '未通过',
  anti_audit_confirm_is_with_order_no: '反审核后不可恢复，确认反审核单据[{{orderNo}}]？',
  anti_audit_check_order_with_order_no: '反审核库存盘点单[{{orderNo}}]',
  anti_audit_transfer_out_order_with_order_no: '反审核调出单[{{orderNo}}]',
  anti_audit_transfer_in_order_with_order_no: '反审核调入单[{{orderNo}}]',
  anti_audit_return_order_with_order_no: '反审核退货单[{{orderNo}}]',
  restaurant: '餐厅管理',
  anti_audit_purchase_receive_order_with_order_no: '反审核采购收货单[{{orderNo}}]',
  anti_audit_stock_transfer_with_order_no: '反审核库存转仓[{{orderNo}}]',
  anti_audit_adjustment_order_with_order_no: '反审核调整单[{{orderNo}}]',
  batch_delete_location_product: '批量删除门店物品',
  sub_merchant: '子商户',
  set_sub_merchant: '子商户设置',
  all_sub_merchant_group: '所有子商户分组',
  select_sub_merchant: '选择子商户',
  anti_audit_produce_material_order_with_order_no: '反审核生产领料单[{{orderNo}}]',
  anti_audit_location_process_order_with_order_no: '反审核门店加工单[{{orderNo}}]',
  anti_audit_produce_storage_order_with_order_no: '反审核生产入库单[{{orderNo}}]',
  item_corner_label: '物品角标',
  search_item_corner_label_name: '搜索物品角标名称',
  create_item_corner_label: '创建物品角标',
  item_corner_label_name: '物品角标名称',
  item_corner_label_del_tip: '确定要删除角标【{{name}}】，删除后无法恢复',
  del_item_corner_label: '删除物品角标[{{name}}]',
  cannot_be_restored_after_deletion: '删除后无法恢复',
  please_select_item_corner_label: '请选择物品角标',
  corner_label_name: '角标名称',
  please_enter_corner_label_name: '请输入角标名称',
  corner_label_type: '角标类型',
  please_enter_term_of_validity: '请输入有效期',
  corner_label_setting: '角标设置',
  validity_period_of_corner_marker: '角标有效期',
  issued1: '下发',
  cancel_distribution: '取消下发',
  issued_success: '下发成功',
  cancel_distribution_success1: '取消下发成功',
  issued_fail: '下发失败',
  cancel_distribution_fail: '取消下发失败',
  specific_practices: '特定做法',
  ic_card_key_configuration: 'IC卡密钥配置',
  del_shop_cost_card_with_no: '删除商城菜品成本卡[{{id}}]',
  del_cost_card_with_no1: '撤回成本卡[{{id}}]',
  product_delivery_price: '物品配送价',

  copy_product_delivery_price: '复制物品配送价',
  product_delivery_price_copy: '物品配送价复制',
  product_delivery_price_copy_desc:
    '配送价复制功能主要用于将参考门店物品的配送价格直接复制到其他门店使用。',

  read_product_delivery_price: '查看物品配送价',
  import_product_delivery_price: '导入物品配送价',
  export_product_delivery_price: '导出配送价',
  setting_product_delivery_price: '设置配送价',
  batch_delete_product_delivery_price: '批量删除物品配送价',
  edit_product_delivery_price_with_location_name: '编辑物品配送价{{locationName}}',
  product_delivery_price_import: '物品配送价导入',
  product_delivery_price_import_tmpl: '物品配送价导入模板',
  choose_financial_entity: '选择财务主体',
  batch_back_success: '批量退回成功',
  batch_back_fail: '批量退回失败',
};
